    // Cart rendering and display functionality

    const TRY_NOW_PAIR_KEY_PROPERTY = '_trynow_pair_key';
    const TRY_NOW_PAIR_ROLE_PROPERTY = '_trynow_pair_role';
    const TRY_NOW_ROLE_PRIMARY = 'primary';
    const TRY_NOW_ROLE_SUBSCRIPTION = 'subscription';
    const SUBSCRIPTION_PROPERTY_KEY = '_is_subscription_purchase';
    const TRY_NOW_SELLING_PLAN_ID_FALLBACK = window.FDMinicartRenderingConfig.tryNowSellingPlanIdFallback;
    const CROSS_SELL_PLAN_ID_FALLBACK = window.FDMinicartRenderingConfig.crossSellPlanIdFallback;
    const CROSS_SELL_DISCOUNT_RATE = 0.85;
    // GWP-on-subscription rule (Theme settings → First Day MiniCart).
    const ENABLE_GWP_SUBSCRIPTION_RULE = window.FDMinicartRenderingConfig.enableGwpSubscriptionRule;
    const GWP_SUBSCRIPTION_TAG = 'gwp-on-any-subscription';
    let isBFCMPage = window.FDMinicartRenderingConfig.bfcmModeEnabled;
    const MINICART_THEME_GLOBAL_COUPON = window.FDMinicartRenderingConfig.themeGlobalCoupon;
    let bfcmCouponCode = window.FDMinicartRenderingConfig.bfcmCouponCode;
    let bfcmDiscountPercent = window.FDMinicartRenderingConfig.bfcmDiscountPercent;
    let bfcmDiscountMultiplier = (100 - bfcmDiscountPercent) / 100; // Convert % to multiplier

    // PDP override: when a product page publishes its coupon_code / discount_percentage,
    // honor those values in the minicart regardless of theme-level BFCM settings.
    if (typeof window !== 'undefined' && window.__pdpDiscountOverride) {
        const override = window.__pdpDiscountOverride;
        if (typeof override.discountPercent === 'number' && Number.isFinite(override.discountPercent)) {
            bfcmDiscountPercent = override.discountPercent;
            bfcmDiscountMultiplier = (100 - bfcmDiscountPercent) / 100;
            isBFCMPage = true;
        }
        if (override.couponCode) {
            bfcmCouponCode = override.couponCode;
        }
    }

    // Optional subscription-aware override layer.
    // All four variables default to the existing OTP/base values, so PDPs that
    // don't publish the new fields render exactly as before. Step 2 (per-line
    // resolver) consumes these in renderItemPricing.
    let bfcmSubMultiplier = bfcmDiscountMultiplier;
    let bfcmSubCouponCode = bfcmCouponCode;
    let bfcmOtpCouponCode = bfcmCouponCode;
    let bfcmAutoApplyOnSub = false;

    if (typeof window !== 'undefined' && window.__pdpDiscountOverride) {
        const override = window.__pdpDiscountOverride;
        if (typeof override.subDiscountMultiplier === 'number' && Number.isFinite(override.subDiscountMultiplier)) {
            bfcmSubMultiplier = override.subDiscountMultiplier;
        } else if (typeof override.subDiscountPercent === 'number' && Number.isFinite(override.subDiscountPercent)) {
            bfcmSubMultiplier = (100 - override.subDiscountPercent) / 100;
        }
        if (override.couponCode)    bfcmSubCouponCode = override.couponCode;
        if (override.otpCouponCode) bfcmOtpCouponCode = override.otpCouponCode;
        bfcmAutoApplyOnSub = Boolean(override.autoApplyOnSubscription);
    }

    (function applyOfferSessionToMinicart() {
        const offer = window.FDOffer && window.FDOffer.active;
        if (!offer || !offer.replacesGlobal) return;
        if (Number.isFinite(offer.otpPct)) {
            bfcmDiscountPercent = offer.otpPct;
            bfcmDiscountMultiplier = (100 - offer.otpPct) / 100;
            isBFCMPage = true;
        }
        if (Number.isFinite(offer.subPct)) {
            bfcmSubMultiplier = (100 - offer.subPct) / 100;
        }
        if (offer.subCode) {
            bfcmCouponCode = offer.subCode;
            bfcmSubCouponCode = offer.subCode;
        }
        if (offer.otpCode) bfcmOtpCouponCode = offer.otpCode;
    })();

    // Parse a percentage value off line-item properties (numeric or string).
    // Returns null if not a finite number in [0, 100].
    function parsePercentProperty(value) {
        if (value === undefined || value === null || value === '') return null;
        const n = typeof value === 'number' ? value : parseFloat(value);
        if (!Number.isFinite(n) || n < 0 || n > 100) return null;
        return n;
    }

    // Cart line prices are already fully resolved (cart.js + theme discount math).
    // Do NOT tag them with igPrice / data-variant-id / data-price-multiplier —
    // Intelligems rewrites those nodes from catalog experiments and can wipe
    // display to $0.00 while Shopify's item.price stays non-zero (qty steppers
    // still show because they key off item.price, not the DOM).
    function renderIgCompareSpan(_variantId, amountCents) {
        return `<span class="firstday-money compare-at" name="compare-at-price">${Shopify.formatMoney(amountCents, '$--amount--')}</span>`;
    }

    function renderIgPriceSpan(_variantId, amountCents, _multiplier, extraAttrs = '') {
        return `<span class="firstday-money subscription-price" name="sale-price"${extraAttrs}>${Shopify.formatMoney(amountCents, '$--amount--')}</span>`;
    }

    function renderIgSinglePriceSpan(_variantId, amountCents, _label = 'Price') {
        return `<span class="firstday-money" name="sale-price">${Shopify.formatMoney(amountCents, '$--amount--')}</span>`;
    }

    // Read the discount metadata that PBFCM-PDP-controller stamps on each line item:
    // _otp_discount_code, _sub_discount_code, _otp_discount_percentage,
    // _sub_discount_percentage. When absent (older carts, items added outside the
    // PDP flow) we fall back to the page-level __pdpDiscountOverride values so
    // existing carts continue rendering as before.
    //
    // Gated by the cart-drawer section setting `use_line_item_properties` (read via
    // the data-use-line-item-properties attribute on #main-nav). When the toggle is
    // off, this function returns an all-null result, which makes every downstream
    // consumer fall back through resolveLineDiscount to the legacy page-level
    // __pdpDiscountOverride / theme-default chain — i.e. byte-for-byte the old behavior.
    const EMPTY_LINE_PROPERTY_DISCOUNT = {
        hasOtp: false, hasSub: false,
        otpCode: null, subCode: null,
        otpMultiplier: null, subMultiplier: null,
        autoApplyOnSub: false,
    };
    function resolveLinePropertyDiscount(item) {
        const properties = (item && item.properties) || {};
        const otpCode = properties._otp_discount_code || null;
        const subCode = properties._sub_discount_code || null;
        const otpPct  = parsePercentProperty(properties._otp_discount_percentage);
        const subPct  = parsePercentProperty(properties._sub_discount_percentage);
        const hasOwnProps = otpCode !== null || subCode !== null || otpPct !== null || subPct !== null;

        // The cart-drawer toggle gates the *rollout* of per-line discounts, but a
        // line that explicitly carries its own discount properties must always be
        // honored — otherwise a mixed cart (items added from different pages, each
        // with its own code/amount) collapses onto the single page-level override.
        const useLineItemProperties = document.querySelector('#main-nav')?.dataset?.useLineItemProperties === 'true';
        if (!useLineItemProperties && !hasOwnProps) return EMPTY_LINE_PROPERTY_DISCOUNT;

        return {
            hasOtp: otpCode !== null || otpPct !== null,
            hasSub: subCode !== null || subPct !== null,
            otpCode,
            subCode,
            otpMultiplier: otpPct !== null ? (100 - otpPct) / 100 : null,
            subMultiplier: subPct !== null ? (100 - subPct) / 100 : null,
            // "Auto-apply on sub" mode is implied per-line by the OTP and sub codes
            // being distinct. When they match, toggling OTP↔sub keeps the same code,
            // so the upgrade button stays visible.
            autoApplyOnSub: !!(otpCode && subCode && otpCode !== subCode),
        };
    }

    // Per-line discount resolver used by renderItemPricing.
    // Priority: per-line stamped properties → page-level PDP override → theme defaults.
    // Subscription lines + auto-apply → sub multiplier + sub code (e.g. "springtime50")
    // Otherwise (OTP lines, or sub lines without auto-apply) → base multiplier + OTP code (e.g. "refresh")
    function resolveLineDiscount(item) {
        const lineProps = resolveLinePropertyDiscount(item);
        const hasSub   = !!(item && item.selling_plan_allocation);
        const hasOwnProps = lineProps.hasOtp || lineProps.hasSub;
        // A subscription line uses its subscription discount whenever one is
        // stamped on the line. Previously this required the OTP and sub codes to
        // differ (autoApplyOnSub), which silently fell back to the OTP rate when
        // both used the same code (e.g. CODE for OTP and sub). When the line
        // carries no per-line discount props, fall back to the legacy page-level flag.
        const autoApply = hasOwnProps
            ? (lineProps.autoApplyOnSub || lineProps.hasSub)
            : bfcmAutoApplyOnSub;
        const useSub   = hasSub && autoApply;

        // Mixed-cart correctness: when a line carries its own discount properties,
        // resolve it ENTIRELY from those props. Never borrow the page-level
        // __pdpDiscountOverride globals (bfcm*) for a missing field — those reflect
        // only the CURRENT page, so in a cart with items added from different pages
        // they would smear one page's discount across every line. Lines with NO
        // per-line props keep the legacy page-level fallback unchanged.
        const otpMultiplier = lineProps.otpMultiplier !== null
            ? lineProps.otpMultiplier
            : (hasOwnProps ? 1 : bfcmDiscountMultiplier);
        const subMultiplier = lineProps.subMultiplier !== null
            ? lineProps.subMultiplier
            : (hasOwnProps ? 1 : bfcmSubMultiplier);
        const otpCode       = lineProps.otpCode || (hasOwnProps ? (lineProps.subCode || '') : bfcmOtpCouponCode);
        const subCode       = lineProps.subCode || (hasOwnProps ? (lineProps.otpCode || '') : bfcmSubCouponCode);

        const resolved = {
            multiplier: useSub ? subMultiplier : otpMultiplier,
            code:       useSub ? subCode       : otpCode,
            // Per-line discount is "active" when either the line carries explicit
            // discount properties or the page is in BFCM mode. Used by renderItemPricing
            // to decide whether to show the strike + "with CODE applied" UI for this
            // specific line, instead of relying on the global isBFCMPage flag.
            hasLineDiscount: hasOwnProps || isBFCMPage,
            fromLineProperties: hasOwnProps,
            // autoApplyOnSub is read by renderSubscriptionButton's legacy hide path
            // (see the !useLineItemProperties guard there).
            autoApplyOnSub: autoApply,
        };
        return resolved;
    }

    // Prefer Shopify's cart-side allocation when a discount code is already applied
    // to this line (final_line_price < original_line_price). Returns the actual
    // pre/post totals and the real coupon title. Falls back to resolveLineDiscount
    // (multiplier-based) when no allocation is present yet.
    function resolveCartLineDiscount(item) {
        const lineResolved = resolveLineDiscount(item);
        const allocations = (item && item.line_level_discount_allocations) || [];
        const allocation = allocations.find(a => a && a.amount > 0);
        if (allocation
            && Number.isFinite(item.final_line_price)
            && Number.isFinite(item.original_line_price)
            && item.final_line_price < item.original_line_price) {
            const cartResolved = {
                source: 'cart',
                finalLineTotal:    item.final_line_price,
                originalLineTotal: item.original_line_price,
                code: (allocation.discount_application && allocation.discount_application.title)
                      || lineResolved.code,
                hasLineDiscount: true,
                autoApplyOnSub: lineResolved.autoApplyOnSub,
                multiplier: lineResolved.multiplier,
            };
            return cartResolved;
        }
        const overrideResolved = Object.assign({ source: 'override' }, lineResolved);
        return overrideResolved;
    }

    let tryNowLinkedKeys = {};
    let crossSellLinkedKeys = {};
    let latestCartState = null;
    // Render ordering: a cart older than one accepted never paints; only the newest render commits.
    let committedCart = null;
    let acceptedCartVersion = -1;
    let cartRenderGeneration = 0;
    let committedGeneration = 0;
    let pendingCrossSellRemoval = null;
    let crossSellModalInitialized = false;
    const addOnPricingCache = new Map();

    // Product tag cache for hasTNProductTag optimization
    const productTagCache = new Map();
    const parentPdpImageCache = new Map();
    const PRODUCT_CACHE_TTL = 5 * 60 * 1000; // 5 minutes
    const productTagJsonInflight = new Map();
    const productTagJsonCache = new Map();

    // Resolves the product JSON, null for a non-OK response (cached as "no tag"),
    // or undefined on a network error (not cached). One request per product per page.
    function fetchProductTagJson(productHandle) {
        const cached = productTagJsonCache.get(productHandle);
        if (cached && cached.expires > Date.now()) {
            return Promise.resolve(cached.value);
        }
        if (productTagJsonInflight.has(productHandle)) {
            return productTagJsonInflight.get(productHandle);
        }
        const pending = fetch(`/products/${productHandle}.js`)
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (product) {
                productTagJsonCache.set(productHandle, { value: product, expires: Date.now() + PRODUCT_CACHE_TTL });
                rememberProductTags(product);
                return product;
            })
            .catch(function (error) {
                console.error('Error checking product tags:', error);
                return undefined;
            })
            .finally(function () { productTagJsonInflight.delete(productHandle); });
        productTagJsonInflight.set(productHandle, pending);
        return pending;
    }

    function rememberProductTags(product) {
        if (!product || !product.handle || !Array.isArray(product.tags)) return;
        window.PBFCM_PRODUCT_DATA = window.PBFCM_PRODUCT_DATA || {};
        if (window.PBFCM_PRODUCT_DATA[product.handle]) return;
        window.PBFCM_PRODUCT_DATA[product.handle] = {
            id: product.id,
            handle: product.handle,
            tags: product.tags,
            hasTNProduct: product.tags.includes('TNProduct')
        };
    }

    function safeString(value) {
        if (value === undefined || value === null) {
            return '';
        }
        return String(value);
    }

    // Identify gift line items by Shopify product_type. Gifts shouldn't show
    // strike pricing, the "with CODE applied" banner, or the Subscribe & Save
    // button — they're free items, not promotional purchases of a sellable SKU.
    function isCheckoutGwpLine(item) {
        const props = item && item.properties ? item.properties : {};
        return props._upsell_module === 'checkout_gwp';
    }

    function isHiddenFromCartCount(item) {
        if (isCheckoutGwpLine(item)) return true;
        return safeString(item && item.product_type).toLowerCase() === 'gift';
    }

    function visibleCartCount(cart) {
        const items = (cart && cart.items) || [];
        const hidden = items.reduce((sum, item) => (
            isHiddenFromCartCount(item) ? sum + (Number(item.quantity) || 0) : sum
        ), 0);
        const raw = cart && typeof cart.item_count === 'number' ? cart.item_count : items.length;
        return Math.max(0, raw - hidden);
    }

    function isGiftItem(item) {
        if (safeString(item && item.product_type).toLowerCase() === 'gift') {
            return true;
        }
        const props = item && item.properties ? item.properties : {};
        if (props._bundle_gift === 'true' || props._bundle_gift === true) {
            return true;
        }
        return props._upsell_module === 'checkout_gwp';
    }

    // Alternate PDP quantity gifts are intentionally handled separately from the
    // store's existing gift/GWP rules. They may carry quantity > 1, so do not fold
    // them into legacy gift classification that other pages may use for one-per-gift
    // behavior. We still hide shopper quantity/remove controls and manage them via
    // their parent-product linkage.
    function isQuantityWelcomeGiftItem(item) {
        const props = item && item.properties ? item.properties : {};
        return normalizeBoolean(props._quantity_welcome_gift);
    }

    function getBundleId(item) {
        const props = item && item.properties ? item.properties : {};
        return safeString(props._bundle);
    }

    function isBundleGiftItem(item) {
        const props = item && item.properties ? item.properties : {};
        return Boolean(getBundleId(item)) && (props._bundle_gift === 'true' || props._bundle_gift === true);
    }

    function parentHandleFromPagePath(path) {
        const match = safeString(path).match(/\/products\/([^/?#]+)/i);
        return match ? decodeURIComponent(match[1]) : '';
    }

    function featuredImageFromProductJson(product) {
        if (!product) return '';
        if (product.featured_image) return product.featured_image;
        if (Array.isArray(product.images) && product.images[0]) {
            return product.images[0].src || product.images[0];
        }
        return '';
    }

    async function fetchProductJsonByHandle(handle) {
        const normalizedHandle = safeString(handle).trim();
        if (!normalizedHandle) return null;

        const product = await fetchProductTagJson(encodeURIComponent(normalizedHandle));
        return product || null;
    }

    async function ensureParentPdpImages(cart) {
        const items = (cart && cart.items) || [];
        const handlesToFetch = new Set();

        items.forEach(function (item) {
            const props = (item && item.properties) || {};
            const parentId = safeString(props._parent_pdp).trim();
            if (!parentId) return;

            const cacheKey = 'parent-pdp-img:' + parentId;
            if (parentPdpImageCache.has(cacheKey) && parentPdpImageCache.get(cacheKey)) return;

            const byId = window.__productFeaturedImagesById || {};
            if (byId[parentId]) {
                parentPdpImageCache.set(cacheKey, sizeShopifyImage(byId[parentId], 184));
                return;
            }

            const handle = safeString(props._parent_pdp_handle).trim()
                || parentHandleFromPagePath(props._page_path);
            if (handle) handlesToFetch.add(handle);
        });

        if (!handlesToFetch.size) return;

        await Promise.all(Array.from(handlesToFetch).map(async function (handle) {
            const byHandle = window.__productFeaturedImagesByHandle || {};
            if (byHandle[handle]) return;

            const product = await fetchProductJsonByHandle(handle);
            const url = featuredImageFromProductJson(product);
            if (!url || !product) return;

            window.__productFeaturedImagesById = window.__productFeaturedImagesById || {};
            window.__productFeaturedImagesByHandle = window.__productFeaturedImagesByHandle || {};
            window.__productFeaturedImagesById[String(product.id)] = url;
            window.__productFeaturedImagesByHandle[product.handle || handle] = url;

            items.forEach(function (item) {
                const props = (item && item.properties) || {};
                if (safeString(props._parent_pdp).trim() === String(product.id)) {
                    parentPdpImageCache.set('parent-pdp-img:' + product.id, sizeShopifyImage(url, 184));
                }
            });
        }));
    }

    function bundleDisplayTitle(item) {
        const props = (item && item.properties) || {};
        return safeString(props.Title) || safeString(props._bundle_title);
    }

    function buildBundleGroups(cart) {
        const items = (cart && cart.items) || [];
        const groups = new Map();
        const order = [];

        items.forEach((item, index) => {
            const bundleId = getBundleId(item);
            if (!bundleId) {
                const props = item.properties || {};
                if (props._upsell_module === 'checkout_gwp') return;
                order.push({ type: 'single', index: index });
                return;
            }
            const props = item.properties || {};
            const displayTitle = bundleDisplayTitle(item);
            if (!groups.has(bundleId)) {
                groups.set(bundleId, {
                    id: bundleId,
                    products: [],
                    gifts: [],
                    title: displayTitle || 'Your Box',
                    parentPdp: safeString(props._parent_pdp),
                    parentPdpHandle: safeString(props._parent_pdp_handle),
                    firstIndex: index
                });
                order.push({ type: 'bundle', id: bundleId });
            }
            const group = groups.get(bundleId);
            if (props.Title) {
                group.title = safeString(props.Title);
            } else if ((!group.title || group.title === 'Your Box') && props._bundle_title) {
                group.title = safeString(props._bundle_title);
            }
            if (!group.parentPdp && (item.properties || {})._parent_pdp) {
                group.parentPdp = safeString(item.properties._parent_pdp);
            }
            if (!group.parentPdpHandle && (item.properties || {})._parent_pdp_handle) {
                group.parentPdpHandle = safeString(item.properties._parent_pdp_handle);
            }
            if (!group.parentPdpHandle && (item.properties || {})._page_path) {
                const handleFromPath = parentHandleFromPagePath(item.properties._page_path);
                if (handleFromPath) group.parentPdpHandle = handleFromPath;
            }
            if (isBundleGiftItem(item)) {
                group.gifts.push(item);
            } else {
                group.products.push(item);
            }
        });

        return { groups: groups, order: order };
    }

    function getBuildBoxLineTotals(item) {
        const quantity = item.quantity || 1;
        const price = item.price || 0;
        const originalPrice = item.original_price || price;
        const hasSubscription = item.selling_plan_allocation !== undefined;
        const lineDiscount = resolveCartLineDiscount(item);
        const quizNetPrice = isQuizBuyBoxItem(item);

        // Quiz packs skip the theme % multiplier below. Their display price is
        // already the net subscription price. Shopify allocations (BUNDLEBUILDER,
        // bulk volume, etc.) are the price checkout charges, so use those.
        if (lineDiscount.source === 'cart') {
            return {
                sale: lineDiscount.finalLineTotal,
                compare: lineDiscount.originalLineTotal,
                code: lineDiscount.code,
                hasDiscount: true
            };
        }

        if (hasSubscription) {
            const allocation = item.selling_plan_allocation || {};
            const unit = allocation.price !== undefined ? allocation.price : price;
            const compareUnit = allocation.compare_at_price !== undefined
                ? allocation.compare_at_price
                : originalPrice;
            let sale = unit * quantity;
            if (!quizNetPrice && lineDiscount.hasLineDiscount && Number.isFinite(lineDiscount.multiplier)) {
                sale = discountedLineTotal(unit, quantity, lineDiscount);
            }
            const strikeUnit = Math.max(compareUnit || 0, originalPrice || 0);
            return {
                sale: sale,
                compare: strikeUnit * quantity,
                code: lineDiscount.code,
                hasDiscount: !!lineDiscount.hasLineDiscount || strikeUnit * quantity > sale
            };
        }

        const sale = !quizNetPrice && lineDiscount.hasLineDiscount && Number.isFinite(lineDiscount.multiplier)
            ? discountedLineTotal(price, quantity, lineDiscount)
            : price * quantity;
        return {
            sale: sale,
            compare: (originalPrice || price) * quantity,
            code: lineDiscount.code,
            hasDiscount: !!lineDiscount.hasLineDiscount
        };
    }

    function sizeShopifyImage(url, width) {
        if (!url) return '';
        const sep = String(url).includes('?') ? '&' : '?';
        return String(url) + sep + 'width=' + width;
    }

    function resolveParentPdpImage(parentPdpId, parentHandle) {
        const normalizedId = safeString(parentPdpId).trim();
        if (!normalizedId) return '';

        const cacheKey = 'parent-pdp-img:' + normalizedId;
        if (parentPdpImageCache.has(cacheKey)) {
            return parentPdpImageCache.get(cacheKey);
        }

        const byId = window.__productFeaturedImagesById || {};
        let url = byId[normalizedId] || '';

        if (!url) {
            const handle = safeString(parentHandle).trim();
            const byHandle = window.__productFeaturedImagesByHandle || {};
            if (handle && byHandle[handle]) {
                url = byHandle[handle];
            }
        }

        if (!url) {
            const catalog = window.__parentPdpCatalog || {};
            const catalogEntry = catalog[normalizedId];
            if (catalogEntry && catalogEntry.featuredImage) {
                url = catalogEntry.featuredImage;
            }
        }

        const sized = url ? sizeShopifyImage(url, 184) : '';
        parentPdpImageCache.set(cacheKey, sized);
        return sized;
    }

    function quizImageFromItem(item) {
        const props = (item && item.properties) || {};
        const fromProp = safeString(props._quiz_image);
        if (fromProp) return fromProp;
        const byId = window.__quizBundleImagesById || {};
        return safeString(byId[String(item && item.product_id)]);
    }

    function isQuizBuyBoxItem(item) {
        const props = (item && item.properties) || {};
        return props._upsell_module === 'quiz_buy_box';
    }

    function isQuizBuyBoxBundle(group) {
        return ((group && group.products) || []).some(function (item) {
            const props = (item && item.properties) || {};
            return (
                props._upsell_module === 'quiz_buy_box' ||
                Boolean(quizImageFromItem(item))
            );
        });
    }

    function renderQuizBundleShot(products) {
        const urls = (products || [])
            .map(function (item) {
                return quizImageFromItem(item);
            })
            .filter(Boolean);
        if (!urls.length) return '';
        return urls
            .map(function (url) {
                return (
                    '<span class="firstday-cart__bundle-shot-item">' +
                    '<img src="' +
                    escapeHtmlAttr(sizeShopifyImage(url, 96)) +
                    '" alt="" width="28" height="80" loading="lazy">' +
                    '</span>'
                );
            })
            .join('');
    }

    async function renderBuildBoxBundle(group) {
        const products = group.products || [];
        const gifts = group.gifts || [];
        const allItems = products.concat(gifts);
        if (!allItems.length) return '';

        const primary = products[0] || gifts[0];
        const title = escapeHtmlAttr(group.title || 'Your Box');
        const nav = document.getElementById('main-nav');
        const settingImage = nav && nav.getAttribute('data-build-box-cart-image');
        const quizShotHtml = isQuizBuyBoxBundle(group) ? renderQuizBundleShot(products) : '';
        let image = '';
        if (!quizShotHtml) {
            if (group.parentPdp) {
                image = resolveParentPdpImage(group.parentPdp, group.parentPdpHandle);
            } else {
                image = settingImage || (primary && primary.image ? `${primary.image}&width=184` : '');
            }
        }

        let saleTotal = 0;
        let compareTotal = 0;
        products.forEach(function (item) {
            const totals = getBuildBoxLineTotals(item);
            saleTotal += Number(totals.sale) || 0;
            compareTotal += Number(totals.compare) || 0;
        });
        saleTotal = Math.round(saleTotal);
        compareTotal = Math.round(compareTotal);
        const showCompare = compareTotal > saleTotal;

        const keys = allItems.map(function (item) { return item.key; });
        const keysJsonAttr = escapeHtmlAttr(JSON.stringify(keys));
        const removeIcon = typeof UI_ICONS !== 'undefined' ? UI_ICONS.remove : 'Remove';

        const preorderTexts = await Promise.all(products.map(function (item) {
            return fetchPreorderText(item.product_id);
        }));
        const contentsHtml = products.map(function (item, index) {
            const qty = Number(item.quantity) || 1;
            const name = item.product_title || item.title || '';
            const preorder = preorderTexts[index];
            return escapeHtmlAttr(qty + 'x ' + name)
                + (preorder ? `<br><span class="firstday-cart__bundle-preorder">${escapeHtmlAttr(preorder)}</span>` : '');
        }).join('<br>');

        const mediaClass = 'firstday-cart__bundle-media' + (quizShotHtml ? ' is-quiz-shot' : '');
        const mediaHtml = quizShotHtml
            ? quizShotHtml
            : (image ? `<img src="${escapeHtmlAttr(image)}" alt="${title}" width="92" height="92" loading="lazy">` : '');

        return `
        <article class="firstday-cart__bundle firstday-cart__flyout-item is-build-box-bundle"
                 data-bundle-id="${escapeHtmlAttr(group.id)}"
                 data-bundle-keys="${keysJsonAttr}"
                 role="listitem"
                 aria-label="Bundle: ${title}">
            <div class="firstday-cart__bundle-head">
                <div class="${mediaClass}">
                    ${mediaHtml}
                </div>
                <div class="firstday-cart__bundle-body">
                    <div class="firstday-cart__bundle-top">
                        <div class="firstday-cart__bundle-copy">
                            <p class="firstday-cart__bundle-title">${title}</p>
                            ${contentsHtml ? `<p class="firstday-cart__bundle-contents">${contentsHtml}</p>` : ''}
                        </div>
                        <button type="button"
                                class="firstday-cart__bundle-remove"
                                aria-label="Remove ${title} from cart"
                                onclick="removeBuildBoxBundle(JSON.parse(this.closest('[data-bundle-keys]').getAttribute('data-bundle-keys')||'[]'))">
                            <span aria-hidden="true">${removeIcon}</span>
                        </button>
                    </div>
                    <div class="firstday-cart__bundle-price firstday-cart__flyout-item-price"
                         role="group"
                         aria-label="Box price">
                        ${showCompare ? renderIgCompareSpan(primary && primary.variant_id, compareTotal) : ''}
                        ${renderIgPriceSpan(primary && primary.variant_id, saleTotal, null)}
                    </div>
                </div>
            </div>
        </article>
        `;
    }

    async function removeBuildBoxBundle(keys) {
        const list = Array.isArray(keys) ? keys : [];
        if (!list.length) return;
        const updates = {};
        list.forEach(function (key) {
            if (key) updates[tappedLineKey(safeString(key))] = 0;
        });
        const container = document.getElementById('mini_cart_form');
        const hidden = container
            ? Array.from(container.children).filter(function (el) {
                const bundleKeys = safeString(el.getAttribute('data-bundle-keys'));
                return list.indexOf(el.getAttribute('data-remove-key')) !== -1 ||
                    list.some(function (key) { return key && bundleKeys.indexOf(JSON.stringify(key)) !== -1; });
            })
            : [];
        hidden.forEach(markLineRemoving);
        beginCartWrite();
        try {
            await trackDrawerAction(applyBulkCartUpdates(updates));
            finishCartWrite();
        } catch (error) {
            console.error('Mini cart: unable to remove bundle', error);
            endCartWrite();
            await rollbackDrawer(null);
        }
    }
    window.removeBuildBoxBundle = removeBuildBoxBundle;

    const TRY_NOW_SELLING_PLAN_ID = safeString(
        (typeof window !== 'undefined' &&
            window.MINICART_CONFIG &&
            window.MINICART_CONFIG.TRYNOW_SELLING_PLAN_ID) ||
            TRY_NOW_SELLING_PLAN_ID_FALLBACK
    );

    const CROSS_SELL_PLAN_ID = safeString(
        (typeof window !== 'undefined' &&
            window.MINICART_CONFIG &&
            window.MINICART_CONFIG.CROSS_SELL_PLAN_ID) ||
            CROSS_SELL_PLAN_ID_FALLBACK
    );

    function escapeForSingleQuote(value) {
        if (value === undefined || value === null) {
            return '';
        }
        return String(value)
            .replace(/\\/g, "\\\\")
            .replace(/'/g, "\\'")
            .replace(/\r/g, "\\r")
            .replace(/\n/g, "\\n");
    }

    function escapeHtmlAttr(value) {
        if (value === undefined || value === null) {
            return '';
        }

        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    function parsePriceCents(value) {
        if (value === undefined || value === null || value === '') {
            return null;
        }

        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) ? parsed : null;
    }

    function convertMoneyValueToCents(value) {
        if (value === undefined || value === null || value === '') {
            return null;
        }

        if (typeof value === 'number') {
            return Math.round(value * 100);
        }

        const normalized = String(value).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
        if (!normalized) {
            return null;
        }

        const floatValue = parseFloat(normalized);
        if (Number.isNaN(floatValue)) {
            return null;
        }

        return Math.round(floatValue * 100);
    }

    function normalizeBoolean(value) {
        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            return normalized === 'true' || normalized === '1' || normalized === 'yes';
        }
        return Boolean(value);
    }

    function isPlanUpgradeFlagPresent(value) {
        if (value === undefined || value === null || value === '') return false;
        const normalized = String(value).trim().toLowerCase();
        return normalized !== 'false' && normalized !== '0' && normalized !== 'no';
    }

    function getLineSellingPlanId(item) {
        if (!item) return '';
        const allocationPlan = item.selling_plan_allocation &&
            item.selling_plan_allocation.selling_plan &&
            item.selling_plan_allocation.selling_plan.id;
        return safeString(item.selling_plan || allocationPlan).trim();
    }

    function getLineSellingPlanName(item) {
        if (!item) return '';
        const fromAllocation = item.selling_plan_allocation &&
            item.selling_plan_allocation.selling_plan &&
            item.selling_plan_allocation.selling_plan.name;
        return safeString(item.selling_plan_name || fromAllocation);
    }

    function isQuarterlySellingPlan(item) {
        return /90|quarter/i.test(getLineSellingPlanName(item));
    }

    // Native 90-day ATC stamps _qtyPerChange=3. Infer it from the plan if missing
    // so cart +/- cannot land on 4, 5, 10, etc.
    function getLineQtyStep(item) {
        const stamped = parseInt(item && item.properties && item.properties._qtyPerChange, 10);
        if (Number.isFinite(stamped) && stamped > 1) return stamped;
        if (isQuarterlySellingPlan(item)) return 3;
        return 1;
    }

    function nextSteppedQty(current, step, direction) {
        const qty = Number(current);
        if (!Number.isFinite(qty) || step <= 1) {
            return Math.max((qty || 0) + direction, 0);
        }
        if (qty % step === 0) {
            if (direction < 0) return Math.max(qty - step, step);
            return qty + step;
        }
        if (direction < 0) return Math.max(Math.floor(qty / step) * step, step);
        return Math.ceil(qty / step) * step;
    }

    function getPlanUpgradeControlMode(item) {
        const properties = (item && item.properties) || {};
        if (!isPlanUpgradeFlagPresent(properties._plan_upgrade)) return '';
        const currentPlanId = getLineSellingPlanId(item);
        if (!currentPlanId) return '';
        if (properties._plan_switcher_from) return 'undo';
        if (isQuarterlySellingPlan(item)) return '';
        const planName = getLineSellingPlanName(item);
        if (/60|bimonth|bi-month|every 2/i.test(planName)) return '';
        const upgradeTo = safeString(properties._plan_upgrade_to).trim();
        if (upgradeTo && currentPlanId === upgradeTo) return '';
        return 'upgrade';
    }

    function getPlanUpgradeSavingsPercent(item) {
        const raw = item && item.properties && item.properties._plan_upgrade_savings;
        const parsed = parseInt(raw, 10);
        if (Number.isFinite(parsed) && parsed > 0 && parsed < 100) return parsed;
        return 20;
    }

    const PLAN_UPGRADE_LABEL_DEFAULT = 'Get +{savings}% OFF With a 90-Day Supply';

    function getPlanUpgradeLabelTemplate() {
        const nav = document.getElementById('main-nav');
        const trimmed = String((nav && nav.dataset && nav.dataset.planUpgradeLabel) || '').trim();
        return trimmed || PLAN_UPGRADE_LABEL_DEFAULT;
    }

    function formatPlanUpgradeLabel(savings) {
        const pct = String(savings);
        return getPlanUpgradeLabelTemplate()
            .replace(/\{\{\s*savings\s*\}\}/gi, pct)
            .replace(/\{savings\}/gi, pct);
    }

    function renderPlanUpgradeControl(item) {
        const mode = getPlanUpgradeControlMode(item);
        if (mode !== 'upgrade') return '';
        const safeKeyForJs = escapeForSingleQuote(item.key);
        const productTitleAttr = escapeHtmlAttr(item.product_title || item.title || '');
        const savings = getPlanUpgradeSavingsPercent(item);
        const copyAttr = escapeHtmlAttr(formatPlanUpgradeLabel(savings));
        return `
        <div class="firstday-cart__plan-upgrade">
            <button type="button"
                    class="firstday-cart__plan-upgrade-link"
                    aria-label="${copyAttr}. ${productTitleAttr}"
                    onclick="changePlanUpgrade('${safeKeyForJs}', 'upgrade')">
                <span class="firstday-cart__plan-upgrade-copy">${copyAttr}</span>
            </button>
        </div>`;
    }

    // ---- 90-day upgrade card: one switch moves every 30-day subscription line to 90-day and back (docs/cart/CART.md).
    const NINETY_DAY_CARD_ON = 'fd-cart-90day-on';
    const NINETY_DAY_CARD_OFF = 'fd-cart-90day-off';
    const NINETY_DAY_CARD_QUERY = 'fd_cart_90day';
    const NINETY_DAY_CARD_SKIPPED_MODULES = ['build_box', 'quiz_buy_box', 'checkout_gwp'];
    const NINETY_DAY_CARD_SKIPPED_PROPS = ['_bundle_gift', '_box_picker_gift', '_welcome_kit_gift', '_quantity_welcome_gift', '_free_gift', '_free_unlock', '_add_on', '_is_cross_sell'];
    let ninetyDayCardBusy = false;
    let ninetyDayCardPaint = 0;
    let ninetyDayCardLastGift = null;

    (function applyNinetyDayCardQuery() {
        try {
            const value = new URLSearchParams(window.location.search).get(NINETY_DAY_CARD_QUERY);
            if (value === '1' || value === '0') sessionStorage.setItem(NINETY_DAY_CARD_QUERY, value);
            const stored = sessionStorage.getItem(NINETY_DAY_CARD_QUERY);
            if (stored === '1') document.documentElement.classList.add(NINETY_DAY_CARD_ON);
            if (stored === '0') document.documentElement.classList.add(NINETY_DAY_CARD_OFF);
        } catch (error) {
            return;
        }
    })();

    function rootHasClass(name) {
        return document.documentElement.classList.contains(name) ||
            Boolean(document.body && document.body.classList.contains(name));
    }

    function ninetyDayCardElement() {
        return document.getElementById('fd-cart-90day');
    }

    function ninetyDayCardEnabled(card) {
        if (!card || rootHasClass(NINETY_DAY_CARD_OFF)) return false;
        return rootHasClass(NINETY_DAY_CARD_ON) || card.dataset.enabled === 'true';
    }

    function parseUpgradePercent(raw) {
        const parsed = parseInt(raw, 10);
        return Number.isFinite(parsed) && parsed > 0 && parsed < 100 ? parsed : null;
    }

    function isMonthlySellingPlanName(name) {
        const text = safeString(name);
        return /month|30/i.test(text) && !/90|quarter|60|bimonth|bi-month|every 2|try|[2-9]\s*months?|three|six/i.test(text);
    }

    function looksLikeAddOnLine(item) {
        const props = item.properties || {};
        return [item.handle, item.product_title, item.title, item.url, props._parent_pdp_handle]
            .join(' ').toLowerCase().indexOf('add-on') !== -1;
    }

    // A paid 30-day subscription line the shopper chose: not a gift, add-on, cross-sell, box or try-now line.
    function isNinetyDayCardCandidate(item) {
        if (!item || !item.key || !(Number(item.quantity) > 0) || !(Number(item.original_line_price) > 0)) return false;
        const props = item.properties || {};
        if (NINETY_DAY_CARD_SKIPPED_PROPS.some(function (key) { return normalizeBoolean(props[key]); })) return false;
        if (NINETY_DAY_CARD_SKIPPED_MODULES.indexOf(safeString(props._upsell_module).toLowerCase()) !== -1) return false;
        if (safeString(props._bundle) || safeString(props[TRY_NOW_PAIR_KEY_PROPERTY]) || looksLikeAddOnLine(item)) return false;
        const planId = getLineSellingPlanId(item);
        if (!planId || planId === TRY_NOW_SELLING_PLAN_ID || planId === CROSS_SELL_PLAN_ID) return false;
        return isMonthlySellingPlanName(getLineSellingPlanName(item));
    }

    function isNinetyDayCardUpgradedLine(item) {
        const props = (item && item.properties) || {};
        return safeString(props._plan_switcher_from).trim() !== '' &&
            safeString(props._plan_upgrade_source) === 'cart' &&
            safeString(props._plan_upgrade_from_qty).trim() !== '';
    }

    // The funnel's stamped 90-day %, else the active offer's 90-day % when the line carries the offer's 90-day code.
    function ninetyDayTargetPercent(item) {
        const props = item.properties || {};
        const stamped = parseUpgradePercent(props._plan_upgrade_discount_percentage);
        if (stamped) return stamped;
        const offer = window.FDOffer && window.FDOffer.active;
        const percent = offer ? parseUpgradePercent(offer.ninetyDayPct) : null;
        const offerCode = offer ? normalizeDiscountCodeKey(offer.ninetyDayCode) : '';
        if (!percent || !offerCode || normalizeDiscountCodeKey(props._sub_discount_code) !== offerCode) return null;
        return percent;
    }

    // A plan of the line's own selling plan group (planId, else its 90-day plan) with the variant's price on it.
    async function sellingPlanInLineGroup(item, planId) {
        const product = await fetchProductJsonByHandle(item.handle);
        if (!product) return null;
        const currentPlanId = getLineSellingPlanId(item);
        const group = (product.selling_plan_groups || []).find(function (entry) {
            return (entry.selling_plans || []).some(function (plan) { return safeString(plan.id) === currentPlanId; });
        });
        if (!group) return null;
        const stampedTo = safeString(item.properties && item.properties._plan_upgrade_to).trim();
        const plans = group.selling_plans || [];
        const plan = planId
            ? plans.find(function (entry) { return safeString(entry.id) === planId; })
            : plans.find(function (entry) { return stampedTo && safeString(entry.id) === stampedTo; }) ||
                plans.find(function (entry) { return /90|quarter/i.test(safeString(entry.name)); });
        if (!plan) return null;
        const variant = (product.variants || []).find(function (entry) { return safeString(entry.id) === safeString(item.variant_id); });
        const allocation = variant && (variant.selling_plan_allocations || []).find(function (entry) {
            return safeString(entry.selling_plan_id) === safeString(plan.id);
        });
        if (!allocation || !Number.isFinite(Number(allocation.price))) return null;
        return {
            id: safeString(plan.id),
            name: safeString(plan.name),
            unitPrice: Number(allocation.price),
            compareAtPrice: Number(allocation.compare_at_price) || Number(allocation.price)
        };
    }

    // The line's code takes floor(unit price x its %) off each unit at checkout.
    function percentLinePrice(unitPrice, quantity, percent) {
        return quantity * (unitPrice - Math.floor(unitPrice * percent / 100));
    }

    // Line-property codes (Regios) take floor(unit x %) off each unit; page-level codes keep line x %.
    function discountedLineTotal(unitPrice, quantity, lineDiscount) {
        if (!lineDiscount.fromLineProperties) return unitPrice * quantity * lineDiscount.multiplier;
        const basisPoints = Math.round((1 - lineDiscount.multiplier) * 10000);
        return quantity * (unitPrice - Math.floor(unitPrice * basisPoints / 10000));
    }

    // exact is false when the cart already prices the line some other way; then no amount is shown.
    function percentLineQuote(item, percent) {
        const price = percentLinePrice(Number(item.price), Number(item.quantity), percent);
        const discounted = Number(item.final_line_price) < Number(item.original_line_price);
        return { price: price, exact: !discounted || Number(item.final_line_price) === price };
    }

    // The lines the switch would move (lines) or move back (upgradedLines), with prices now and after.
    async function ninetyDayCardPlan(cart) {
        const items = (cart && Array.isArray(cart.items)) ? cart.items : [];
        const lines = (await Promise.all(items.filter(isNinetyDayCardCandidate).map(async function (item) {
            const percent = ninetyDayTargetPercent(item);
            const currentPercent = parseUpgradePercent(item.properties && item.properties._sub_discount_percentage) || 0;
            if (!percent || percent <= currentPercent) return null;
            const plan = await sellingPlanInLineGroup(item).catch(function () { return null; });
            if (!plan) return null;
            const toQuantity = Number(item.quantity) * 3;
            const now = percentLineQuote(item, currentPercent);
            return {
                item: item,
                plan: plan,
                percent: percent,
                toQuantity: toQuantity,
                exact: now.exact,
                nowAtUpgradeQty: now.price * 3,
                upgraded: percentLinePrice(plan.unitPrice, toQuantity, percent)
            };
        }))).filter(Boolean);
        const upgradedLines = (await Promise.all(items.filter(isNinetyDayCardUpgradedLine).map(async function (item) {
            const props = item.properties || {};
            const percent = parseUpgradePercent(props._sub_discount_percentage);
            const fromPercent = parseUpgradePercent(props._plan_upgrade_from_percentage) || 0;
            const monthly = await sellingPlanInLineGroup(item, safeString(props._plan_switcher_from).trim()).catch(function () { return null; });
            const now = percentLineQuote(item, percent || 0);
            return {
                item: item,
                percent: percent,
                exact: Boolean(monthly) && now.exact,
                nowAtUpgradeQty: monthly ? percentLinePrice(monthly.unitPrice, Number(item.quantity), fromPercent) : 0,
                upgraded: now.price
            };
        }))).filter(function (line) { return line.percent; });
        return { lines: lines, upgradedLines: upgradedLines };
    }

    // The cart as it would be after the switch, for the gift rules.
    function ninetyDayPredictedCart(cart, lines) {
        const byKey = new Map(lines.map(function (line) { return [line.item.key, line]; }));
        const items = cart.items.map(function (item) {
            const line = byKey.get(item.key);
            if (!line) return item;
            const original = line.plan.unitPrice * line.toQuantity;
            const allocation = Object.assign({}, item.selling_plan_allocation, {
                price: line.plan.unitPrice,
                compare_at_price: line.plan.compareAtPrice,
                per_delivery_price: line.plan.unitPrice,
                selling_plan: Object.assign({}, item.selling_plan_allocation && item.selling_plan_allocation.selling_plan, { id: Number(line.plan.id), name: line.plan.name })
            });
            return Object.assign({}, item, {
                quantity: line.toQuantity,
                properties: Object.assign({}, item.properties, { _sub_discount_percentage: String(line.percent) }),
                selling_plan_allocation: allocation,
                price: line.plan.unitPrice,
                original_price: line.plan.unitPrice,
                line_price: original,
                original_line_price: original,
                final_line_price: line.upgraded,
                final_price: Math.round(line.upgraded / line.toQuantity)
            });
        });
        const delta = lines.reduce(function (sum, line) { return sum + line.upgraded - Number(line.item.final_line_price); }, 0);
        return Object.assign({}, cart, {
            items: items,
            item_count: items.reduce(function (sum, item) { return sum + (Number(item.quantity) || 0); }, 0),
            total_price: Number(cart.total_price) + delta,
            items_subtotal_price: Number(cart.items_subtotal_price) + delta
        });
    }

    // A gift the cart earns only after the switch, per the gift rules.
    function ninetyDayCardGift(cart, lines) {
        const now = plannedGiftAdds(cart).map(function (gift) { return safeString(gift.variantId).split('/').pop(); });
        const after = plannedGiftAdds(ninetyDayPredictedCart(cart, lines));
        return after.find(function (gift) { return now.indexOf(safeString(gift.variantId).split('/').pop()) === -1; }) || null;
    }

    // The value the gift progress bar promises for this gift, in cents.
    function giftTierValueFor(variantId) {
        const progress = window.PBFCM_Minicart && window.PBFCM_Minicart.giftProgress;
        let value = null;
        ((progress && progress.instances) || []).some(function (inst) {
            const tier = (inst.abTiers || []).find(function (entry) {
                return entry && safeString(entry.giftVariant).split('/').pop() === variantId;
            });
            if (tier && Number(tier.giftValue) > 0) value = Math.round(Number(tier.giftValue) * 100);
            return value !== null;
        });
        return value;
    }

    async function ninetyDayGiftDetails(gift) {
        const variantId = safeString(gift.variantId).split('/').pop();
        const card = giftCardFor(variantId);
        let title = card && card.title;
        let image = card && card.imageUrl;
        let value = giftTierValueFor(variantId);
        if (window.Storefront && typeof window.Storefront.giftVariantsByIds === 'function') {
            const details = (await window.Storefront.giftVariantsByIds([variantId]).catch(function () { return []; }))[0];
            if (details) {
                title = title || details.productTitle;
                image = image || details.image;
                if (value === null) value = details.compareAtCents;
            }
        }
        if (!title || !image) return null;
        return { variantId: variantId, title: title, image: image, value: value };
    }

    function fillCardCopy(template, values) {
        return escapeHtmlAttr(template).replace(/\{(\w+)\}(%?)/g, function (token, key, sign) {
            if (!Object.prototype.hasOwnProperty.call(values, key)) return token;
            return typeof values[key] === 'function' ? values[key](sign) : values[key] + sign;
        });
    }

    function ninetyDayCardHtml(card, state) {
        const data = card.dataset;
        const percent = String(state.percent);
        const giftValue = state.gift && state.gift.value
            ? ` <s>${Shopify.formatMoney(state.gift.value, '$--amount--').replace(/\.00$/, '')}</s>`
            : '';
        const giftHtml = state.gift ? `
            <div class="fd-cart-90day__gift">
                <div class="fd-cart-90day__gift-media">
                    <img class="fd-cart-90day__gift-info" src="${escapeHtmlAttr(data.infoIcon)}" alt="" width="16" height="16" aria-hidden="true">
                    <img class="fd-cart-90day__gift-image" src="${escapeHtmlAttr(sizeShopifyImage(state.gift.image, 168))}" alt="${escapeHtmlAttr(state.gift.title)}" width="77" height="56" loading="lazy">
                </div>
                <div class="fd-cart-90day__gift-caption">
                    <span class="fd-cart-90day__gift-value">${escapeHtmlAttr(data.giftLabel)}${giftValue}</span>
                    <span class="fd-cart-90day__gift-title">${escapeHtmlAttr(state.gift.title)}</span>
                </div>
            </div>` : '';
        const amountHtml = state.saving > 0
            ? `<p class="fd-cart-90day__savings">${fillCardCopy(data.savings, { amount: `<strong>${Shopify.formatMoney(state.saving, '$--amount--')}</strong>` })}</p>`
            : '';
        return `
            <div class="fd-cart-90day__main${state.gift ? '' : ' fd-cart-90day__main--no-gift'}">
                ${giftHtml}
                <div class="fd-cart-90day__text">
                    <p class="fd-cart-90day__pill">${fillCardCopy(data.pill, { percent: function (sign) { return `<strong>${percent}${sign}</strong>`; } })}</p>
                    <div class="fd-cart-90day__title-row">
                        <p class="fd-cart-90day__title" id="fd-cart-90day-title"><span>${escapeHtmlAttr(data.titleTop)}</span> <span>${escapeHtmlAttr(data.titleBottom)}</span></p>
                        <button type="button"
                                class="fd-cart-90day__switch"
                                role="switch"
                                aria-checked="${state.on ? 'true' : 'false'}"
                                aria-labelledby="fd-cart-90day-title"
                                aria-describedby="fd-cart-90day-body"
                                data-fd-cart-90day="toggle"
                                onclick="changeAllPlanUpgrades(this.getAttribute('aria-checked') === 'true' ? 'undo' : 'upgrade')">
                            <span class="fd-cart-90day__knob" aria-hidden="true"></span>
                        </button>
                    </div>
                    <p class="fd-cart-90day__body" id="fd-cart-90day-body">${fillCardCopy(state.gift ? data.body : data.bodyNoGift, { percent: percent })}</p>
                </div>
            </div>
            ${amountHtml}`;
    }

    // Writes only when the markup changed, and keeps keyboard focus on the switch.
    function renderNinetyDayCard(card, state) {
        const html = ninetyDayCardHtml(card, state);
        if (card.__fdHtml !== html) {
            const hadFocus = card.contains(document.activeElement);
            card.innerHTML = html;
            card.__fdHtml = html;
            const toggle = card.querySelector('.fd-cart-90day__switch');
            if (hadFocus && toggle) toggle.focus();
        }
        card.hidden = false;
        const nav = document.getElementById('main-nav');
        if (nav) nav.classList.add('fd-cart-90day-shown');
    }

    function hideNinetyDayCard(card) {
        const nav = document.getElementById('main-nav');
        if (nav) nav.classList.remove('fd-cart-90day-shown');
        if (!card) return;
        card.hidden = true;
        card.innerHTML = '';
        card.__fdHtml = '';
        card.removeAttribute('aria-busy');
    }

    // Off with 30-day lines to move; on when every such line was moved by the card, so it can move them back.
    async function paintNinetyDayCard(cart) {
        const card = ninetyDayCardElement();
        const paint = ++ninetyDayCardPaint;
        if (!ninetyDayCardEnabled(card)) {
            hideNinetyDayCard(card);
            return;
        }
        if (ninetyDayCardBusy) return;
        const plan = await ninetyDayCardPlan(cart);
        if (paint !== ninetyDayCardPaint || ninetyDayCardBusy) return;
        const on = !plan.lines.length && plan.upgradedLines.length > 0;
        if (!plan.lines.length && !on) {
            hideNinetyDayCard(card);
            return;
        }
        const lines = on ? plan.upgradedLines : plan.lines;
        const percent = Math.min.apply(null, lines.map(function (line) { return line.percent; }));
        const saving = lines.every(function (line) { return line.exact; })
            ? lines.reduce(function (sum, line) { return sum + line.nowAtUpgradeQty - line.upgraded; }, 0)
            : 0;
        let gift = null;
        if (on) {
            const last = ninetyDayCardLastGift;
            gift = last && cart.items.some(function (item) { return safeString(item.variant_id) === last.variantId; }) ? last : null;
        } else {
            const earned = ninetyDayCardGift(cart, plan.lines);
            gift = earned ? await ninetyDayGiftDetails(earned).catch(function () { return null; }) : null;
            if (paint !== ninetyDayCardPaint || ninetyDayCardBusy) return;
            ninetyDayCardLastGift = gift;
        }
        if (!(percent > 0 && percent < 100)) {
            hideNinetyDayCard(card);
            return;
        }
        renderNinetyDayCard(card, { on: on, percent: percent, saving: saving, gift: gift });
    }

    // The switch flips at once; paints that started before the tap are dropped.
    function setNinetyDayCardBusy(on) {
        ninetyDayCardBusy = Boolean(on);
        ninetyDayCardPaint += 1;
        const card = ninetyDayCardElement();
        const toggle = card && card.querySelector('.fd-cart-90day__switch');
        if (!card) return;
        if (on) {
            card.setAttribute('aria-busy', 'true');
            if (toggle) {
                toggle.setAttribute('aria-checked', toggle.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
                toggle.setAttribute('aria-disabled', 'true');
            }
        } else {
            card.removeAttribute('aria-busy');
            if (toggle) toggle.removeAttribute('aria-disabled');
        }
    }

    function getCartContainsSubscription(cart) {
        if (!cart || !Array.isArray(cart.items)) {
            return false;
        }

        return cart.items.some(item => {
            if (!item) {
                return false;
            }
            const properties = item.properties || {};
            return normalizeBoolean(properties[SUBSCRIPTION_PROPERTY_KEY]);
        });
    }

    function updateMinicartAttributeInputs(cart, containsSubscription) {
        const container = document.querySelector('[data-minicart-attributes]');
        const subscriptionIndicator = document.querySelector('[data-minicart-contains-subscription]');
        if (!container) {
            return;
        }

        const methodInput = container.querySelector('[data-cart-attribute="_method"]');
        const oneTimeInput = container.querySelector('[data-cart-attribute="_is_one_time_purchase"]');
        const subscriptionInput = container.querySelector('[data-cart-attribute="_is_subscription_purchase"]');
        const itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

        let methodValue = '';
        let oneTimeValue = 'false';
        let subscriptionValue = 'false';

        if (containsSubscription) {
            methodValue = 'shipping';
            subscriptionValue = 'true';
            oneTimeValue = 'false';
        } else if (itemCount > 0) {
            oneTimeValue = 'true';
            subscriptionValue = 'false';
            if (itemCount >= 2) {
                methodValue = 'shipping';
            }
        }

        if (methodInput) methodInput.value = methodValue;
        if (oneTimeInput) oneTimeInput.value = oneTimeValue;
        if (subscriptionInput) subscriptionInput.value = subscriptionValue;
        if (subscriptionIndicator) subscriptionIndicator.textContent = containsSubscription ? 'true' : 'false';
        scheduleCheckoutAttributeSync();
    }

    // While the drawer is open, the cart gets the checkout form's attributes in the
    // background, so the checkout click usually has nothing to write. Paths that
    // never show this form keep the attributes the add wrote.
    let checkoutAttributeSync = null;
    let checkoutAttributeSyncAgain = false;

    function drawerFormVisible() {
        const context = document.querySelector('.js-menu__context');
        return !!context && context.classList.contains('js-menu__expanded') && !context.hasAttribute('inert') &&
            !!document.querySelector('#main-nav [data-minicart-attributes]');
    }

    function checkoutFormAttributeChanges() {
        const store = window.FDCart;
        if (!store || typeof store.getCurrentCart !== 'function' || !committedCart) return null;
        const current = store.getCurrentCart();
        if (!current || !Array.isArray(current.items) || !current.items.length) return null;
        if (store.fingerprintComposition(current) !== store.fingerprintComposition(committedCart)) return null;
        const known = (typeof store.getKnownAttributes === 'function' && store.getKnownAttributes()) || current.attributes || {};
        const changes = {};
        document.querySelectorAll('#main-nav [data-minicart-attributes] input[name^="attributes["]').forEach(function (input) {
            const key = input.name.slice('attributes['.length, -1);
            const want = String(input.value);
            const have = known[key] != null ? String(known[key]) : null;
            if (have === want || (have === null && want === '')) return;
            changes[key] = want;
        });
        return Object.keys(changes).length ? changes : null;
    }

    function scheduleCheckoutAttributeSync() {
        if (checkoutAttributeSync) {
            checkoutAttributeSyncAgain = true;
            return;
        }
        checkoutAttributeSync = (async function () {
            await new Promise(function (resolve) { setTimeout(resolve, 300); });
            const gwp = window.FDCartGwp;
            if (gwp && typeof gwp.whenIdle === 'function') await gwp.whenIdle(8000);
            const store = window.FDCart;
            if (store && typeof store.whenWritesIdle === 'function') await store.whenWritesIdle(8000);
            if (drawerActions.size || pendingCartWrites || !drawerFormVisible()) return;
            const changes = checkoutFormAttributeChanges();
            if (!changes) return;
            const body = new URLSearchParams();
            Object.keys(changes).forEach(function (key) { body.append('attributes[' + key + ']', changes[key]); });
            await fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' },
                body: body.toString()
            });
        })().catch(function () {}).finally(function () {
            checkoutAttributeSync = null;
            if (checkoutAttributeSyncAgain) {
                checkoutAttributeSyncAgain = false;
                scheduleCheckoutAttributeSync();
            }
        });
    }
    window.FDCartSyncCheckoutAttributes = scheduleCheckoutAttributeSync;

    function isCrossSellItem(item) {
        const properties = item?.properties || {};

        if (normalizeBoolean(properties._is_cross_sell)) {
            return true;
        }
        if(item?.title.toLowerCase().includes('add-on')) {
            return true;
        }

        if (!CROSS_SELL_PLAN_ID) {
            return false;
        }

        const planIdsToCheck = [
            safeString(item?.selling_plan_allocation?.selling_plan?.id),
            safeString(item?.selling_plan),
            safeString(properties._selling_plan)
        ].filter(Boolean);

        return planIdsToCheck.includes(CROSS_SELL_PLAN_ID);
    }

    // Check if product has TNProduct tag (uses pre-populated data, no fetch needed)
    async function hasTNProductTag(item) {
        const productHandle = item.handle;

        // Check pre-populated data first (instant, no network)
        if (window.PBFCM_PRODUCT_DATA && window.PBFCM_PRODUCT_DATA[productHandle]) {
            const productData = window.PBFCM_PRODUCT_DATA[productHandle];
            // Use pre-computed hasTNProduct flag or check tags array
            if (productData.hasTNProduct !== undefined) {
                return productData.hasTNProduct;
            }
            return productData.tags && productData.tags.includes('TNProduct');
        }

        // Check memory cache as secondary option
        const cacheKey = `tn:${productHandle}`;
        const cached = productTagCache.get(cacheKey);
        if (cached && cached.expires > Date.now()) {
            return cached.value;
        }

        // Fallback to fetch only if not pre-populated (shouldn't happen for PBFCM products)
        const product = await fetchProductTagJson(productHandle);
        if (product === undefined) return false;
        const hasTN = Boolean(product && product.tags && product.tags.includes('TNProduct'));
        productTagCache.set(cacheKey, { value: hasTN, expires: Date.now() + PRODUCT_CACHE_TTL });
        return hasTN;
    }

    // Generic, case-insensitive product-tag check. Reuses the same pre-populated
    // PBFCM_PRODUCT_DATA / cache / product.js-fetch chain as hasTNProductTag.
    async function productHasTag(item, tag) {
        const productHandle = item && item.handle;
        if (!productHandle || !tag) return false;

        const wanted = String(tag).toLowerCase();
        const hasWanted = (tags) =>
            Array.isArray(tags) && tags.some(t => String(t).toLowerCase() === wanted);

        if (window.PBFCM_PRODUCT_DATA && window.PBFCM_PRODUCT_DATA[productHandle]) {
            return hasWanted(window.PBFCM_PRODUCT_DATA[productHandle].tags);
        }

        const cacheKey = `tag:${wanted}:${productHandle}`;
        const cached = productTagCache.get(cacheKey);
        if (cached && cached.expires > Date.now()) {
            return cached.value;
        }

        const product = await fetchProductTagJson(productHandle);
        if (product === undefined) return false;
        const has = Boolean(product && hasWanted(product.tags));
        productTagCache.set(cacheKey, { value: has, expires: Date.now() + PRODUCT_CACHE_TTL });
        return has;
    }

    // Main cart item rendering function with accessibility enhancements
    async function renderCartItem(updatedCart, i) {
        const item = updatedCart.items[i];
        const prodId = item.product_id;
        // Independent lookups run together (reviews still wait for the TN check).
        const tnCheck = hasTNProductTag(item);
        const isAddOnLine = Boolean(item.handle && item.handle.includes('add-on'));
        if (isAddOnLine) fetchAddOnPricing(item.product_id);
        const [isTNProduct, isGwp, reviewsHTML, blurbHTML, subscriptionButtonHtml, preorderText] = await Promise.all([
            tnCheck,
            productHasTag(item, 'gwp'),
            tnCheck.then(function (isTN) { return isTN ? '' : renderReviews(prodId); }),
            renderProductBlurb(prodId),
            renderSubscriptionButton(item),
            fetchPreorderText(prodId)
        ]);
        // GWP (gift-with-purchase) lines: hide quantity controls (handled in
        // renderQuantityControls via this flag).
        item.__isGwp = isGwp;
        const linkedKey = tryNowLinkedKeys[item.key] || '';
        const safeKeyForJs = escapeForSingleQuote(item.key);
        const safeLinkedKeyForJs = escapeForSingleQuote(linkedKey);
        const removeKeyAttr = escapeHtmlAttr(item.key);
        const linkedKeyAttr = linkedKey ? ` data-linked-key="${escapeHtmlAttr(linkedKey)}"` : '';
        const crossSellDependents = Array.isArray(crossSellLinkedKeys[item.key]) ? crossSellLinkedKeys[item.key] : [];
        // Gift / GWP lines are managed by cart rules (added/removed automatically),
        // so the shopper shouldn't be able to remove them manually.
        const isGiftLine = item.__isGwp === true || isGiftItem(item) || isQuantityWelcomeGiftItem(item);
        const removeButtonHtml = (isTNProduct || isGiftLine) ? '' : renderRemoveButton(item, safeKeyForJs, safeLinkedKeyForJs, crossSellDependents);
        const isPreventSubscriptionItem = normalizeBoolean((item.properties || {})._prevent_subscription);
        const quantityControlsHtml = renderQuantityControls(item, i, linkedKey, isTNProduct || isPreventSubscriptionItem, crossSellDependents);
        const detailsQuantityControlsHtml = renderQuantityControls(item, i, linkedKey, isTNProduct || isPreventSubscriptionItem, crossSellDependents, 'details');
        const itemPricingHtml = renderItemPricing(item);
        const detailsItemPricingHtml = itemPricingHtml
            .replace(/\s+id="[^"]*"/g, '')
            .replace(/\s+name="[^"]*"/g, '');
        const baseSubscriptionInfoHtml = renderSubscriptionInfo(item, 'ab-cart-drawer__base-subscription-info', preorderText);
        const detailsSubscriptionInfoHtml = renderSubscriptionInfo(item, 'ab-cart-drawer__details-subscription-info', preorderText);
        const preorderHTML = preorderText && !detailsSubscriptionInfoHtml
            ? `<p class="subscription-delivery-text firstday-cart__flyout-item-preorder">${escapeHtmlAttr(preorderText)}</p>`
            : '';
        if (isAddOnLine) {
            await ensureAddOnPricingProperties(item);
        }
        
        // Accessibility: Calculate item position for screen readers
        const itemNumber = i + 1;
        const totalItems = updatedCart.items.length;
        const itemDetailsId = `item-details-${escapeHtmlAttr(item.key)}`;
        const itemTitleId = `item-title-${escapeHtmlAttr(item.key)}`;
        const variantText = item.variant_title && item.variant_title !== 'Default Title' ? ` - ${item.variant_title}` : '';
        const itemAriaLabel = `Cart item ${itemNumber} of ${totalItems}: ${escapeHtmlAttr(item.product_title)}${variantText}`;
        const productHref = isGiftLine ? '#' : `/products/${item.handle}`;

        // Per-type styling hooks on the card. Pure presentation — no logic change.
        const itemProps = item.properties || {};
        const isSubscriptionItem = normalizeBoolean(itemProps._is_subscription_purchase)
            || Boolean(item.selling_plan)
            || Boolean(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
        const isFreeUnlockItem = normalizeBoolean(itemProps._free_unlock);
        const typeClasses = [
            isSubscriptionItem ? 'is-subscription' : 'is-onetime',
            item.__isGwp ? 'is-gwp' : '',
            isTNProduct ? 'is-tn' : '',
            isFreeUnlockItem ? 'is-free-unlock' : '',
            isPreventSubscriptionItem ? 'is-prevent-subscription' : ''
        ].filter(Boolean).join(' ');

        return `
        <article class="firstday-cart__flyout-item product-${item.handle} ${typeClasses}"
                 data-remove-key="${removeKeyAttr}"${linkedKeyAttr}
                 role="listitem"
                 aria-label="${itemAriaLabel}"
                 aria-describedby="${itemDetailsId}">
            <div class="mini-cart-product-container">
                <div class="mini-cart-product-content">
                    <div class="firstday-cart__flyout-item-media">
                        ${isGiftLine
                            ? `<div class="firstday-cart__flyout-item-media-inner is-gift">
                                  <img src="${item.image}&width=180" 
                                       alt="Product image: ${escapeHtmlAttr(item.product_title)}${variantText}" 
                                       loading="lazy">
                               </div>`
                            : `<a href="${productHref}"
                                   aria-label="View ${escapeHtmlAttr(item.product_title)}${variantText} product details">
                                   <img src="${item.image}&width=180" 
                                        alt="Product image: ${escapeHtmlAttr(item.product_title)}${variantText}" 
                                        loading="lazy">
                               </a>`}
                    </div>
                    <div class="firstday-cart__flyout-item-details" id="${itemDetailsId}">
                        <div class="mini-cart-product-title-row">
                            ${isGiftLine
                                ? `<span class="firstday-cart__flyout-item-product-title is-gift" id="${itemTitleId}">
                                       ${item.product_title}
                                   </span>`
                                : `<a href="${productHref}" 
                                       class="firstday-cart__flyout-item-product-title"
                                       id="${itemTitleId}">
                                       ${item.product_title}
                                   </a>`}
                            ${removeButtonHtml}
                        </div>
                        ${detailsSubscriptionInfoHtml}

                        ${renderVariantTitle(item)}
                        ${preorderHTML}
                        ${reviewsHTML}
                        ${blurbHTML}
                        <div class="mini-cart-product-price-and-controls ab-cart-drawer__details-price-and-controls">
                            ${detailsQuantityControlsHtml}
                            ${detailsItemPricingHtml}
                        </div>
                    </div>
                </div>

                <div class="mini-cart-product-price-and-controls ab-cart-drawer__base-price-and-controls">
                    ${quantityControlsHtml}
                    ${itemPricingHtml}
                </div>
                ${baseSubscriptionInfoHtml}

                <div class="mini-cart-product-footer">
                    ${renderPlanUpgradeControl(item)}
                    ${(isTNProduct || isPreventSubscriptionItem) ? '' : subscriptionButtonHtml}
                </div>
            </div>
        </article>
    `;
    }

    // Render variant title
    function renderVariantTitle(item) {
        const variantTitle = item.variant_title === undefined ? item.title : item.variant_title;
        if (!variantTitle || variantTitle === 'Default Title') {
            return '';
        }
        return `<div class="firstday-cart__flyout-item-variant-title">${variantTitle}</div>`;
    }

    // Render item pricing based on subscription/one-time status
    function renderItemPricing(item) {
        // Re-evaluate BFCM state per render: respect PDP override if present,
        // otherwise fall back to the theme-level BFCM mode.
        if (typeof window !== 'undefined' && window.__pdpDiscountOverride
            && typeof window.__pdpDiscountOverride.discountPercent === 'number'
            && Number.isFinite(window.__pdpDiscountOverride.discountPercent)) {
            isBFCMPage = true;
        } else {
            isBFCMPage = window.FDMinicartRenderingConfig.bfcmModeEnabled;
        }

        const hasSubscription = item.selling_plan_allocation !== undefined;
        const quantity = item.quantity;
        const price = item.price;
        const originalPrice = item.original_price || price;
        const isCrossSell = isCrossSellItem(item);
        const variantId = item.variant_id;

        const properties = item.properties || {};


        // Free "unlocks" gift line: a separate product added free alongside an
        // upsell (flagged _free_unlock by the PDP controller). Show its MSRP
        // struck through with FREE next to it, reusing the standard two-price
        // markup. NOTE: this is the cart DISPLAY only — the actual charge-to-$0
        // is enforced by the store's discount/Function, not the theme.
        // GWP (gift-with-purchase) tagged products get the same FREE treatment as
        // free-unlock gifts: MSRP struck through with a green FREE, never a "$0.00".
        const isFreeUnlock = normalizeBoolean(properties._free_unlock);
        const isGwpFree = item.__isGwp === true;
        const isBundleFreeGift = normalizeBoolean(properties._free_gift) || normalizeBoolean(properties._bundle_gift);
        if (isFreeUnlock || isGwpFree || isBundleFreeGift) {
            const fullCents = parsePriceCents(properties._bfcm_add_on_full_price);
            const compareUnit = fullCents != null ? fullCents : (originalPrice || price);
            const compareTotal = compareUnit * quantity;
            // No struck price worth showing → just render FREE on its own.
            if (!compareTotal || compareTotal <= 0) {
                return `
            <div class="firstday-cart__flyout-item-price${isBFCMPage ? ' is-bfcm' : ''}">
                <span class="firstday-money" name="sale-price">FREE</span>
            </div>
        `;
            }
            return `
            <div class="firstday-cart__flyout-item-price${isBFCMPage ? ' is-bfcm' : ''}"
                 role="group"
                 aria-label="Price information">
<div>
                ${renderIgCompareSpan(variantId, compareTotal)}
                <span class="firstday-money subscription-price" name="sale-price">
                    <span class="sr-only">Sale price free</span>
                    <span aria-hidden="true">FREE</span>
                </span>
</div>
            </div>
        `;
        }

        // Check if this is a prevent-subscription variant (shows as free)
        const isPreventSubscription = normalizeBoolean(properties._prevent_subscription);
        if (isPreventSubscription) {
            return `
            <div class="firstday-cart__flyout-item-price${isBFCMPage ? ' is-bfcm' : ''}">
                ${renderIgSinglePriceSpan(variantId, 0)}
            </div>
        `;
        }

        // Check if this is a Try Now product or linked to a Try Now product
        const tryNowSellingPlanMatches = TRY_NOW_SELLING_PLAN_ID && [
            safeString(properties._selling_plan),
            safeString(item.selling_plan),
            safeString(item.selling_plan_allocation?.selling_plan?.id)
        ].some(id => id && id === TRY_NOW_SELLING_PLAN_ID);
        const isTryNowItem = tryNowSellingPlanMatches || normalizeBoolean(properties._is_try_now);
        const isLinkedToTryNow = tryNowLinkedKeys[item.key] !== undefined;

        // Show $0.00 for Try Now products or products linked to Try Now products
        if (isTryNowItem || isLinkedToTryNow) {
            return `
            <div class="firstday-cart__flyout-item-price${isBFCMPage ? ' is-bfcm' : ''}">
                ${renderIgSinglePriceSpan(variantId, 0)}
            </div>
        `;
        }

        // Gift line items render their final price only — no strike, no
        // "with CODE applied" banner, no is-bfcm class. final_line_price is
        // Shopify's post-allocation line total (typically $0 for gifts); falls
        // back to price * quantity for older cart payloads.
        if (isGiftItem(item)) {
            const giftTotal = Number.isFinite(item.final_line_price)
                ? item.final_line_price
                : price * quantity;
            if (!giftTotal || giftTotal <= 0) {
                const fullCents = parsePriceCents(properties._bfcm_add_on_full_price);
                const compareUnit = fullCents != null ? fullCents : (originalPrice || price);
                const compareTotal = compareUnit * quantity;
                if (!compareTotal || compareTotal <= 0) {
                    return `
            <div class="firstday-cart__flyout-item-price">
                <span class="firstday-money" name="sale-price">FREE</span>
            </div>
        `;
                }
                return `
            <div class="firstday-cart__flyout-item-price"
                 role="group"
                 aria-label="Price information">
                ${renderIgCompareSpan(variantId, compareTotal)}
                <span class="firstday-money subscription-price" name="sale-price">
                    <span class="sr-only">Sale price free</span>
                    <span aria-hidden="true">FREE</span>
                </span>
            </div>
        `;
            }
            return `
            <div class="firstday-cart__flyout-item-price">
                <span class="firstday-money" name="sale-price">${Shopify.formatMoney(giftTotal, '$--amount--')}</span>
            </div>
        `;
        }

        if (isCrossSell) {
            // Check if this is an add-on item (identified by 'add-on' in the handle)
            const isAddOnItem = item.handle && item.handle.includes('add-on');

            const sellingPlanAllocation = item.selling_plan_allocation || {};
            const discountedUnitPrice = (sellingPlanAllocation.price !== undefined ? sellingPlanAllocation.price : price) || 0;
            const basePriceFallback = price || discountedUnitPrice || 0;

            let baseUnitPrice;
            let finalDiscountedPrice;

            if (isAddOnItem) {
                const promoPriceCents = parsePriceCents(properties._bfcm_add_on_promo_price);
                const fullPriceCents = parsePriceCents(properties._bfcm_add_on_full_price);
                finalDiscountedPrice = promoPriceCents != null ? promoPriceCents : basePriceFallback;
                const fallbackBase = finalDiscountedPrice > 0 ? finalDiscountedPrice * 2 : basePriceFallback * 2;
                baseUnitPrice = fullPriceCents != null ? fullPriceCents : fallbackBase;
            } else {
                // Regular cross-sell: Strike price = price × 1, Sale price = price × 0.85 (15% off)
                baseUnitPrice = sellingPlanAllocation.compare_at_price !== undefined
                    ? sellingPlanAllocation.compare_at_price
                    : (item.compare_at_price || originalPrice || 0);

                if ((!baseUnitPrice || baseUnitPrice <= discountedUnitPrice) && discountedUnitPrice > 0) {
                    baseUnitPrice = Math.round(discountedUnitPrice / CROSS_SELL_DISCOUNT_RATE);
                }

                finalDiscountedPrice = discountedUnitPrice;
            }

            const compareAtTotal = baseUnitPrice * quantity;
            const discountedTotal = finalDiscountedPrice * quantity;

            if (compareAtTotal <= discountedTotal) {
                return `
            <div class="firstday-cart__flyout-item-price${isBFCMPage ? ' is-bfcm' : ''}">
                ${renderIgSinglePriceSpan(variantId, discountedTotal)}
            </div>
        `;
            }

            const crossSellMultiplier = null;

            return `
            <div class="firstday-cart__flyout-item-price${isBFCMPage ? ' is-bfcm' : ''}"
                 role="group"
                 aria-label="Price information">
<div>
                ${renderIgCompareSpan(variantId, compareAtTotal)}
                ${renderIgPriceSpan(variantId, discountedTotal, crossSellMultiplier)}
</div>
            </div>
        `;
        }

        if (hasSubscription) {
            const sellingPlanAllocation = item.selling_plan_allocation || {};
            const subscriptionUnitPrice = sellingPlanAllocation.price !== undefined ? sellingPlanAllocation.price : price;
            const compareAtUnitPrice = sellingPlanAllocation.compare_at_price !== undefined ? sellingPlanAllocation.compare_at_price : originalPrice;

            const lineDiscount = resolveCartLineDiscount(item);

            let subscriptionTotal;
            let compareAtTotal;
            if (lineDiscount.source === 'cart') {
                subscriptionTotal = lineDiscount.finalLineTotal;
                compareAtTotal    = lineDiscount.originalLineTotal;
            } else {
                subscriptionTotal = subscriptionUnitPrice * quantity;
                if (lineDiscount.hasLineDiscount) {
                    subscriptionTotal = discountedLineTotal(subscriptionUnitPrice, quantity, lineDiscount);
                }
                // Strike against the higher of compare_at_price (Shopify sale price)
                // or original_price (pre-sub-allocation MSRP). Compare against the
                // post-coupon subscriptionTotal so the strike still shows when our
                // coupon multiplier is what creates the saving (e.g. autoApplyOnSub
                // mode where Shopify's selling-plan price equals MSRP).
                const strikeUnitPrice = Math.max(compareAtUnitPrice || 0, originalPrice || 0);
                compareAtTotal = strikeUnitPrice * quantity;
            }

            const showCompareAt     = compareAtTotal > subscriptionTotal;
            const showDiscountBanner = lineDiscount.hasLineDiscount || lineDiscount.source === 'cart';
            const subMultiplier = null;


            return `
            <div class="firstday-cart__flyout-item-price${showDiscountBanner ? ' is-bfcm' : ''}"
                 role="group"
                 aria-label="Price information">
<div>
                ${showCompareAt ? renderIgCompareSpan(variantId, compareAtTotal) : ''}
                ${renderIgPriceSpan(variantId, subscriptionTotal, subMultiplier, ' id="label-subscription-price"')}

</div>
${showDiscountBanner ? `<div aria-live="polite">with <strong>${lineDiscount.code}</strong> code applied</div>` : ''}
            </div>

        `;
        }

        const otpLineDiscount = resolveCartLineDiscount(item);
        const otpStrikeTotal = otpLineDiscount.source === 'cart'
            ? otpLineDiscount.originalLineTotal
            : price * quantity;
        const otpFinalTotal = otpLineDiscount.source === 'cart'
            ? otpLineDiscount.finalLineTotal
            : (otpLineDiscount.hasLineDiscount ? discountedLineTotal(price, quantity, otpLineDiscount) : price * quantity);
        const showOtpDiscountBanner = otpLineDiscount.hasLineDiscount || otpLineDiscount.source === 'cart';
        const otpMultiplier = otpLineDiscount.hasLineDiscount ? otpLineDiscount.multiplier : null;
        const showOtpCompare = otpStrikeTotal > otpFinalTotal;


        return `

            <div class="firstday-cart__flyout-item-price${showOtpDiscountBanner ? ' is-bfcm' : ''}"
                 role="group"
                 aria-label="Price information">
<div>
                ${showOtpCompare ? renderIgCompareSpan(variantId, otpStrikeTotal) : ''}
                ${renderIgPriceSpan(variantId, otpFinalTotal, otpMultiplier, ' id="label-subscription-price7"')}

</div>
${showOtpDiscountBanner ? `<div aria-live="polite">with <strong>${otpLineDiscount.code}</strong> code applied</div>` : ''}
            </div>
    `;
    }

    // Product metafield custom.preorder_text, e.g. "Expected to ship on 11/13".
    async function fetchPreorderText(prodId) {
        try {
            return await window.Storefront.productPreorderTextById(prodId);
        } catch (error) {
            console.error('Error fetching preorder text:', error);
            return null;
        }
    }

    // Render subscription info if item is a subscription
    function renderSubscriptionInfo(item, extraClass = '', preorderText = '') {
        const hasSubscription = item.selling_plan_allocation !== undefined;

        if (!hasSubscription) {
            return '';
        }

        // Check if this is a Try Now item
        const properties = item.properties || {};
        const tryNowSellingPlanMatches = TRY_NOW_SELLING_PLAN_ID && [
            safeString(properties._selling_plan),
            safeString(item.selling_plan),
            safeString(item.selling_plan_allocation?.selling_plan?.id)
        ].some(id => id && id === TRY_NOW_SELLING_PLAN_ID);
        const isTryNowItem = tryNowSellingPlanMatches || normalizeBoolean(properties._is_try_now);

        // Don't show subscription info for Try Now items
        if (isTryNowItem) {
            return '';
        }

        // ACCESSIBILITY: Include product context and proper semantic structure
        const productTitle = escapeHtmlAttr(item.product_title || item.title || 'this item');
        const className = extraClass
            ? `mini-cart-subscription-info ${escapeHtmlAttr(extraClass)}`
            : 'mini-cart-subscription-info';
        const deliveryText = [formatSubscriptionDeliveryText(item), preorderText].filter(Boolean).join(' | ');
        return `
            <div class="${className}" 
                 role="status" 
                 aria-label="Subscription details for ${productTitle}">
                <p class="subscription-delivery-text">${escapeHtmlAttr(deliveryText)}</p>
            </div>
        `;
    }

    function formatSubscriptionDeliveryText(item) {
        const plan = item?.selling_plan_allocation?.selling_plan;
        const name = safeString(plan?.name).trim();
        if (!name) return 'Delivered on subscription';

        if (/^delivered\b/i.test(name)) return name;
        if (/^delivery\s+every\b/i.test(name)) {
            return name.replace(/^delivery\s+/i, 'Delivered ');
        }

        const everyMatch = name.match(/every\s+(\d+)\s*days?/i);
        if (everyMatch) return `Delivered every ${everyMatch[1]} days`;

        const daysMatch = name.match(/(\d+)\s*-?\s*day/i);
        if (daysMatch) return `Delivered every ${daysMatch[1]} days`;

        return name;
    }

    async function buildTryNowPairMap(cart) {
        const map = {};

        if (!cart || !Array.isArray(cart.items)) {
            return map;
        }

        const pairGroups = {};

        cart.items.forEach(item => {
            const properties = item.properties || {};
            const rawPairKey = properties[TRY_NOW_PAIR_KEY_PROPERTY];

            if (!rawPairKey) {
                return;
            }

            const pairKey = safeString(rawPairKey);
            if (!pairGroups[pairKey]) {
                pairGroups[pairKey] = [];
            }
            pairGroups[pairKey].push(item);
        });

        Object.values(pairGroups).forEach(group => {
            if (!Array.isArray(group) || group.length < 2) {
                return;
            }

            const primary = group.find(line => safeString(line.properties?.[TRY_NOW_PAIR_ROLE_PROPERTY]).toLowerCase() === TRY_NOW_ROLE_PRIMARY) || group[0];
            const subscription = group.find(line => safeString(line.properties?.[TRY_NOW_PAIR_ROLE_PROPERTY]).toLowerCase() === TRY_NOW_ROLE_SUBSCRIPTION);

            if (primary && subscription) {
                map[primary.key] = subscription.key;
                map[subscription.key] = primary.key;
            }
        });

        if (Object.keys(map).length > 0) {
            return map;
        }

        const mainsByProduct = {};
        const subsByProduct = {};

        cart.items.forEach(item => {
            const properties = item.properties || {};
            const productId = item.product_id;
            if (!productId) {
                return;
            }

            const isSubscriptionItem = normalizeBoolean(properties._is_subscription_purchase) ||
                !!item.selling_plan_allocation ||
                safeString(item.selling_plan_allocation?.selling_plan?.name).toLowerCase().includes('subscription') ||
                safeString(item.selling_plan_allocation?.selling_plan?.name).toLowerCase().includes('stay');

            // Only real Try Now signals — NOT plain OTP (_is_one_time_purchase).
            // Stamping _is_one_time_purchase on every OTP ATC line made this
            // fallback pair normal OTP+sub of the same product and force $0.
            const tryNowSellingPlanMatches = TRY_NOW_SELLING_PLAN_ID && [
                safeString(properties._selling_plan),
                safeString(item.selling_plan),
                safeString(item.selling_plan_allocation?.selling_plan?.id)
            ].some(id => id && id === TRY_NOW_SELLING_PLAN_ID);

            const isTryNowItem = tryNowSellingPlanMatches ||
                normalizeBoolean(properties._is_try_now) ||
                safeString(item.selling_plan_allocation?.selling_plan?.name).toLowerCase().includes('try');

            // Mains must be real Try Now. Subs collected for any product — pairing
            // below only runs when that product also has a Try Now main.
            if (isTryNowItem && !isSubscriptionItem) {
                (mainsByProduct[productId] = mainsByProduct[productId] || []).push(item);
            } else if (isSubscriptionItem) {
                (subsByProduct[productId] = subsByProduct[productId] || []).push(item);
            }
        });

        Object.keys(mainsByProduct).forEach(productId => {
            const mains = mainsByProduct[productId];
            const subs = subsByProduct[productId] || [];

            if (!mains.length || !subs.length) {
                return;
            }


            mains.forEach((mainLine, index) => {
                const subscriptionLine = subs[index] || subs[subs.length - 1];
                if (subscriptionLine) {
                    map[mainLine.key] = subscriptionLine.key;
                    map[subscriptionLine.key] = mainLine.key;
                }
            });
        });

        return map;
    }

    function buildCrossSellPairMap(cart) {
        const result = {};

        if (!cart || !Array.isArray(cart.items)) {
            return result;
        }

        const groupedByPair = {};

        cart.items.forEach(item => {
            const itemKey = safeString(item?.key);
            const pairId = safeString(item?.properties?._cross_sell_pair_id);

            if (!itemKey || !pairId) {
                return;
            }

            if (!groupedByPair[pairId]) {
                groupedByPair[pairId] = { mains: [], cross: [] };
            }

            if (isCrossSellItem(item)) {
                groupedByPair[pairId].cross.push(itemKey);
            } else {
                groupedByPair[pairId].mains.push(itemKey);
            }
        });

        Object.values(groupedByPair).forEach(group => {
            if (!group || !group.mains.length || !group.cross.length) {
                return;
            }

            group.mains.forEach(mainKey => {
                result[mainKey] = group.cross.slice();
            });
        });

        return result;
    }

    function getCartItemByKey(key) {
        if (!latestCartState || !Array.isArray(latestCartState.items)) {
            return null;
        }

        const normalizedKey = safeString(key);
        if (!normalizedKey) {
            return null;
        }

        return latestCartState.items.find(item => safeString(item?.key) === normalizedKey) || null;
    }

    function getCartItemTitleByKey(key) {
        const item = getCartItemByKey(key);
        if (!item) {
            return '';
        }

        return safeString(item.product_title || item.title || '');
    }

    function getCartItemQuantityByKey(key) {
        const item = getCartItemByKey(key);
        if (!item) {
            return 0;
        }

        const quantity = Number(item.quantity);
        return Number.isFinite(quantity) ? quantity : 0;
    }

    async function fetchAddOnPricing(productId) {
        const cacheKey = safeString(productId);
        if (!cacheKey || !window.Storefront || typeof window.Storefront.productAddOnPricingById !== 'function') {
            return null;
        }

        if (!addOnPricingCache.has(cacheKey)) {
            const promise = window.Storefront.productAddOnPricingById(productId)
                .then((data) => {
                    if (!data) return null;
                    return {
                        promoCents: convertMoneyValueToCents(data.promo),
                        fullCents: convertMoneyValueToCents(data.full)
                    };
                })
                .catch((error) => {
                    console.error('Mini cart: failed to fetch add-on pricing', error);
                    return null;
                });
            addOnPricingCache.set(cacheKey, promise);
        }

        return addOnPricingCache.get(cacheKey);
    }

    async function ensureAddOnPricingProperties(item) {
        if (!item || !item.handle || !item.handle.includes('add-on')) {
            return;
        }

        const properties = item.properties || (item.properties = {});
        const hasPromo = parsePriceCents(properties._bfcm_add_on_promo_price) != null;
        const hasFull = parsePriceCents(properties._bfcm_add_on_full_price) != null;

        if (hasPromo && hasFull) {
            return;
        }

        try {
            const pricing = await fetchAddOnPricing(item.product_id);
            if (!pricing) {
                return;
            }

            if (!hasPromo && pricing.promoCents != null) {
                properties._bfcm_add_on_promo_price = String(pricing.promoCents);
            }
            if (!hasFull && pricing.fullCents != null) {
                properties._bfcm_add_on_full_price = String(pricing.fullCents);
            }
        } catch (error) {
            console.error('Mini cart: unable to ensure add-on pricing', error);
        }
    }

    function formatCrossSellDependentList(keys) {
        const titles = (Array.isArray(keys) ? keys : [])
            .map(getCartItemTitleByKey)
            .filter(Boolean);

        if (!titles.length) {
            return 'the associated add-on product';
        }

        if (titles.length === 1) {
            return titles[0];
        }

        const lastTitle = titles[titles.length - 1];
        const leadingTitles = titles.slice(0, -1);
        return `${leadingTitles.join(', ')} and ${lastTitle}`;
    }

    function injectCrossSellModalStyles() {
        if (document.getElementById('cross-sell-removal-styles')) {
            return;
        }

        const style = document.createElement('style');
        style.id = 'cross-sell-removal-styles';
        style.type = 'text/css';
        style.textContent = `
            .cross-sell-remove-overlay {
                position: fixed;
                inset: 0;
                display: none;
                align-items: center;
                justify-content: center;
                background: rgba(15, 23, 42, 0.55);
                z-index: 99999 !important;
                padding: 24px;
            }

            .cross-sell-remove-overlay.is-visible {
                display: flex;
            }

            body.cross-sell-modal-open {
                overflow: hidden;
            }

            .cross-sell-remove-dialog {
                background: #ffffff;
                border-radius: 20px;
                width: min(420px, 100%);
                padding: 32px 28px;
                text-align: center;
                box-shadow: 0 30px 60px rgba(15, 23, 42, 0.18);
            }

            .cross-sell-remove-icon {
                width: 64px;
                height: 64px;
                border-radius: 50%;
                margin: 0 auto 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(72, 108, 237, 0.12);
                color: #486ced;
                font-size: 28px;
                font-weight: 700;
            }

            .cross-sell-remove-heading {
                font-size: 24px;
                text-align: center;
                font-family: 'gelica';
                margin-top: 0;
                font-weight: 700;
                margin-bottom: 12px;
                color: #111827;
            }

            .cross-sell-remove-message {
                font-size: 16px;
                font-family: 'gelica';
                line-height: 1.5;
                color: #4b5563;
                margin-bottom: 24px;
            }

            .cross-sell-remove-actions {
                display: flex;
                font-size: 14px;
                flex-direction: column;
                gap: 12px;
            }

            .cross-sell-remove-button {
                width: 100%;
                border-radius: 999px;
                border: 0;
                font-weight: 600;
                padding: 14px 20px;
                cursor: pointer;
                transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
            }

            .cross-sell-remove-button:focus {
                outline: none;
                box-shadow: 0 0 0 3px rgba(72, 108, 237, 0.35);
            }

            .cross-sell-remove-button:disabled {
                cursor: not-allowed;
                opacity: 0.7;
            }

            .cross-sell-remove-button--keep {
                background: #ffffff;
                color: #486ced;
                border: 2px solid #486ced;
            }

            .cross-sell-remove-button--keep:hover:not(:disabled) {
                box-shadow: 0 4px 12px rgba(72, 108, 237, 0.2);
                transform: translateY(-1px);
            }

            .cross-sell-remove-button--remove {
                background: #486ced;
                color: #ffffff;
            }

            .cross-sell-remove-button--remove:hover:not(:disabled) {
                box-shadow: 0 4px 12px rgba(72, 108, 237, 0.4);
                transform: translateY(-1px);
            }
        `;

        document.head.appendChild(style);
    }

    function attachCrossSellModalEvents(overlay) {
        if (!overlay || crossSellModalInitialized) {
            return;
        }

        const keepButton = overlay.querySelector('.cross-sell-remove-button--keep');
        const removeButton = overlay.querySelector('.cross-sell-remove-button--remove');

        if (keepButton) {
            keepButton.addEventListener('click', handleKeepCrossSellProducts);
        }

        if (removeButton) {
            removeButton.addEventListener('click', confirmCrossSellRemoval);
        }

        overlay.addEventListener('click', event => {
            if (event.target === overlay) {
                handleKeepCrossSellProducts();
            }
        });

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && overlay.classList.contains('is-visible')) {
                handleKeepCrossSellProducts();
            }
        });

        crossSellModalInitialized = true;
    }

    function ensureCrossSellRemovalModal() {
        injectCrossSellModalStyles();

        let overlay = document.querySelector('[data-cross-sell-modal]');

        if (!overlay) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = `
                <div class="cross-sell-remove-overlay" data-cross-sell-modal aria-hidden="true">
                    <div class="cross-sell-remove-dialog" role="dialog" aria-modal="true" aria-labelledby="cross-sell-remove-heading">
                        <h1 class="cross-sell-remove-heading" id="cross-sell-remove-heading">Are you sure you want to remove this product?</h1>
                        <p class="cross-sell-remove-message"></p>
                        <div class="cross-sell-remove-actions">
                            <button type="button" class="cross-sell-remove-button cross-sell-remove-button--keep">Keep Products</button>
                            <button type="button" class="cross-sell-remove-button cross-sell-remove-button--remove">Remove Products</button>
                        </div>
                    </div>
                </div>
            `.trim();

            const element = wrapper.firstElementChild;
            if (element) {
                document.body.appendChild(element);
                overlay = element;
            }
        }

        attachCrossSellModalEvents(overlay);

        return overlay;
    }

    function openCrossSellRemovalModal(primaryKey, dependents, productTitle = '') {
        const overlay = ensureCrossSellRemovalModal();
        if (!overlay) {
            return;
        }

        const normalizedPrimaryKey = safeString(primaryKey);
        if (!normalizedPrimaryKey) {
            return;
        }

        const dependentKeys = Array.from(new Set((Array.isArray(dependents) ? dependents : [])
            .map(key => safeString(key))
            .filter(Boolean)));

        const resolvedTitle = productTitle || getCartItemTitleByKey(normalizedPrimaryKey) || 'this product';
        const messageElement = overlay.querySelector('.cross-sell-remove-message');

        if (messageElement) {
            const dependentLabel = formatCrossSellDependentList(dependentKeys);
            messageElement.innerHTML = `By removing <strong>${resolvedTitle}</strong>, your cart will be cleared`;
        }

        pendingCrossSellRemoval = {
            primaryKey: normalizedPrimaryKey,
            dependents: dependentKeys
        };

        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cross-sell-modal-open');

        const removeButton = overlay.querySelector('.cross-sell-remove-button--remove');
        removeButton?.focus();
    }

    function closeCrossSellRemovalModal() {
        const overlay = document.querySelector('[data-cross-sell-modal]');
        if (overlay) {
            overlay.classList.remove('is-visible');
            overlay.setAttribute('aria-hidden', 'true');
        }

        document.body.classList.remove('cross-sell-modal-open');
        pendingCrossSellRemoval = null;
    }

    function handleKeepCrossSellProducts() {
        closeCrossSellRemovalModal();
    }

    async function confirmCrossSellRemoval() {
        if (!pendingCrossSellRemoval) {
            closeCrossSellRemovalModal();
            return;
        }

        const overlay = document.querySelector('[data-cross-sell-modal]');
        const removeButton = overlay?.querySelector('.cross-sell-remove-button--remove');

        if (removeButton) {
            removeButton.disabled = true;
        }

        const updates = {};
        updates[tappedLineKey(pendingCrossSellRemoval.primaryKey)] = 0;
        pendingCrossSellRemoval.dependents.forEach(key => {
            updates[tappedLineKey(key)] = 0;
        });

        let removalSuccessful = false;

        try {
            await applyBulkCartUpdates(updates);
            removalSuccessful = true;
        } catch (error) {
            console.error('Mini cart: unable to remove cross-sell bundle', error);
        } finally {
            if (removeButton) {
                removeButton.disabled = false;
            }
        }

        if (removalSuccessful) {
            closeCrossSellRemovalModal();
        }
    }

    function handleCrossSellMainRemoval(event) {
        const button = event.currentTarget;
        const primaryKey = button.dataset.primaryKey || '';
        const productTitle = button.dataset.productTitle || '';
        const dependentsJson = button.dataset.dependents || '[]';

        let dependents = [];
        try {
            dependents = JSON.parse(dependentsJson);
        } catch (error) {
            console.warn('Mini cart: unable to parse cross-sell dependents', error);
        }

        openCrossSellRemovalModal(primaryKey, dependents, productTitle);
    }

    // Render product reviews with accessibility enhancements
    async function renderReviews(prodId) {
        // Lines render in parallel, so a failed badge query must not fail the whole drawer.
        let reviewsHTML = null;
        try {
            reviewsHTML = await window.Storefront.productReviewsById(prodId, "judgeme.badge");
        } catch (error) {
            console.error('Error fetching product reviews badge:', error);
            return '';
        }

        if (!reviewsHTML) {
            return '';
        }

        // ACCESSIBILITY: Extract actual rating value for better screen reader context
        let reviewsAriaLabel = 'Product rating';
        const ratingMatch = reviewsHTML.match(/data-average-rating="([\d.]+)"|(\d+\.?\d*)\s*(?:out of|\/)\s*5|rating['":\s]+(\d+\.?\d*)/i);
        if (ratingMatch) {
            const ratingValue = ratingMatch[1] || ratingMatch[2] || ratingMatch[3];
            reviewsAriaLabel = `Product rating: ${ratingValue} out of 5 stars`;
        }

        return `
          <div class='jdgm-widget jdgm-preview-badge' 
               role="img" 
               aria-label="${reviewsAriaLabel}">${reviewsHTML}</div>
    `;
    }

    // Render product blurb from custom.blurb metafield
    async function renderProductBlurb(prodId) {
        try {
            const blurbValue = await window.Storefront.productBlurbById(prodId);

            if (!blurbValue) {
                return '';
            }

            return `
                <div class="product-blurb">
                    ${blurbValue}
                </div>
            `;
        } catch (error) {
            console.error('Error fetching product blurb:', error);
            return '';
        }
    }

    // Render quantity controls with accessibility enhancements
    function renderQuantityControls(item, index, linkedKey, isTNProduct, crossSellDependents = [], idSuffix = '') {

        // No quantity controls for: GWP (gift-with-purchase) tagged products,
        // free-unlock gifts, Shopify "gift" product_type, or any line whose unit
        // or line total is $0.
        const qtyProps = item.properties || {};
        const isQuantityWelcomeGift = isQuantityWelcomeGiftItem(item);
        const hideQuantityControls =
            item.__isGwp === true
            || normalizeBoolean(qtyProps._free_unlock)
            || (!isQuantityWelcomeGift && isGiftItem(item))
            || (!isQuantityWelcomeGift && Number(item.price) === 0)
            || (!isQuantityWelcomeGift && Number(item.final_line_price) === 0);
        if (hideQuantityControls) {
            return '';
        }
        const safeKeyForJs = escapeForSingleQuote(item.key);
        const safeLinkedKeyForJs = escapeForSingleQuote(linkedKey || '');
        const linkedKeyAttr = linkedKey ? ` data-linked-key="${escapeHtmlAttr(linkedKey)}"` : '';
        const qtyStep = getLineQtyStep(item);
        const hasQtyStep = qtyStep > 1;
        const minQty = hasQtyStep ? qtyStep : 1;
        const isAtMinQty = Number(item.quantity) <= minQty;
        const decrementQuantity = Math.max(item.quantity - minQty, 0);
        const isCrossSell = isCrossSellItem(item);
        const dependents = Array.isArray(crossSellDependents) ? crossSellDependents : [];
        const dependentsJsonAttr = escapeHtmlAttr(JSON.stringify(dependents));
        const productTitleAttr = escapeHtmlAttr(item.product_title || item.title || '');
        const primaryKeyAttr = escapeHtmlAttr(item.key);
        const hasCrossSellDependents = !isCrossSell && dependents.length > 0;
        
        // ACCESSIBILITY: Generate unique IDs for labeling
        const quantityIdBase = escapeHtmlAttr(item.key).replace(/[^a-zA-Z0-9]/g, '-');
        const quantityIdSuffix = idSuffix ? `-${escapeHtmlAttr(idSuffix).replace(/[^a-zA-Z0-9]/g, '-')}` : '';
        const inputId = `quantity-input-${quantityIdBase}${quantityIdSuffix}`;
        const groupId = `quantity-group-${quantityIdBase}${quantityIdSuffix}`;

        // For read-only items (Try Now, Cross-sell, or alternate quantity Welcome Gifts).
        // Quantity Welcome Gifts may legitimately have quantity > 1. Show that quantity,
        // but do not expose +/- controls or allow the shopper to edit it.
        if (isTNProduct || isCrossSell || isQuantityWelcomeGift) {
            return `
<div class="firstday-cart__flyout-item-quantity" 
     id="${groupId}"
     role="group" 
     aria-label="Quantity for ${productTitleAttr}"${linkedKeyAttr}>
    <span class="visually-hidden">Quantity: </span>
    <input type="number" 
           value="${item.quantity}" 
           min="${minQty}" 
           class="quantity-input" 
           disabled 
           readonly
           aria-label="Quantity: ${item.quantity} (cannot be changed)"
           id="${inputId}">
</div>
`;
        }

        // ACCESSIBILITY: Build minus button with appropriate labels
        const decrementAriaLabel = isAtMinQty
            ? `Minimum quantity is ${minQty} for ${productTitleAttr}`
            : `Decrease quantity of ${productTitleAttr}`;
        
        const minusDisabledAttrs = isAtMinQty
            ? ' disabled aria-disabled="true"'
            : '';

        const minusButton = hasCrossSellDependents && isAtMinQty && minQty <= 1
            ? `<button type="button" 
                       class="quantity-btn minus" 
                       aria-label="Remove ${productTitleAttr} and associated items from cart"
                       onclick="handleCrossSellMainRemoval(event)" 
                       data-primary-key="${primaryKeyAttr}" 
                       data-dependents="${dependentsJsonAttr}" 
                       data-product-title="${productTitleAttr}">`
            : `<button type="button" 
                       class="quantity-btn minus${isAtMinQty ? ' is-at-min' : ''}" 
                       aria-label="${decrementAriaLabel}"
                       aria-describedby="${inputId}"${minusDisabledAttrs}
                       onclick="changeLineQty('${safeKeyForJs}', -1, '${safeLinkedKeyForJs}')">`;

        // Stepped packs (_qtyPerChange): display-only input — change qty via +/- only
        const steppedInputAttrs = hasQtyStep
            ? ` step="${minQty}" readonly tabindex="-1" aria-readonly="true" aria-label="Quantity: ${item.quantity} (use plus or minus to change by ${minQty})"`
            : ` onchange="updateQuantityInput('${safeKeyForJs}', this.value, '${safeLinkedKeyForJs}')"`;

        return `
        <div class="firstday-cart__flyout-item-quantity${isAtMinQty ? ' is-at-min' : ''}" 
             id="${groupId}"
             role="group" 
             data-min-qty="${minQty}"
             ${hasQtyStep ? `data-qty-step="${minQty}"` : ''}
             aria-label="Quantity controls for ${productTitleAttr}"${linkedKeyAttr}>
            ${minusButton}
                <span aria-hidden="true">${UI_ICONS.minus}</span>
            </button>
            <label for="${inputId}" class="visually-hidden">
                Quantity for ${productTitleAttr}
            </label>
            <input type="number" 
                   value="${item.quantity}" 
                   min="${minQty}" 
                   class="quantity-input${hasQtyStep ? ' quantity-input--stepped' : ''}"
                   id="${inputId}"
                   aria-live="polite"${steppedInputAttrs}>
            <button type="button" 
                    class="quantity-btn plus" 
                    aria-label="Increase quantity of ${productTitleAttr}"
                    aria-describedby="${inputId}"
                    onclick="changeLineQty('${safeKeyForJs}', 1, '${safeLinkedKeyForJs}')">
                <span aria-hidden="true">${UI_ICONS.plus}</span>
            </button>
        </div>
    `;
    }

    // Render remove button with accessibility enhancements
    function renderRemoveButton(item, safeKeyForJs, safeLinkedKeyForJs, crossSellDependents = []) {
        const dependents = Array.isArray(crossSellDependents) ? crossSellDependents : [];
        const dependentsJsonAttr = escapeHtmlAttr(JSON.stringify(dependents));
        const productTitleAttr = escapeHtmlAttr(item.product_title || item.title || '');
        const primaryKeyAttr = escapeHtmlAttr(item.key);
        const linkedKeyArg = safeLinkedKeyForJs || '';
        
        // ACCESSIBILITY: Include variant info in aria-label for better context
        const variantInfo = item.variant_title && item.variant_title !== 'Default Title' 
            ? ` (${escapeHtmlAttr(item.variant_title)})` : '';
        const fullProductLabel = `${productTitleAttr}${variantInfo}`;

        // ACCESSIBILITY: Add aria-label for screen readers
        if (!isCrossSellItem(item) && dependents.length > 0) {
            return `
            <button type="button" 
                    class="quantity-btn icon-remove" 
                    aria-label="Remove ${fullProductLabel} and associated items from cart"
                    onclick="handleCrossSellMainRemoval(event)" 
                    data-primary-key="${primaryKeyAttr}" 
                    data-dependents="${dependentsJsonAttr}" 
                    data-product-title="${productTitleAttr}">
                <span aria-hidden="true">${UI_ICONS.remove}</span>
            </button>
        `;
        }

        return `
        <button type="button" 
                class="quantity-btn icon-remove" 
                aria-label="Remove ${fullProductLabel} from cart"
                onclick="updateQuantity('${safeKeyForJs}', '0', '${linkedKeyArg}')">
            <span aria-hidden="true">${UI_ICONS.remove}</span>
        </button>
    `;
    }

    // Render subscription upgrade button
    async function renderSubscriptionButton(item) {
        const hasSubscription = item.selling_plan_allocation !== undefined;
        if (hasSubscription) {
            return '';
        }

        const isAddOnItem = item.handle && item.handle.includes('add-on');
        if (isAddOnItem) {
            return '';
        }

        // Gifts are free items, not sellable SKUs — never offer to upgrade to sub.
        if (isGiftItem(item)) {
            return '';
        }

        // Legacy behavior (toggle off): hide the OTP→sub upgrade button when the
        // active PDP is in auto-apply-on-sub mode, because mid-cart toggling at
        // the page level would mix coupon codes (e.g. springtime50 ↔ refresh).
        //
        // New behavior (toggle on): the per-line _sub_discount_code,
        // _sub_discount_percentage, and _if_upgrade__selling_plan_id stamped on the item
        // make the upgrade self-contained — clicking the button rewrites the
        // line to its own sub plan + sub code without affecting other lines —
        // so the button is safe to show even when the OTP and sub codes differ.
        const useLineItemProperties = document.querySelector('#main-nav')?.dataset?.useLineItemProperties === 'true';
        const lineDiscount = resolveLineDiscount(item);
        if (!useLineItemProperties && lineDiscount.autoApplyOnSub) {
            return '';
        }

        // Check metafield to see if button should be hidden
        try {
            const shouldHideButton = await window.Storefront.productHideSubscribeButtonById(item.product_id);
            if (shouldHideButton) {
                return '';
            }
        } catch (error) {
            console.error('Error checking hide subscribe button metafield:', error);
            // Continue to show button on error (fail safe)
        }

        // Deliberately don't surface a specific % in the button label: the
        // actual subscription discount is configured in Stay AI (the subscription
        // platform), not in the theme. A stamped _sub_discount_percentage may
        // reflect the storefront promo at add-time but won't include the extra
        // Stay AI subscriber discount, so showing a number here would understate
        // the saving and risk being wrong if Stay AI's setup changes.
        // ACCESSIBILITY: Generate unique IDs for accessibility
        const buttonId = `subscribe-btn-${escapeHtmlAttr(item.key).replace(/[^a-zA-Z0-9]/g, '-')}`;
        const descriptionId = `subscribe-desc-${escapeHtmlAttr(item.key).replace(/[^a-zA-Z0-9]/g, '-')}`;
        const productTitleAttr = escapeHtmlAttr(item.product_title || item.title || '');

        return `
        <div class="firstday-cart__flyout-item-subscription">
            <p id="${descriptionId}" class="visually-hidden">
                Convert ${productTitleAttr} to a subscription and save more on this item
            </p>
            <button type="button"
                    id="${buttonId}"
                    class="firstday-button firstday-cart__checkout-button block new-mini-cart-checkout-button firstday_secundary_minicart_button"
                    aria-describedby="${descriptionId}"
                    onclick="upgradeToSubscription('${escapeForSingleQuote(item.key)}')">
                Subscribe &amp; Save More
            </button>
        </div>
    `;
    }

    // Helper function to calculate total from elements with specified name attribute
    // Made globally available for use by other components (e.g., gift progress)
    window.calculateTotalFromNamedElements = function(elementName, scope) {
        const root = scope || document;
        const elements = root === document
            ? document.getElementsByName(elementName)
            : root.querySelectorAll('[name="' + elementName + '"]');
        let total = 0;

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const visible = element.querySelector('[aria-hidden="true"]');
            const textContent = ((visible && visible.textContent) || element.textContent || '');
            const cents = convertMoneyValueToCents(textContent);

            if (cents != null && cents > 0) {
                total += cents;
            }
        }

        return total;
    };

    // Helper function to calculate both sale-price and compare-at-price totals
    // Made globally available for use by other components (e.g., gift progress)
    window.calculateCartTotalsFromElements = function() {
        const cartRoot = document.getElementById('main-nav');
        const scope = cartRoot || document;
        return {
            salePriceTotal: window.calculateTotalFromNamedElements('sale-price', scope),
            compareAtTotal: window.calculateTotalFromNamedElements('compare-at-price', scope)
        };
    };

    // Gift progress must use the theme-discounted cart total (e.g. FIREWORKS 40% off),
    // not cart.js total_price which omits stamped line-item discounts.
    function isGiftProgressExcludedItem(item) {
        if (!item) return true;

        const properties = item.properties || {};
        if (isGiftItem(item)) return true;
        if (normalizeBoolean(properties._free_unlock)) return true;
        if (item.__isGwp === true) return true;

        const tryNowSellingPlanMatches = TRY_NOW_SELLING_PLAN_ID && [
            safeString(properties._selling_plan),
            safeString(item.selling_plan),
            safeString(item.selling_plan_allocation?.selling_plan?.id)
        ].some(id => id && id === TRY_NOW_SELLING_PLAN_ID);
        if (tryNowSellingPlanMatches || normalizeBoolean(properties._is_try_now)) return true;
        if (normalizeBoolean(properties._prevent_subscription)) return true;

        const title = safeString(item.product_title || item.title).toLowerCase();
        const handle = safeString(item.handle).toLowerCase();
        const productType = safeString(item.product_type).toLowerCase();

        if (title.includes('checkout+') || title.includes('satisfaction guarantee')) return true;
        if (title.includes('package protection') || title.includes('delivery protection')) return true;
        if (title.includes('shipping protection') || title.includes('route protection')) return true;
        if (handle.includes('checkout') && (handle.includes('protection') || handle.includes('guarantee'))) {
            return true;
        }
        if (productType === 'insurance' || productType === 'protection') return true;

        return false;
    }

    window.readCartFooterTotals = function() {
        const saleEl = document.querySelector(
            '#main-nav .firstday-cart__flyout-subtotal.original-price .mini-cart-price.sale [aria-hidden="true"]'
        );
        if (!saleEl) return null;

        const saleCents = convertMoneyValueToCents(saleEl.textContent || '');
        if (saleCents == null || saleCents <= 0) return null;

        const compareEl = document.querySelector(
            '#main-nav .firstday-cart__flyout-subtotal.original-price #cartTotalPrice [aria-hidden="true"]'
        );
        const compareCents = compareEl
            ? convertMoneyValueToCents(compareEl.textContent || '')
            : null;

        return {
            salePriceTotal: saleCents,
            compareAtTotal: (compareCents != null && compareCents > 0) ? compareCents : saleCents
        };
    };

    window.calculateGiftProgressTotalsFromCart = function(cart) {
        const result = { salePriceTotal: 0, compareAtTotal: 0 };
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
            return result;
        }

        cart.items.forEach(item => {
            const quantity = item.quantity || 1;
            if (!quantity || isGiftProgressExcludedItem(item)) return;

            const properties = item.properties || {};
            const lineDiscount = resolveCartLineDiscount(item);
            if (lineDiscount.source === 'cart') {
                result.salePriceTotal += lineDiscount.finalLineTotal;
                result.compareAtTotal += lineDiscount.originalLineTotal;
                return;
            }

            const price = item.price || 0;
            const originalPrice = item.original_price || price;
            const hasSubscription = item.selling_plan_allocation !== undefined;

            if (isCrossSellItem(item)) {
                const isAddOnItem = item.handle && item.handle.includes('add-on');
                const sellingPlanAllocation = item.selling_plan_allocation || {};
                const discountedUnitPrice = (sellingPlanAllocation.price !== undefined ? sellingPlanAllocation.price : price) || 0;
                const basePriceFallback = price || discountedUnitPrice || 0;

                let baseUnitPrice;
                let finalDiscountedPrice;

                if (isAddOnItem) {
                    const promoPriceCents = parsePriceCents(properties._bfcm_add_on_promo_price);
                    const fullPriceCents = parsePriceCents(properties._bfcm_add_on_full_price);
                    finalDiscountedPrice = promoPriceCents != null ? promoPriceCents : basePriceFallback;
                    const fallbackBase = finalDiscountedPrice > 0 ? finalDiscountedPrice * 2 : basePriceFallback * 2;
                    baseUnitPrice = fullPriceCents != null ? fullPriceCents : fallbackBase;
                } else {
                    baseUnitPrice = sellingPlanAllocation.compare_at_price !== undefined
                        ? sellingPlanAllocation.compare_at_price
                        : (item.compare_at_price || originalPrice || 0);
                    if ((!baseUnitPrice || baseUnitPrice <= discountedUnitPrice) && discountedUnitPrice > 0) {
                        baseUnitPrice = Math.round(discountedUnitPrice / CROSS_SELL_DISCOUNT_RATE);
                    }
                    finalDiscountedPrice = discountedUnitPrice;
                }

                const compareAtTotal = baseUnitPrice * quantity;
                const discountedTotal = finalDiscountedPrice * quantity;
                result.salePriceTotal += discountedTotal;
                if (compareAtTotal > discountedTotal) {
                    result.compareAtTotal += compareAtTotal;
                }
                return;
            }

            if (hasSubscription) {
                const sellingPlanAllocation = item.selling_plan_allocation || {};
                const subscriptionUnitPrice = sellingPlanAllocation.price !== undefined ? sellingPlanAllocation.price : price;
                const compareAtUnitPrice = sellingPlanAllocation.compare_at_price !== undefined
                    ? sellingPlanAllocation.compare_at_price
                    : originalPrice;

                let subscriptionTotal = subscriptionUnitPrice * quantity;
                if (lineDiscount.hasLineDiscount) {
                    subscriptionTotal = Math.round(discountedLineTotal(subscriptionUnitPrice, quantity, lineDiscount));
                }

                const strikeUnitPrice = Math.max(compareAtUnitPrice || 0, originalPrice || 0);
                const compareAtTotal = strikeUnitPrice * quantity;
                result.salePriceTotal += subscriptionTotal;
                if (compareAtTotal > subscriptionTotal) {
                    result.compareAtTotal += compareAtTotal;
                }
                return;
            }

            const otpStrikeTotal = price * quantity;
            let otpFinalTotal = otpStrikeTotal;
            if (lineDiscount.hasLineDiscount) {
                otpFinalTotal = Math.round(discountedLineTotal(price, quantity, lineDiscount));
            }
            result.salePriceTotal += otpFinalTotal;
            if (otpStrikeTotal > otpFinalTotal) {
                result.compareAtTotal += otpStrikeTotal;
            }
        });

        return result;
    };

    window.calculateGiftProgressTotals = function(cart) {
        // Empty / missing cart → hard zero. Never fall back to stale DOM footer/line prices.
        if (!cart || !cart.item_count || !Array.isArray(cart.items) || !cart.items.length) {
            return { salePriceTotal: 0, compareAtTotal: 0 };
        }

        const fromCart = window.calculateGiftProgressTotalsFromCart(cart);
        if (fromCart.salePriceTotal > 0 || fromCart.compareAtTotal > 0) {
            return fromCart;
        }

        const footerTotals = window.readCartFooterTotals();
        if (footerTotals && footerTotals.salePriceTotal > 0) {
            return footerTotals;
        }

        const cartLinesRoot = document.getElementById('mini_cart_form');
        if (cartLinesRoot) {
            const salePriceTotal = window.calculateTotalFromNamedElements('sale-price', cartLinesRoot);
            const compareAtTotal = window.calculateTotalFromNamedElements('compare-at-price', cartLinesRoot);
            if (salePriceTotal > 0 || compareAtTotal > 0) {
                return { salePriceTotal, compareAtTotal };
            }
        }

        return { salePriceTotal: 0, compareAtTotal: 0 };
    };



    function normalizeDiscountCodeKey(value) {
        return safeString(value).trim().toUpperCase();
    }

    function getThemeGlobalCouponKey() {
        const ctx = typeof window !== 'undefined' ? window.__pageCartContext : null;
        return normalizeDiscountCodeKey((ctx && ctx.globalCode) || MINICART_THEME_GLOBAL_COUPON);
    }

    function itemKeepsDiscountCode(item) {
        if (!item) return false;
        if (isGiftItem(item) || isQuantityWelcomeGiftItem(item)) return false;
        const props = (item && item.properties) || {};
        if (normalizeBoolean(props._free_gift) || normalizeBoolean(props._welcome_kit_gift)) return false;
        return true;
    }

    function itemOwnsOverrideDiscountCode(item) {
        if (!itemKeepsDiscountCode(item)) return false;
        const props = (item && item.properties) || {};
        const module = safeString(props._upsell_module);
        if (
            module === 'cart_upsells' ||
            module === 'pdp_upsells' ||
            module === 'pdp_upsells_dialog'
        ) {
            return false;
        }
        if (safeString(props._discount_source) === 'cart_upsells') return false;
        return true;
    }

    function collectClaimedDiscountCodes(cart) {
        const claimed = new Set();
        (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (item) {
            if (!itemOwnsOverrideDiscountCode(item)) return;
            const props = (item && item.properties) || {};
            [
                props._otp_discount_code,
                props._sub_discount_code,
                props._upsell_discount_code,
                props._unlock_discount_code,
                props._discount_code_source
            ].forEach(function (code) {
                const key = normalizeDiscountCodeKey(code);
                if (key) claimed.add(key);
            });
        });
        return claimed;
    }

    function getAppliedDiscountCodes(cart) {
        return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [])
            .filter(function (entry) {
                return entry && entry.applicable !== false && entry.code;
            })
            .map(function (entry) {
                return entry.code;
            });
    }

    // Drops codes no paid line claims (BUNDLEBUILDER) after running writes end, then repaints from the prune's answer.
    function pruneUnclaimedDiscountCodes(cart, options) {
        if (!prunedDiscountCodes(cart) || (pruneWrite && !pruneWrite.sent)) return;
        beginCartWrite();
        const prune = writePrunedCodes(cart);
        const entry = pruneWrite;
        trackDrawerAction(prune.then(function (next) {
            if (!entry.sent || !next || next === cart || cartIsOlderThanDrawer(next)) return null;
            return updateCartDisplay(next, Object.assign({}, options, { changedKeys: null, skipDiscountPrune: true }));
        }).catch(function () {}).finally(function () {
            finishCartWrite();
            if (!pruneWrite) clearLinePricesPending();
        }));
    }

    // The codes the cart should hold, or null when it already holds them.
    function prunedDiscountCodes(cart) {
        const applied = getAppliedDiscountCodes(cart);
        if (!applied.length) return null;

        const claimed = collectClaimedDiscountCodes(cart);
        const globalKey = getThemeGlobalCouponKey();
        const hasPaidItems = (cart && Array.isArray(cart.items) ? cart.items : []).some(itemKeepsDiscountCode);
        // A page offer (page-cart-context) or a session offer (fd-offer-session.js,
        // FDOffer.active.replacesGlobal) replaces the sitewide code: do not put it back.
        // Without the FDOffer check, swapCartDiscount removed the sitewide code and this
        // put it back on every render, a write loop about once a second (2026-10-06).
        const sessionOffer = typeof window !== 'undefined' && window.FDOffer && window.FDOffer.active;
        const replacesGlobal = Boolean(
            typeof window !== 'undefined' &&
            ((window.__pageCartContext && window.__pageCartContext.replacesGlobalCode) ||
                (sessionOffer && sessionOffer.replacesGlobal))
        );

        // While a session offer replaces the sitewide offer, its codes play the sitewide
        // code's role: kept while merchandise remains. swapCartDiscount puts them on the
        // cart; dropping them here as unclaimed started a second write loop (2026-10-06).
        const sessionKeys = new Set();
        if (sessionOffer && sessionOffer.replacesGlobal) {
            [sessionOffer.subCode, sessionOffer.otpCode].forEach(function (code) {
                const key = normalizeDiscountCodeKey(code);
                if (key) sessionKeys.add(key);
            });
        }

        const keep = applied.filter(function (code) {
            const key = normalizeDiscountCodeKey(code);
            if (claimed.has(key)) return true;
            if (!hasPaidItems) return false;
            if (sessionKeys.has(key)) return true;
            return Boolean(globalKey && key === globalKey);
        });

        if (hasPaidItems && globalKey && !replacesGlobal) {
            const hasGlobal = keep.some(function (code) {
                return normalizeDiscountCodeKey(code) === globalKey;
            });
            if (!hasGlobal) {
                const globalCode = (window.__pageCartContext && window.__pageCartContext.globalCode) ||
                    MINICART_THEME_GLOBAL_COUPON;
                if (globalCode) keep.push(globalCode);
            }
        }

        const appliedKey = applied.map(normalizeDiscountCodeKey).sort().join('|');
        const keepKey = keep.map(normalizeDiscountCodeKey).sort().join('|');
        if (appliedKey === keepKey) return null;

        // The cart already holds exactly these codes, some as "not applicable" (the
        // sitewide code next to a better page code): writing would store the same
        // codes again and cost a full cart recalculation.
        if (cartHoldsExactCodes(cart, keep.map(normalizeDiscountCodeKey))) return null;

        return keep;
    }

    function cartHoldsExactCodes(cart, keys) {
        const onCartKeys = ((cart && cart.discount_codes) || []).map(function (entry) {
            return normalizeDiscountCodeKey(entry && entry.code);
        });
        return keys.every(function (key) { return onCartKeys.indexOf(key) !== -1; }) &&
            onCartKeys.every(function (key) { return keys.indexOf(key) !== -1; });
    }

    // Waiting prunes share one write, sent once cart writes end (overlapping writes undo gift fixes).
    let pruneWrite = null;

    function writePrunedCodes(cart) {
        if (pruneWrite && !pruneWrite.sent) return pruneWrite.promise;
        const entry = { sent: false, promise: null };
        entry.promise = sendPrunedCodes(cart, entry);
        pruneWrite = entry;
        entry.promise.finally(function () {
            if (pruneWrite === entry) pruneWrite = null;
        });
        return entry.promise;
    }

    async function sendPrunedCodes(cart, entry) {
        try {
            const gwp = window.FDCartGwp;
            const newest = gwp && typeof gwp.settledCart === 'function' ? await gwp.settledCart(cart) : cart;
            if (!newest) return cart;
            const keep = prunedDiscountCodes(newest);
            if (!keep) return newest;
            entry.sent = true;
            const discount = keep.length ? keep.join(',') : '';

            if (window.FDCartApi && typeof window.FDCartApi.updateCart === 'function') {
                return await window.FDCartApi.updateCart({
                    discount: discount
                });
            }

            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ discount: discount })
            });
            if (!response.ok) return cart;
            const nextCart = await response.json();
            if (window.FDCart) window.FDCart.setCart(nextCart);
            return nextCart;
        } catch (error) {
            console.warn('[MINICART] Failed pruning unclaimed discount codes', error);
            return cart;
        }
    }

    function resolveCartFooterCouponCodes(cart) {
        const codes = [];
        const seen = Object.create(null);

        function isHiddenFooterDiscount(raw) {
            const key = safeString(raw).trim().toUpperCase();
            if (!key) return true;
            if (key.indexOf('BULK ITEM VOLUME') !== -1) return true;
            const ctx = window.__pageCartContext;
            const offer = window.FDOffer && window.FDOffer.active;
            if ((ctx && ctx.replacesGlobalCode) || (offer && offer.replacesGlobal)) {
                const globalKey = safeString(
                    (window.FDOffer && window.FDOffer.globalCode) || ctx && ctx.globalCode || bfcmCouponCode
                ).trim().toUpperCase();
                if (globalKey && key === globalKey) return true;
            }
            return false;
        }

        function pushCode(raw) {
            const code = safeString(raw).trim();
            if (!code || isHiddenFooterDiscount(code)) return;
            const key = code.toUpperCase();
            if (seen[key]) return;
            seen[key] = true;
            codes.push(code);
        }

        if (cart && Array.isArray(cart.discount_codes)) {
            cart.discount_codes.forEach(function (entry) {
                if (entry && entry.applicable === false) return;
                pushCode(entry && entry.code);
            });
        }

        if (cart && Array.isArray(cart.items)) {
            cart.items.forEach(function (item) {
                const props = (item && item.properties) || {};
                pushCode(props._otp_discount_code);
                pushCode(props._sub_discount_code);
                pushCode(props._upsell_discount_code);
                pushCode(props._unlock_discount_code);

                const allocations = (item && item.line_level_discount_allocations) || [];
                allocations.forEach(function (alloc) {
                    const application = alloc && alloc.discount_application;
                    if (application && application.type === 'automatic') return;
                    pushCode(application && application.title);
                });

                const discount = resolveCartLineDiscount(item);
                if (discount && discount.hasLineDiscount) pushCode(discount.code);
            });
        }

        if (!codes.length && bfcmCouponCode) {
            pushCode(bfcmCouponCode);
        }

        return codes;
    }

    // Back-compat alias — callers that expect a single string still work.
    function resolveCartFooterCouponCode(cart) {
        return resolveCartFooterCouponCodes(cart).join(', ');
    }

    function formatCartFooterDiscountLabel(codes) {
        const list = Array.isArray(codes) ? codes.filter(Boolean) : [];
        if (!list.length) return '';
        if (list.length > 1) return 'Total with discounts';
        const escaped = String(list[0])
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
        return `Total with <strong>${escaped}</strong> code applied`;
    }

    const footerHtmlWrites = new WeakMap();

    function writeFooterHtml(element, html) {
        const last = footerHtmlWrites.get(element);
        if (last && last.html === html && element.innerHTML === last.rendered) return;
        element.innerHTML = html;
        footerHtmlWrites.set(element, { html, rendered: element.innerHTML });
    }

    // Update cart HTML content
    function updateCartHTMLContent(cartList, updatedCart, orderContainsSubscription, cartHasTNProducts, renderOptions) {
        renderOptions = renderOptions || {};
        const skipItemsInnerHTML = renderOptions.skipItemsInnerHTML === true;
        const cartCount = visibleCartCount(updatedCart);
        const cartTotal = updatedCart.items_subtotal_price;

        // Check if any item is a Try Now item
        let hasTryNowItems = false;
        if (updatedCart && Array.isArray(updatedCart.items)) {
            hasTryNowItems = updatedCart.items.some(item => {
                const properties = item.properties || {};
                const tryNowSellingPlanMatches = TRY_NOW_SELLING_PLAN_ID && [
                    safeString(properties._selling_plan),
                    safeString(item.selling_plan),
                    safeString(item.selling_plan_allocation?.selling_plan?.id)
                ].some(id => id && id === TRY_NOW_SELLING_PLAN_ID);
                return tryNowSellingPlanMatches || normalizeBoolean(properties._is_try_now);
            });
        }

        // Update the correct cart container with accessibility attributes
        const cartContainer = document.getElementById('mini_cart_form');
        if (cartContainer && !skipItemsInnerHTML) {
            // ACCESSIBILITY: Add list role and label for screen readers
            cartContainer.setAttribute('role', 'list');
            cartContainer.setAttribute('aria-label', `Shopping cart items, ${cartCount} ${cartCount === 1 ? 'item' : 'items'}`);
            renderCartLines(cartContainer, cartList.join(''));
        }
        if (cartContainer) {
            cartContainer.querySelectorAll('.fd-cart-predicted-hidden').forEach(function (el) {
                el.style.removeProperty('display');
                el.classList.remove('fd-cart-predicted-hidden');
            });
            cartContainer.querySelectorAll('.fd-cart-line-removing').forEach(function (el) {
                el.classList.remove('fd-cart-line-removing');
                el.removeAttribute('inert');
                el.removeAttribute('aria-hidden');
            });
        }


        // Update cart title — read base text from the section's data-base-title
        // attribute (set by sections/cart-drawer.liquid) so merchant edits in
        // the theme editor stick.
        const cartTitle = document.getElementById('SmartCart_title');
        if (cartTitle) {
            const baseTitle = cartTitle.dataset.baseTitle || 'Your Cart';
            cartTitle.textContent = `${baseTitle} (${cartCount})`;
        }
        
        // ACCESSIBILITY: Update cart button aria-label with item count
        const cartButton = document.querySelector('.js-menu__open[data-menu="#main-nav"]');
        if (cartButton) {
            const itemText = cartCount === 1 ? 'item' : 'items';
            cartButton.setAttribute('aria-label', 
                cartCount > 0 
                    ? `Open shopping cart, ${cartCount} ${itemText}` 
                    : 'Open shopping cart, empty'
            );
        }
        
        // ACCESSIBILITY: Update pulse bubble count for screen readers
        const pulseCountNumber = document.querySelector('.cart-count-number');
        if (pulseCountNumber) {
            pulseCountNumber.textContent = cartCount;
        }

        // Show/hide empty cart message and loading state
        const emptyCartMessage = document.querySelector('.firstday-cart__flyout-empty-cart');
        const emptyCartLoading = document.querySelector('.firstday-cart__flyout-empty-cart-loading');
        const cartContent = document.querySelector('.firstday-cart__flyout-content');
        const _cartContent = document.getElementById('mini_cart_form');


        if (cartCount === 0) {
            // Hide loading state and show empty message
            if (emptyCartLoading) emptyCartLoading.style.display = 'none';
            if (emptyCartMessage) emptyCartMessage.style.display = 'block';
            if (cartContent) cartContent.classList.remove('has-items');
            // Disable checkout button using button-loading-utility
            window.setButtonLoading('checkoutButton', true);
        } else {
            // Hide both loading and empty states when there are items
            if (emptyCartLoading) emptyCartLoading.style.display = 'none';
            if (emptyCartMessage) emptyCartMessage.style.display = 'none';
            if (cartContent) cartContent.classList.add('has-items');
            // Show cart content
            if (_cartContent && _cartContent.getAttribute('style') !== '') {
                _cartContent.style = 'block';
            }
            // Enable checkout button when cart has items using button-loading-utility
            window.setButtonLoading('checkoutButton', false);
        }

        // Update cart count elements safely
        const cartCountElements = document.querySelectorAll('.cart-count, #cartCount, [data-cart-count]');
        cartCountElements.forEach(element => {
            if (element) {
                element.textContent = cartCount;
            }
        });

        // Update total label and price based on TNProduct presence
        const totalLabelElement = document.getElementById('cartTotalLabel');
        const totalPriceElement = document.getElementById('cartTotalPrice');
        const totalSalePriceElement = totalPriceElement && totalPriceElement.parentElement
            ? totalPriceElement.parentElement.querySelector('.mini-cart-price.firstday-money.sale')
            : null;



        if (totalLabelElement && totalPriceElement) {
            if (cartCount === 0) {
                const formattedZero = Shopify.formatMoney(0, '$--amount--');

                totalLabelElement.textContent = 'Total:';
                totalPriceElement.innerHTML = `<span class="sr-only">Original price ${formattedZero}, strikethrough</span><span aria-hidden="true">${formattedZero}</span>`;
                totalPriceElement.classList.remove('compare-at', 'subscription-price');
                totalPriceElement.classList.add('no-strikethrough');

                if (totalSalePriceElement) {
                    totalSalePriceElement.innerHTML = `<span class="sr-only"></span><span aria-hidden="true"></span>`;
                    totalSalePriceElement.classList.remove('subscription-price');
                }
            } else if (cartHasTNProducts || hasTryNowItems) {
                totalLabelElement.textContent = 'Due today:';
                const formattedZero = Shopify.formatMoney(0, '$--amount--');
                totalPriceElement.innerHTML = `<span class="sr-only">Original price ${formattedZero}, strikethrough</span><span aria-hidden="true">${formattedZero}</span>`;
                totalPriceElement.classList.remove('compare-at', 'subscription-price');
                totalPriceElement.classList.add('no-strikethrough');
                if (totalSalePriceElement) {
                    totalSalePriceElement.innerHTML = `<span class="sr-only"></span><span aria-hidden="true"></span>`;
                    totalSalePriceElement.classList.remove('subscription-price');
                }
            } else {

         // Resolve coupon code(s) from cart discount_codes + stamped line props
const footerCouponCodes = resolveCartFooterCouponCodes(updatedCart);
const footerDiscountLabel = formatCartFooterDiscountLabel(footerCouponCodes);

if (footerDiscountLabel) {
    writeFooterHtml(totalLabelElement, footerDiscountLabel);
} else if (isBFCMPage) {
    writeFooterHtml(totalLabelElement, formatCartFooterDiscountLabel([bfcmCouponCode].filter(Boolean)) || 'Total:');
} else {
    totalLabelElement.textContent = 'Total:';
}

                // Calculate totals from individual item price elements
                const elementTotals = window.calculateCartTotalsFromElements();

                // Always refresh sale + compare — previously sale was skipped when
                // compareAtTotal was 0, which left a stale green total next to $0.00
                // after Intelligems wiped line igPrice nodes.
                if (totalSalePriceElement) {
                    const formattedSaleTotal = Shopify.formatMoney(elementTotals.salePriceTotal, '$--amount--');
                    writeFooterHtml(totalSalePriceElement, `<span class="sr-only">Sale price ${formattedSaleTotal}</span><span aria-hidden="true">${formattedSaleTotal}</span>`);
                }

                if (totalPriceElement) {
                    const showFooterCompare = elementTotals.compareAtTotal > elementTotals.salePriceTotal;
                    if (showFooterCompare) {
                        const formattedCompareTotal = Shopify.formatMoney(elementTotals.compareAtTotal, '$--amount--');
                        writeFooterHtml(totalPriceElement, `<span class="sr-only">Original price ${formattedCompareTotal}, strikethrough</span><span aria-hidden="true">${formattedCompareTotal}</span>`);
                    } else {
                        writeFooterHtml(totalPriceElement, `<span class="sr-only"></span><span aria-hidden="true"></span>`);
                    }
                    totalPriceElement.classList.toggle('no-strikethrough', !showFooterCompare);
                }

                if (orderContainsSubscription) {
                    const totalDisplay = buildCartTotalDisplayData(updatedCart);

                    if (totalDisplay.hasCompareAt && totalSalePriceElement) {
                        totalPriceElement.classList.add('compare-at');
                        totalPriceElement.classList.remove('subscription-price');
                        totalSalePriceElement.classList.add('subscription-price');
                    } else {
                        totalPriceElement.classList.add('subscription-price');
                        totalPriceElement.classList.remove('compare-at');
                        if (totalSalePriceElement) {
                            totalSalePriceElement.classList.remove('subscription-price');
                        }
                    }
                } else {
                    totalPriceElement.classList.remove('compare-at', 'subscription-price');

                    if (totalSalePriceElement) {
                        totalSalePriceElement.classList.remove('subscription-price');
                    }
                }

            }
        } else {
            console.error('[MINICART] Could not find total label or price elements');
        }

        // Update shipping information
        renderShippingInfo(cartTotal, orderContainsSubscription);

        if (typeof window.handleCartReserveTimer === 'function') {
            window.handleCartReserveTimer(cartCount);
        }

        if (window.PBFCM_Minicart && window.PBFCM_Minicart.giftProgress && typeof window.PBFCM_Minicart.giftProgress.updateAll === 'function') {
            window.PBFCM_Minicart.giftProgress.updateAll();
        }

        if (window.PBFCM_PDP && window.PBFCM_PDP.giftProgress && typeof window.PBFCM_PDP.giftProgress.refresh === 'function') {
            window.PBFCM_PDP.giftProgress.refresh(updatedCart);
        }

        if (!pendingCartWrites) setCartTotalsPending(false);
        if (quantityTargets.size) paintOptimisticQuantities();
    }

    // Render shipping information
    function renderShippingInfo(cartTotal, orderContainsSubscription) {
        const freeShippingThreshold = 5000; // $50.00 in cents
        const shippingLabel = document.getElementById('shipping-method-label');

        if (!shippingLabel) {
            console.warn('Shipping method label element not found');
            return;
        }

        if (orderContainsSubscription || cartTotal >= freeShippingThreshold) {
            shippingLabel.innerText = 'FREE U.S. Shipping';
        } else {
            shippingLabel.innerText = 'Calculated at checkout';
        }
    }

    function buildCartTotalDisplayData(updatedCart) {
        const result = {
            formattedTotal: Shopify.formatMoney(0, '$--amount--'),
            formattedCompareAt: Shopify.formatMoney(0, '$--amount--'),
            hasCompareAt: false,
        };

        if (!updatedCart || !Array.isArray(updatedCart.items) || updatedCart.items.length === 0) {
            return result;
        }

        let compareAtTotal = 0;
        let hasCompareAt = false;

        updatedCart.items.forEach(item => {
            const quantity = item.quantity || 0;
            if (quantity === 0) {
                return;
            }

            let unitPrice = item.price || 0;
            let compareAtUnitPrice = item.original_price !== undefined ? item.original_price : unitPrice;

            if (item.selling_plan_allocation) {
                const allocation = item.selling_plan_allocation;
                if (allocation.price !== undefined) {
                    unitPrice = allocation.price;
                }
                if (allocation.compare_at_price !== undefined) {
                    compareAtUnitPrice = allocation.compare_at_price;
                }
            }

            const linePrice = unitPrice * quantity;
            const lineCompareAt = compareAtUnitPrice * quantity;

            compareAtTotal += lineCompareAt;

            if (lineCompareAt > linePrice) {
                hasCompareAt = true;
            }
        });

        let totalPrice = updatedCart.total_price || 0;

        // Apply BFCM discount if enabled
        if (isBFCMPage) {
            totalPrice = totalPrice * bfcmDiscountMultiplier;
        }

        result.formattedTotal = Shopify.formatMoney(totalPrice, '$--amount--');
        result.formattedCompareAt = Shopify.formatMoney(compareAtTotal, '$--amount--');
        result.hasCompareAt = hasCompareAt;

        return result;
    }

    // Check if cart only contains TNProduct items (parallel checks)
    async function cartHasOnlyTNProducts(cart) {
        if (!cart.items || cart.items.length === 0) {
            return false;
        }

        const results = await Promise.all(cart.items.map(item => hasTNProductTag(item)));
        return results.every(isTN => isTN);
    }

    // Update cart display function (optimized with parallel processing)
    // GWP-on-subscription rule (toggle: settings.enable_gwp_subscription_rule).
    // Removes any line whose product carries GWP_SUBSCRIPTION_TAG once the cart no
    // longer contains a subscription. Returns true if it removed something (and
    // therefore kicked off a fresh render via applyBulkCartUpdates).
    async function removeGwpWhenNoSubscription(cart, hasSubscription, renderOptions) {
        if (!ENABLE_GWP_SUBSCRIPTION_RULE) return false;
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
        if (hasSubscription) return false;

        const tagResults = await Promise.all(
            cart.items.map(item => productHasTag(item, GWP_SUBSCRIPTION_TAG))
        );

        // A gift the bundle builder added was earned by the box, not by a subscription:
        // it stays on one-time boxes (checkout keeps it free, as the checkout-mode pages do).
        const updates = {};
        cart.items.forEach((item, i) => {
            const props = (item && item.properties) || {};
            if (normalizeBoolean(props._bundle_gift)) return;
            if (tagResults[i] && item && item.key) {
                updates[item.key] = 0;
            }
        });

        if (!Object.keys(updates).length) return false;

        await applyGiftRuleCorrection(updates, renderOptions);
        return true;
    }

    // Quantity Welcome Gifts are dependent on the base product that unlocked them.
    // The PDP controller stamps _gift_parent_product_id on each quantity gift.
    // After any cart mutation, remove gifts whose parent product is no longer present.
    // For older gift lines without parent metadata, only remove them when no normal
    // (non-quantity-gift) product remains, which avoids orphaned gift-only carts.
    async function removeOrphanQuantityWelcomeGifts(cart, renderOptions) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;

        const quantityGifts = cart.items.filter(function (item) {
            const props = (item && item.properties) || {};
            return normalizeBoolean(props._quantity_welcome_gift);
        });
        if (!quantityGifts.length) return false;

        const normalItems = cart.items.filter(function (item) {
            if (!item) return false;
            const props = item.properties || {};
            return !normalizeBoolean(props._quantity_welcome_gift);
        });

        const normalProductIds = new Set(
            normalItems
                .map(function (item) { return safeString(item && item.product_id); })
                .filter(Boolean)
        );

        const updates = {};
        quantityGifts.forEach(function (gift) {
            const props = gift.properties || {};
            const parentProductId = safeString(props._gift_parent_product_id).trim();

            const parentMissing = parentProductId
                ? !normalProductIds.has(parentProductId)
                : normalItems.length === 0;

            if (parentMissing && gift.key) {
                updates[gift.key] = 0;
            }
        });

        if (!Object.keys(updates).length) return false;

        console.log('[MINICART] Removing orphan quantity welcome gifts:', updates);
        await applyGiftRuleCorrection(updates, renderOptions);
        return true;
    }

    function applyGiftRuleCorrection(updates, renderOptions) {
        const gwp = window.FDCartGwp;
        const run = function () { return applyBulkCartUpdates(updates, renderOptions); };
        return gwp && typeof gwp.duringRuleCorrection === 'function' ? gwp.duringRuleCorrection(run) : run();
    }

    // The free lines leave in one write that keeps the codes, except gift lines a running gift sync pass is removing.
    function removeFreeLines(cart, renderOptions) {
        const gwp = window.FDCartGwp;
        const retry = Boolean(renderOptions && renderOptions.freeLinesRetry);
        const syncRemoves = !retry && Boolean(gwp && typeof gwp.isPending === 'function' && gwp.isPending());
        const updates = {};
        let skipped = false;
        cart.items.forEach(function (item) {
            if (syncRemoves && gwp.isCheckoutGwpLine(item)) {
                skipped = true;
                return;
            }
            updates[item.key] = 0;
        });
        if (skipped) repaintAfterGiftSync();
        if (!Object.keys(updates).length) return Promise.resolve();
        return applyGiftRuleCorrection(updates, renderOptions);
    }

    // Gift lines left to the gift sync: once it is idle, paint the newest cart once, and remove its free lines if any remain.
    let giftSyncRepaint = null;

    function repaintAfterGiftSync() {
        if (giftSyncRepaint) return giftSyncRepaint;
        const gwp = window.FDCartGwp;
        giftSyncRepaint = (async function () {
            if (typeof gwp.whenIdle === 'function') await gwp.whenIdle(8000);
            if (drawerBusy()) return;
            const cart = await newestServerCart();
            if (!cart || cart === committedCart || drawerBusy() || cartIsOlderThanDrawer(cart)) return;
            await updateCartDisplay(cart, { freeLinesRetry: true });
        })().catch(function () {}).finally(function () {
            giftSyncRepaint = null;
        });
        return giftSyncRepaint;
    }

    function cartHasOnlyGiftLines(cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
        return cart.items.every(function (item) {
            if (!item) return false;
            const props = item.properties || {};
            const isFree = Number(item.price) === 0 || Number(item.final_line_price) === 0;
            const isGift = isGiftItem(item) || item.__isGwp === true || normalizeBoolean(props._free_unlock);
            return isFree || isGift;
        });
    }

    // Bring an element in line with new markup, touching only what changed, so a
    // quantity change does not rebuild the whole line (and every observer on it).
    function morphNode(current, next) {
        if (current.nodeType !== next.nodeType || current.nodeName !== next.nodeName) {
            current.replaceWith(next);
            return;
        }
        if (current.nodeType !== 1) {
            if (current.nodeValue !== next.nodeValue) current.nodeValue = next.nodeValue;
            return;
        }
        if (current.isEqualNode(next)) return;
        if (current.classList.contains('jdgm-widget')) {
            current.replaceWith(next);
            return;
        }
        Array.from(current.attributes).forEach(function (attr) {
            if (!next.hasAttribute(attr.name)) current.removeAttribute(attr.name);
        });
        Array.from(next.attributes).forEach(function (attr) {
            if (current.getAttribute(attr.name) !== attr.value) current.setAttribute(attr.name, attr.value);
        });
        const currentChildren = Array.from(current.childNodes);
        const nextChildren = Array.from(next.childNodes);
        if (currentChildren.length !== nextChildren.length) {
            current.replaceChildren.apply(current, nextChildren);
            return;
        }
        for (let i = 0; i < currentChildren.length; i++) {
            morphNode(currentChildren[i], nextChildren[i]);
        }
    }

    function syncInputValues(root) {
        root.querySelectorAll('input[value]').forEach(function (input) {
            const value = input.getAttribute('value');
            if (input.type !== 'checkbox' && input.type !== 'radio' && input.value !== value) input.value = value;
        });
    }

    function parseSingleElement(html) {
        const template = document.createElement('template');
        template.innerHTML = String(html).trim();
        return template.content.childElementCount === 1 && template.content.childNodes.length === 1
            ? template.content.firstElementChild
            : null;
    }

    function lineIdentity(el) {
        return el.getAttribute('data-remove-key') || el.getAttribute('data-bundle-id') || '';
    }

    // Full render: keep the lines that did not change, update the ones that did.
    function renderCartLines(container, html) {
        const template = document.createElement('template');
        template.innerHTML = html;
        const nextLines = Array.from(template.content.children);
        const currentLines = Array.from(container.children).filter(function (el) {
            return !el.classList.contains('fd-cart-gift-pending');
        });
        const sameLines = nextLines.length === currentLines.length && nextLines.length > 0 &&
            template.content.childElementCount === nextLines.length &&
            nextLines.every(function (line, i) {
                const id = lineIdentity(line);
                return id && id === lineIdentity(currentLines[i]);
            });
        if (!sameLines) {
            container.innerHTML = html;
            return;
        }
        nextLines.forEach(function (line, i) { morphNode(currentLines[i], line); });
        syncInputValues(container);
    }

    // Patch specific line items in the DOM (qty/remove) without full re-render.
    async function patchCartLines(updatedCart, changedKeys, superseded) {
        const container = document.getElementById('mini_cart_form');
        if (!container || !Array.isArray(changedKeys) || !changedKeys.length) {
            return false;
        }

        try {
            tryNowLinkedKeys = await buildTryNowPairMap(updatedCart);
        } catch (error) {
            console.warn('Mini cart: failed to build TryNow pair map during patch', error);
        }

        const targets = changedKeys.map(function (key) {
            const safeKey = safeString(key);
            return {
                existing: drawerArticlesForKey(safeKey)[0] || null,
                index: updatedCart.items.findIndex(function (item) { return item.key === safeKey; })
            };
        });
        if (targets.some(function (target) { return target.index === -1 || !target.existing; })) {
            return false;
        }

        const htmls = await Promise.all(targets.map(function (target) {
            return renderCartItem(updatedCart, target.index);
        }));
        if (superseded && superseded()) return true;
        targets.forEach(function (target, i) {
            const next = parseSingleElement(htmls[i]);
            if (next) {
                morphNode(target.existing, next);
                syncInputValues(target.existing);
            } else {
                target.existing.outerHTML = htmls[i];
            }
        });

        return true;
    }

    function planUpgradeBackfillKeys(cart) {
        const ctx = window.FDCartContext;
        if (!ctx || typeof ctx.findPlanUpgradeSeed !== 'function' || !cart || !Array.isArray(cart.items)) return [];
        const seed = ctx.findPlanUpgradeSeed(cart.items);
        if (!seed) return [];
        return cart.items.filter(function (item) {
            return item && item.key && ctx.isEligibleForPlanUpgradeCopy(item, seed);
        }).map(function (item) { return item.key; });
    }

    function cartVersionOf(cart) {
        const store = window.FDCart;
        const version = store && typeof store.cartVersion === 'function' ? store.cartVersion(cart) : null;
        return typeof version === 'number' ? version : null;
    }

    function cartIsOlderThanDrawer(cart) {
        const version = cartVersionOf(cart);
        return version !== null && version < acceptedCartVersion;
    }

    // After a stale cart is dropped: once writes end, repaint the newest cart unless a newer paint is on its way.
    let staleCartRepaint = null;

    function repaintAfterStaleCart() {
        if (staleCartRepaint) return staleCartRepaint;
        staleCartRepaint = (async function () {
            await new Promise(function (resolve) { setTimeout(resolve, 0); });
            const store = window.FDCart;
            if (store && typeof store.whenWritesIdle === 'function') await store.whenWritesIdle(8000);
            if (committedGeneration !== cartRenderGeneration || drawerBusy()) return;
            if (latestCartState && store && typeof store.isCartCurrent === 'function' && store.isCartCurrent(latestCartState)) {
                await updateCartDisplay(latestCartState, {
                    skipDiscountPrune: true,
                    skipPlanUpgradeBackfill: true,
                    skipGwpSync: true,
                    skipRecommendations: true
                });
                return;
            }
            const cart = await newestServerCart();
            if (cart && !drawerBusy()) await updateCartDisplay(cart, { backgroundGwpSync: true });
        })().catch(function () {}).finally(function () {
            staleCartRepaint = null;
        });
        return staleCartRepaint;
    }

    async function updateCartDisplay(updatedCart, options) {
        options = options || {};

        if (cartIsOlderThanDrawer(updatedCart)) {
            repaintAfterStaleCart();
            return;
        }

        if (!options.skipDiscountPrune) pruneUnclaimedDiscountCodes(updatedCart, options);

        // Lines added elsewhere get the plan-upgrade props after the paint, then
        // repaint only if that write changed the cart. Those lines stay inert and
        // later quantity writes wait until it is done.
        async function repaintAfterPlanUpgradeBackfill() {
            if (options.skipPlanUpgradeBackfill || !window.FDCartApi || typeof window.FDCartApi.backfillPlanUpgrade !== 'function') {
                return false;
            }
            const keys = planUpgradeBackfillKeys(updatedCart);
            if (!keys.length) return false;
            const releases = keys.map(function (key) { return holdLine(key); });
            try {
                const nextCart = await runLineAction(function () {
                    return window.FDCartApi.backfillPlanUpgrade(updatedCart);
                }, { now: true });
                if (nextCart && nextCart !== updatedCart) {
                    await updateCartDisplay(nextCart, Object.assign({}, options, {
                        skipPlanUpgradeBackfill: true,
                        skipDiscountPrune: true
                    }));
                    return true;
                }
            } catch (error) {
                console.warn('Mini cart: plan upgrade backfill failed', error);
            } finally {
                releases.forEach(function (release) { release(); });
            }
            return false;
        }

        function syncGifts(renderOptions) {
            if (options.skipGwpSync || !window.FDCartGwp || typeof window.FDCartGwp.sync !== 'function') return null;
            const pending = window.FDCartGwp.sync(updatedCart, { renderOptions: renderOptions });
            return options.backgroundGwpSync ? null : pending;
        }

        let orderContainsSubscription = getCartContainsSubscription(updatedCart);

        const previousCartState = latestCartState;
        const prevForCompare = committedCart;
        latestCartState = updatedCart || null;
        const version = cartVersionOf(updatedCart);
        if (version !== null && version > acceptedCartVersion) acceptedCartVersion = version;
        const generation = ++cartRenderGeneration;
        const superseded = function () { return generation !== cartRenderGeneration; };
        if (lastConfirmedCart === updatedCart || !quantityWriteRunning) lastConfirmedCart = null;
        crossSellLinkedKeys = buildCrossSellPairMap(updatedCart);

        if (window.FDCart && window.FDCart.getCart() !== updatedCart) window.FDCart.setCart(updatedCart);

        // Keep alternate-layout quantity gifts dependent on their qualifying base product.
        // Run before the partial-render fast path so removals cannot leave orphan gifts behind.
        if (await removeOrphanQuantityWelcomeGifts(updatedCart, options)) {
            return;
        }

        const changedKeys = options.changedKeys;
        const productSetChanged = window.FDCart && prevForCompare
            ? window.FDCart.productSetChanged(prevForCompare, updatedCart)
            : null;
        const canPartial = Array.isArray(changedKeys) &&
            changedKeys.length &&
            prevForCompare &&
            window.FDCart &&
            !productSetChanged;

        if (canPartial) {
            const patched = await patchCartLines(updatedCart, changedKeys, superseded);
            if (patched) {
                const tnTagResults = await Promise.all(
                    updatedCart.items.map(function (item) { return hasTNProductTag(item); })
                );
                const cartHasTNProducts = tnTagResults.some(function (hasTag) { return hasTag; });

                if (superseded()) return;
                updateCartHTMLContent([], updatedCart, orderContainsSubscription, cartHasTNProducts, {
                    skipItemsInnerHTML: true
                });
                committedCart = updatedCart;
                committedGeneration = generation;
                keepPendingLook();
                paintNinetyDayCard(updatedCart).catch(function () {});
                updateMinicartAttributeInputs(updatedCart, orderContainsSubscription);
                if (await repaintAfterPlanUpgradeBackfill()) return;
                await syncGifts({ skipUpsells: true, skipRecommendations: true });
                return;
            }
        }

        try {
            tryNowLinkedKeys = await buildTryNowPairMap(updatedCart);
        } catch (error) {
            console.warn('Mini cart: failed to build TryNow pair map', error);
            tryNowLinkedKeys = {};
        }

        // Check if cart only contains TNProduct items, if so clear it
        if (await cartHasOnlyTNProducts(updatedCart)) {
            console.log('Cart only contains TNProduct items, clearing cart');
            await clearCart();
            return;
        }

        // GWP-on-subscription rule: drop gift lines that require an active
        // subscription once none remains. applyBulkCartUpdates re-renders with the
        // corrected cart, so bail out of this now-stale pass.
        if (await removeGwpWhenNoSubscription(updatedCart, orderContainsSubscription, options)) {
            return;
        }

        if (updatedCart.total_price === 0 && cartHasOnlyGiftLines(updatedCart)) {
            if (!superseded()) await removeFreeLines(updatedCart, options);
            return;
        }

        // Pre-fetch all TN tags in parallel (cache will be warm for renderCartItem)
        const tnTagPromises = updatedCart.items.map(item => hasTNProductTag(item));
        const tnTagResults = await Promise.all(tnTagPromises);
        const cartHasTNProducts = tnTagResults.some(hasTag => hasTag);

        await ensureParentPdpImages(updatedCart);

        // Lines render in parallel (each one waits on its own lookups); Promise.all
        // keeps the cart order.
        const bundlePlan = buildBundleGroups(updatedCart);
        const linePromises = [];
        for (let o = 0; o < bundlePlan.order.length; o++) {
            const entry = bundlePlan.order[o];
            if (entry.type === 'bundle') {
                const group = bundlePlan.groups.get(entry.id);
                linePromises.push(renderBuildBoxBundle(group));
                const bundleGifts = (group && group.gifts) || [];
                for (let g = 0; g < bundleGifts.length; g++) {
                    const giftIndex = updatedCart.items.indexOf(bundleGifts[g]);
                    if (giftIndex >= 0) {
                        linePromises.push(renderCartItem(updatedCart, giftIndex));
                    }
                }
            } else {
                linePromises.push(renderCartItem(updatedCart, entry.index));
            }
        }
        const cartList = await Promise.all(linePromises);

        if (superseded()) return;
        updateCartHTMLContent(cartList, updatedCart, orderContainsSubscription, cartHasTNProducts);
        committedCart = updatedCart;
        committedGeneration = generation;
        keepPendingLook();
        paintNinetyDayCard(updatedCart).catch(function () {});
        updateMinicartAttributeInputs(updatedCart, orderContainsSubscription);
        if (await repaintAfterPlanUpgradeBackfill()) return;

        // Populate recommendations section with metafield-based products
        if (!options.skipRecommendations && typeof populateRecommendations === 'function') {
            await populateRecommendations(updatedCart, previousCartState);
        }

        if (!options.skipRecommendations && typeof populateEmptyCartStarterPacks === 'function') {
            await populateEmptyCartStarterPacks(updatedCart);
        }

        await syncGifts({
            skipUpsells: options.skipUpsells,
            skipRecommendations: options.skipRecommendations
        });
    }

    window.__fdCartGwpRefresh = function (cart, renderOptions) {
        // A quantity tap on its way paints the newer cart it returns; until then the drawer keeps its look.
        if (quantityWriteRunning) return Promise.resolve();
        return updateCartDisplay(cart, Object.assign({ skipGwpSync: true }, renderOptions || {}));
    };

    // ---- Optimistic drawer actions --------------------------------------------
    // A drawer action paints its predicted result at once. Quantity taps share one
    // write in flight (taps in between only move the target, then one more write
    // sends the last target), the drawer reconciles with the cart that write
    // returns, and an error repaints the last cart the server confirmed.

    const quantityTargets = new Map();
    const quantityLinks = new Map();
    const quantityPrimaries = new Set();
    // Shopify can give a line a new key on a quantity write: old key, then the key it moved to.
    const movedLineKeys = new Map();
    let quantityWriteRunning = null;
    // Time of the last quantity tap, or of the end of its writes.
    let lastQuantityActivity = 0;
    // Quantity writes with the render that follows them.
    const quantityFlows = new Set();
    // The newest cart a drawer write returned, until the render that follows adopts it.
    let lastConfirmedCart = null;
    let pendingCartWrites = 0;
    const drawerActions = new Set();

    // A removed line keeps its place, faded and inert, until the write confirms, so a
    // second tap cannot land on the line below.
    function markLineRemoving(el) {
        el.classList.add('fd-cart-line-removing');
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
    }

    // Subscribe, the 90-day pill and the plan-upgrade backfill rewrite a line (its key
    // can change). They and the quantity writes take turns, in tap order.
    const lineActions = new Set();

    function runLineAction(task, options) {
        const waitFor = options && options.now
            ? []
            : Array.from(quantityFlows).concat(Array.from(lineActions));
        const run = Promise.all(waitFor.map(function (p) { return p.catch(function () {}); })).then(task);
        lineActions.add(run);
        const done = function () { lineActions.delete(run); };
        run.then(done, done);
        return trackDrawerAction(run);
    }

    // Lines a line action is rewriting: inert, and every repaint keeps the action's
    // look until it releases them.
    const busyLines = new Map();

    function setLineBusy(article, on) {
        article.classList.toggle('fd-cart-line-busy', on);
        if (on) {
            article.setAttribute('inert', '');
            article.setAttribute('aria-busy', 'true');
        } else {
            article.removeAttribute('inert');
            article.removeAttribute('aria-busy');
        }
    }

    function paintBusyLine(key) {
        const holds = busyLines.get(key);
        if (!holds) return;
        drawerArticlesForKey(key).forEach(function (article) {
            setLineBusy(article, true);
            holds.forEach(function (hold) {
                if (hold.paint) hold.paint(article);
            });
        });
    }

    function holdLine(key, paint) {
        const hold = { paint: paint || null };
        const holds = busyLines.get(key) || [];
        holds.push(hold);
        busyLines.set(key, holds);
        paintBusyLine(key);
        return function releaseLine() {
            const current = busyLines.get(key) || [];
            const index = current.indexOf(hold);
            if (index >= 0) current.splice(index, 1);
            if (current.length) return;
            busyLines.delete(key);
            drawerArticlesForKey(key).forEach(function (article) { setLineBusy(article, false); });
        };
    }

    // After a repaint from another flow: the taps still on their way and the lines
    // still being rewritten keep their look.
    function keepPendingLook() {
        busyLines.forEach(function (holds, key) { paintBusyLine(key); });
        if (quantityTargets.size) paintOptimisticQuantities();
        else refreshGiftPlaceholders(committedCart, false);
        // A prune on its way changes the codes, so line prices from the cart at hand wait for its repaint.
        if (pruneWrite) markAllLinePricesPending();
    }

    function trackDrawerAction(promise) {
        drawerActions.add(promise);
        const done = function () { drawerActions.delete(promise); };
        promise.then(done, done);
        return promise;
    }

    // Quantity taps queued or on their way: the gift sync plans on the cart they return.
    const quantityIdleWaiters = [];

    function whenQuantityWritesIdle(maxWait) {
        if (!quantityWriteRunning) return Promise.resolve();
        return new Promise(function (resolve) {
            quantityIdleWaiters.push(resolve);
            if (maxWait > 0) setTimeout(resolve, maxWait);
        });
    }

    window.FDCartDrawerWrites = {
        pending: function () { return drawerActions.size; },
        settled: function () { return Promise.allSettled(Array.from(drawerActions)); },
        quantityPending: function () { return Boolean(quantityWriteRunning); },
        whenQuantityIdle: whenQuantityWritesIdle,
        lastQuantityActivity: function () { return lastQuantityActivity; },
        paintedCart: function () { return committedCart; }
    };

    function beginCartWrite() {
        pendingCartWrites += 1;
        setCartTotalsPending(true);
    }

    function endCartWrite() {
        pendingCartWrites = Math.max(0, pendingCartWrites - 1);
    }

    // For flows whose final paint already ran while the write was still counted.
    function finishCartWrite() {
        endCartWrite();
        if (!pendingCartWrites) setCartTotalsPending(false);
    }

    function setCartTotalsPending(on) {
        const nav = document.getElementById('main-nav');
        if (nav && nav.classList.contains('fd-cart-totals-pending') !== Boolean(on)) {
            nav.classList.toggle('fd-cart-totals-pending', Boolean(on));
        }
    }

    function drawerArticlesForKey(key) {
        const container = document.getElementById('mini_cart_form');
        if (!container) return [];
        return Array.from(container.querySelectorAll('[data-remove-key]')).filter(function (el) {
            return el.getAttribute('data-remove-key') === key;
        });
    }

    function markLinePricesPending(articles) {
        articles.forEach(function (article) {
            article.querySelectorAll('.firstday-cart__flyout-item-price').forEach(function (block) {
                block.classList.add('fd-cart-price-pending');
            });
        });
    }

    function markAllLinePricesPending() {
        const container = document.getElementById('mini_cart_form');
        if (container) markLinePricesPending([container]);
    }

    function clearLinePricesPending() {
        const container = document.getElementById('mini_cart_form');
        if (!container) return;
        container.querySelectorAll('.fd-cart-price-pending').forEach(function (block) {
            block.classList.remove('fd-cart-price-pending');
        });
        keepPendingLook();
    }

    // Codes known to take a flat percentage off every line, so a line's discount
    // scales with its quantity. Anything else (bundle tiers, volume discounts) waits
    // for the server price.
    function isFlatPercentCode(title) {
        const key = normalizeDiscountCodeKey(title);
        if (!key) return false;
        const offer = window.FDOffer && window.FDOffer.active;
        const flat = [MINICART_THEME_GLOBAL_COUPON, bfcmCouponCode];
        if (offer && offer.replacesGlobal) flat.push(offer.subCode, offer.otpCode);
        return flat.some(function (code) { return normalizeDiscountCodeKey(code) === key; });
    }

    // The line at a new quantity, and whether its prices can be predicted exactly.
    function scaleCartLine(item, quantity) {
        const next = Object.assign({}, item, { quantity: quantity });
        const oldQuantity = Number(item.quantity) || 0;
        if (oldQuantity === quantity) return { item: next, exact: true };
        const unitOriginal = Number(item.original_price);
        const unitPrice = Number(item.price);
        if (!oldQuantity || !Number.isFinite(unitOriginal) || !Number.isFinite(unitPrice) ||
            Number(item.original_line_price) !== unitOriginal * oldQuantity) {
            return { item: next, exact: false };
        }
        const allocations = Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [];
        const originalLine = unitOriginal * quantity;
        let exact = true;
        let oldDiscount = 0;
        const nextAllocations = allocations.map(function (allocation) {
            const application = (allocation && allocation.discount_application) || {};
            const percent = parseFloat(application.value);
            const amount = Number(allocation && allocation.amount) || 0;
            oldDiscount += amount;
            if (application.type !== 'discount_code' || application.value_type !== 'percentage' ||
                !Number.isFinite(percent) || !isFlatPercentCode(application.title) ||
                Math.round(Number(item.original_line_price) * percent / 100) !== amount) {
                exact = false;
                return allocation;
            }
            return Object.assign({}, allocation, { amount: Math.round(originalLine * percent / 100) });
        });
        if (!exact || Number(item.final_line_price) !== Number(item.original_line_price) - oldDiscount) {
            return { item: next, exact: false };
        }
        const discount = nextAllocations.reduce(function (sum, allocation) {
            return sum + (Number(allocation.amount) || 0);
        }, 0);
        next.line_level_discount_allocations = nextAllocations;
        next.line_level_total_discount = discount;
        next.total_discount = discount;
        next.original_line_price = originalLine;
        next.line_price = unitPrice * quantity;
        next.final_line_price = originalLine - discount;
        next.final_price = Math.round(next.final_line_price / quantity);
        return { item: next, exact: true };
    }

    // The confirmed cart with the quantities still on their way applied.
    function predictCart(cart, quantities) {
        if (!cart || !Array.isArray(cart.items)) return null;
        const automatic = (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length > 0) ||
            cart.items.some(function (item) {
                return (item.line_level_discount_allocations || []).some(function (allocation) {
                    return allocation && allocation.discount_application && allocation.discount_application.type === 'automatic';
                });
            });
        const lines = {};
        const items = [];
        let itemCount = 0;
        let exact = !automatic;
        cart.items.forEach(function (item) {
            if (!quantities.has(item.key)) {
                items.push(item);
                itemCount += Number(item.quantity) || 0;
                return;
            }
            const quantity = quantities.get(item.key);
            if (quantity <= 0) {
                lines[item.key] = { item: null, exact: true };
                return;
            }
            const scaled = scaleCartLine(item, quantity);
            if (automatic) scaled.exact = false;
            if (!scaled.exact) exact = false;
            lines[item.key] = scaled;
            items.push(scaled.item);
            itemCount += quantity;
        });
        return {
            cart: Object.assign({}, cart, { items: items, item_count: itemCount }),
            lines: lines,
            exact: exact
        };
    }

    // A line's articles, including ones still shown under a key the line had before a write.
    function lineArticles(key, cart) {
        const container = document.getElementById('mini_cart_form');
        if (!container) return [];
        return Array.from(container.querySelectorAll('[data-remove-key]')).filter(function (el) {
            const at = el.getAttribute('data-remove-key');
            return at === key || currentLineKey(at, cart) === key;
        });
    }

    // Pending targets by the key each line has in this cart, so a tap made before a write gave its line a new key still paints.
    function targetsOn(cart) {
        const targets = new Map();
        const linked = new Set(Array.from(quantityLinks.keys()).concat(Array.from(quantityLinks.values())));
        quantityTargets.forEach(function (quantity, key) {
            if (cart.items.some(function (item) { return item.key === key; })) targets.set(key, quantity);
        });
        quantityTargets.forEach(function (quantity, key) {
            const at = linked.has(key) ? null : currentLineKey(key, cart);
            if (at && !targets.has(at)) targets.set(at, quantity);
        });
        return targets;
    }

    function paintPredictedLine(key, line, cart) {
        const articles = lineArticles(key, cart);
        if (!line.item) {
            articles.forEach(markLineRemoving);
            return;
        }
        const quantity = line.item.quantity;
        articles.forEach(function (article) {
            article.querySelectorAll('input.quantity-input').forEach(function (input) {
                if (input.value !== String(quantity)) input.value = String(quantity);
                if (input.getAttribute('value') !== String(quantity)) input.setAttribute('value', String(quantity));
            });
            article.querySelectorAll('.firstday-cart__flyout-item-quantity[data-min-qty]').forEach(function (group) {
                const minQty = parseInt(group.getAttribute('data-min-qty'), 10) || 1;
                const atMin = quantity <= minQty;
                group.classList.toggle('is-at-min', atMin);
                const minus = group.querySelector('button.quantity-btn.minus');
                if (!minus || minus.hasAttribute('data-dependents')) return;
                minus.classList.toggle('is-at-min', atMin);
                minus.disabled = atMin;
                if (atMin) minus.setAttribute('aria-disabled', 'true');
                else minus.removeAttribute('aria-disabled');
            });
        });
        if (!line.exact) {
            markLinePricesPending(articles);
            return;
        }
        const pricingHtml = renderItemPricing(line.item).trim();
        const detailsPricingHtml = pricingHtml
            .replace(/\s+id="[^"]*"/g, '')
            .replace(/\s+name="[^"]*"/g, '');
        articles.forEach(function (article) {
            article.querySelectorAll('.firstday-cart__flyout-item-price').forEach(function (block) {
                const inDetails = Boolean(block.closest('.ab-cart-drawer__details-price-and-controls'));
                const next = parseSingleElement(inDetails ? detailsPricingHtml : pricingHtml);
                if (next) morphNode(block, next);
            });
        });
    }

    function setTextIfChanged(el, text) {
        if (el && el.textContent !== String(text)) el.textContent = String(text);
    }

    function paintCartCounts(cart) {
        const itemCount = Number(cart.item_count) || 0;
        const badgeCount = typeof displayCartBadgeCount === 'function'
            ? displayCartBadgeCount(cart, itemCount)
            : itemCount;
        const cartTitle = document.getElementById('SmartCart_title');
        if (cartTitle) {
            const baseTitle = cartTitle.dataset.baseTitle || 'Your Cart';
            setTextIfChanged(cartTitle, `${baseTitle} (${itemCount})`);
        }
        const cartButton = document.querySelector('.js-menu__open[data-menu="#main-nav"]');
        if (cartButton) {
            const itemText = itemCount === 1 ? 'item' : 'items';
            const label = itemCount > 0 ? `Open shopping cart, ${itemCount} ${itemText}` : 'Open shopping cart, empty';
            if (cartButton.getAttribute('aria-label') !== label) cartButton.setAttribute('aria-label', label);
        }
        document.querySelectorAll('.cart-count-number, [data-cart-count]').forEach(function (el) {
            setTextIfChanged(el, itemCount);
        });
        document.querySelectorAll('.cart-count, #cartCount, .pulse-cart-bubble-number-of-items, .cart-bubble-number-of-items').forEach(function (el) {
            setTextIfChanged(el, badgeCount);
        });
    }

    function showPredictedEmptyState() {
        const emptyCartMessage = document.querySelector('.firstday-cart__flyout-empty-cart');
        const cartContent = document.querySelector('.firstday-cart__flyout-content');
        const container = document.getElementById('mini_cart_form');
        if (emptyCartMessage) emptyCartMessage.style.display = 'block';
        if (cartContent) cartContent.classList.remove('has-items');
        if (container) {
            Array.from(container.children).forEach(function (child) {
                child.style.display = 'none';
                child.classList.add('fd-cart-predicted-hidden');
            });
        }
        const ninetyDayCard = ninetyDayCardElement();
        if (ninetyDayCard) ninetyDayCard.hidden = true;
    }

    function paintOptimisticQuantities() {
        const base = lastConfirmedCart || latestCartState;
        if (!quantityTargets.size || !base) return;
        const predicted = Array.isArray(base.items) ? predictCart(base, targetsOn(base)) : null;
        if (!predicted) return;
        Object.keys(predicted.lines).forEach(function (key) {
            paintPredictedLine(key, predicted.lines[key], base);
        });
        paintCartCounts(predicted.cart);
        setCartTotalsPending(true);
        const paidLeft = predicted.cart.items.length > 0 && !cartHasOnlyGiftLines(predicted.cart);
        if (!paidLeft) showPredictedEmptyState();
        if (predicted.exact) refreshGiftPlaceholders(paidLeft ? predicted.cart : null, true);
        if (predicted.exact && window.PBFCM_Minicart && window.PBFCM_Minicart.giftProgress &&
            typeof window.PBFCM_Minicart.giftProgress.updateAll === 'function') {
            window.PBFCM_Minicart.giftProgress.updateAll(paidLeft ? predicted.cart : { items: [], item_count: 0 });
        }
    }

    // Repaint the last cart the server confirmed, without new cart writes.
    function rollbackDrawer(cart, keys) {
        const confirmed = cart && !cartIsOlderThanDrawer(cart) ? cart : latestCartState;
        if (!confirmed) return Promise.resolve();
        return updateCartDisplay(confirmed, {
            changedKeys: keys,
            skipDiscountPrune: true,
            skipPlanUpgradeBackfill: true,
            skipGwpSync: true
        });
    }

    // After a write that may have reached the server (network error, or a second
    // write failing after the first landed): paint a fresh read.
    async function repaintFromServer() {
        if (window.FDCartApi && typeof window.FDCartApi.getCart === 'function') {
            try {
                const cart = await window.FDCartApi.getCart(true);
                if (cart && Array.isArray(cart.items)) {
                    await updateCartDisplay(cart);
                    return;
                }
            } catch (error) {
                console.warn('Mini cart: cart read after a failed write failed', error);
            }
        }
        await rollbackDrawer(null);
    }

    // ---- Add to cart from the page ------------------------------------------------
    // The drawer opens at the click with the new lines as placeholders (no price, no
    // total, checkout waits), keeps the lines already in the cart, and paints the
    // confirmed cart once. Callers: CartUtilities.updateCartAfterAdd, product cards,
    // quick shop and postAdd.

    function pendingLineNode(line) {
        const title = safeString(line && line.title).trim();
        const quantity = Number(line && line.quantity) || 1;
        const image = safeString(line && line.image).trim();
        const node = document.createElement('div');
        node.className = 'fd-cart-pending-line fd-bb-cart-skeleton__row';
        node.setAttribute('role', 'listitem');
        node.setAttribute('aria-busy', 'true');
        node.setAttribute('aria-label', title ? `Adding ${title} to cart` : 'Adding to cart');
        node.innerHTML =
            (image
                ? `<span class="fd-bb-cart-skeleton__media fd-bb-cart-skeleton__media--image"><img src="${escapeHtmlAttr(image)}" alt="" width="64" height="64"></span>`
                : '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__media"></span>') +
            '<span class="fd-bb-cart-skeleton__lines">' +
            (title
                ? `<span class="fd-bb-cart-skeleton__title">${escapeHtmlAttr((quantity > 1 ? quantity + 'x ' : '') + title)}</span>`
                : '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar"></span>') +
            '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar fd-bb-cart-skeleton__bar--short"></span>' +
            '</span>' +
            '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__price"></span>';
        return node;
    }

    // A gift the cart earns shows as a placeholder line from the tap that earns it
    // (or from the paint the gift sync plans it on) until the gift line paints.
    const GIFT_PLACEHOLDER_MAX = 10000;
    let giftPlaceholderKey = '';
    let giftPlaceholderSince = 0;
    let giftPlaceholderTimer = null;
    let giftPlaceholderIdleWait = false;

    function plannedGiftAdds(cart) {
        const gwp = window.FDCartGwp;
        if (!cart || !gwp || typeof gwp.plannedAdds !== 'function') return [];
        try {
            return gwp.plannedAdds(cart);
        } catch (error) {
            return [];
        }
    }

    function plannedGiftRemovals(cart) {
        const gwp = window.FDCartGwp;
        if (!cart || !gwp || typeof gwp.plannedRemovals !== 'function') return [];
        try {
            return gwp.plannedRemovals(cart);
        } catch (error) {
            return [];
        }
    }

    // A gift line the cart no longer earns looks like a line on its way out until the gift sync removes it.
    function paintLeavingGifts(keys) {
        const container = document.getElementById('mini_cart_form');
        if (!container) return;
        container.querySelectorAll('[data-remove-key]').forEach(function (el) {
            el.classList.toggle('fd-cart-gift-leaving', keys.indexOf(el.getAttribute('data-remove-key')) !== -1);
        });
    }

    // Title and image from the gift progress cards, when one holds this gift.
    function giftCardFor(variantId) {
        const progress = window.PBFCM_Minicart && window.PBFCM_Minicart.giftProgress;
        const id = safeString(variantId).split('/').pop();
        let found = null;
        ((progress && progress.instances) || []).some(function (inst) {
            found = (inst.giftCards || []).find(function (card) {
                return card && safeString(card.variantId) === id;
            }) || null;
            return Boolean(found);
        });
        return found;
    }

    function paintGiftPlaceholders(gifts) {
        const container = document.getElementById('mini_cart_form');
        if (!container) return;
        const key = gifts.map(function (gift) { return safeString(gift.variantId); }).sort().join('|');
        const shown = Array.from(container.children).filter(function (el) {
            return el.classList.contains('fd-cart-gift-pending');
        });
        if (key === giftPlaceholderKey && shown.length === gifts.length) return;
        shown.forEach(function (node) { node.remove(); });
        giftPlaceholderKey = key;
        gifts.slice().reverse().forEach(function (gift) {
            const card = giftCardFor(gift.variantId);
            const node = pendingLineNode({
                title: card && card.title,
                image: card && card.imageUrl,
                quantity: gift.quantity || 1
            });
            node.classList.add('fd-cart-gift-pending');
            node.setAttribute('aria-label', 'Adding your free gift to cart');
            container.insertBefore(node, container.firstChild);
        });
    }

    // A predicted cart (taps on their way) shows the gifts it earns; a painted cart
    // shows them while the gift sync still runs. At most 10s in a row.
    function refreshGiftPlaceholders(cart, predicted) {
        const gwp = window.FDCartGwp;
        const syncing = Boolean(gwp && typeof gwp.isPending === 'function' && gwp.isPending());
        const leaving = predicted || syncing ? plannedGiftRemovals(cart) : [];
        paintLeavingGifts(leaving);
        const gifts = predicted || syncing ? plannedGiftAdds(cart) : [];
        if (!gifts.length) giftPlaceholderSince = 0;
        else if (!giftPlaceholderSince) giftPlaceholderSince = Date.now();
        const left = giftPlaceholderSince ? giftPlaceholderSince + GIFT_PLACEHOLDER_MAX - Date.now() : 0;
        paintGiftPlaceholders(left > 0 ? gifts : []);
        if (left <= 0) {
            clearTimeout(giftPlaceholderTimer);
            giftPlaceholderTimer = null;
        } else if (!giftPlaceholderTimer) {
            giftPlaceholderTimer = setTimeout(function () {
                giftPlaceholderTimer = null;
                recheckGiftPlaceholders();
            }, left + 20);
        }
        if (syncing && (left > 0 || leaving.length) && !giftPlaceholderIdleWait && typeof gwp.whenIdle === 'function') {
            giftPlaceholderIdleWait = true;
            gwp.whenIdle(left > 0 ? left : GIFT_PLACEHOLDER_MAX).then(function () {
                giftPlaceholderIdleWait = false;
                recheckGiftPlaceholders();
            });
        }
    }

    function recheckGiftPlaceholders() {
        if (!quantityTargets.size) {
            refreshGiftPlaceholders(committedCart, false);
            return;
        }
        const base = lastConfirmedCart || latestCartState;
        const predicted = base && Array.isArray(base.items) ? predictCart(base, targetsOn(base)) : null;
        if (predicted && predicted.exact) refreshGiftPlaceholders(predicted.cart, true);
    }

    // Title and image for a placeholder line, read from the card or block around el.
    function pendingLineFromElement(el, title, quantity) {
        let node = el && el.nodeType === 1 ? el : null;
        let image = '';
        while (node && node !== document.body) {
            const img = node.querySelector('img');
            if (img) {
                image = img.currentSrc || img.getAttribute('src') || '';
                break;
            }
            node = node.parentElement;
        }
        if (!title && node && node !== document.body) {
            const heading = node.querySelector('h2, h3, h4, [class*="title"]');
            title = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
        }
        return { title: title || '', image: image, quantity: quantity || 1 };
    }

    // Adds that overlap (a second card pressed before the first add returns) share
    // one paint, made after the last of them reports back.
    let pageAddGroup = null;
    const PAGE_ADD_SLOW_NOTE = 'Still adding. Check your connection.';
    const PAGE_ADD_SLOW_NOTE_DELAY = 3000;

    function newestServerCart() {
        const store = window.FDCart;
        const current = store && typeof store.getCurrentCart === 'function' ? store.getCurrentCart() : null;
        if (current) return Promise.resolve(current);
        return window.FDCartApi ? window.FDCartApi.getCart(true) : Promise.resolve(latestCartState);
    }

    // Another tab wrote the cart: repaint the server cart (no writes) when this page
    // comes back into view, and before the next quantity tap here picks its target.
    let seenOtherTabWrites = 0;
    let otherTabCatchUp = null;

    function otherTabWrites() {
        const store = window.FDCart;
        return store && typeof store.getOtherTabWrites === 'function' ? store.getOtherTabWrites() : 0;
    }

    function drawerBusy() {
        return Boolean(pageAddGroup || quantityWriteRunning || quantityFlows.size || lineActions.size);
    }

    function catchUpWithOtherTabs() {
        if (otherTabCatchUp) return otherTabCatchUp;
        const seen = otherTabWrites();
        if (seen === seenOtherTabWrites || !latestCartState || drawerBusy() || !window.FDCartApi) return Promise.resolve();
        seenOtherTabWrites = seen;
        otherTabCatchUp = (async function () {
            try {
                const cart = await window.FDCartApi.getCart(true);
                if (cart && !drawerBusy()) {
                    await updateCartDisplay(cart, {
                        skipDiscountPrune: true,
                        skipPlanUpgradeBackfill: true,
                        skipGwpSync: true
                    });
                }
            } catch (error) {
                // the next cart action repaints
            }
        })().finally(function () {
            otherTabCatchUp = null;
        });
        return otherTabCatchUp;
    }

    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') catchUpWithOtherTabs();
    });

    function drawerWritesRunning() {
        return Boolean(quantityWriteRunning || quantityFlows.size || lineActions.size);
    }

    function drawerWritesSettled(maxWait) {
        const running = Array.from(quantityFlows).concat(Array.from(lineActions), quantityWriteRunning ? [quantityWriteRunning] : []);
        const settled = Promise.all(running.map(function (p) { return p.catch(function () {}); }));
        return Promise.race([settled, new Promise(function (resolve) { setTimeout(resolve, maxWait); })]);
    }

    // Placeholders stay while the read is stalled (a second tap would add twice), so they say why.
    function showPageAddSlowNote(group) {
        let shown = false;
        group.tokens.forEach(function (token) {
            if (token.showSlowNote()) shown = true;
        });
        if (shown && typeof window.announceToScreenReader === 'function') {
            window.announceToScreenReader(PAGE_ADD_SLOW_NOTE);
        }
    }

    async function finishPageAddGroup(group) {
        if (pageAddGroup === group) pageAddGroup = null;
        if (!pageAddGroup) window.__fdCartRenderHold = null;
        const armSlowNote = function () {
            return setTimeout(function () { showPageAddSlowNote(group); }, PAGE_ADD_SLOW_NOTE_DELAY);
        };
        let slowNote = group.timedOut ? armSlowNote() : null;
        try {
            let cart = group.cart && group.tokens.length === 1 && !group.needsRead ? group.cart : null;
            // The add's read can predate a drawer write still running or already painted.
            if (cart && (drawerWritesRunning() || cartIsOlderThanDrawer(cart))) cart = null;
            if (!cart) {
                if (drawerWritesRunning()) await drawerWritesSettled(8000);
                if (!slowNote) slowNote = armSlowNote();
                cart = await newestServerCart();
            }
            if (cart) await updateCartDisplay(cart);
        } catch (error) {
            if (latestCartState) await rollbackDrawer(null);
        } finally {
            clearTimeout(slowNote);
            group.tokens.forEach(function (token) { token.removePlaceholders(); });
            if (!pendingCartWrites) setCartTotalsPending(false);
            group.settles.forEach(function (settle) { settle(); });
        }
    }

    // An add that reports back after its group already painted (the 15s fallback):
    // repaint the newest cart unless another drawer action is about to paint.
    async function repaintAfterLateAdd() {
        if (pageAddGroup || quantityWriteRunning || lineActions.size) return;
        try {
            const cart = await newestServerCart();
            if (cart && !pageAddGroup) await updateCartDisplay(cart);
        } catch (readError) {
            // the next cart action repaints
        }
    }

    function beginPageAdd(lines) {
        if (!pageAddGroup) pageAddGroup = { tokens: [], open: [], settles: [], cart: null, needsRead: false, timedOut: false };
        const group = pageAddGroup;
        const container = document.getElementById('mini_cart_form');
        const nodes = [];
        const list = Array.isArray(lines) && lines.length ? lines : [{}];
        if (container) {
            list.slice().reverse().forEach(function (line) {
                const node = pendingLineNode(line);
                container.insertBefore(node, container.firstChild);
                nodes.push(node);
            });
            const emptyCartMessage = document.querySelector('.firstday-cart__flyout-empty-cart');
            const emptyCartLoading = document.querySelector('.firstday-cart__flyout-empty-cart-loading');
            const cartContent = document.querySelector('.firstday-cart__flyout-content');
            const starterPacks = document.getElementById('mini_cart_empty_starter_packs_wrap');
            if (emptyCartMessage) emptyCartMessage.style.display = 'none';
            if (emptyCartLoading) emptyCartLoading.style.display = 'none';
            if (cartContent) cartContent.classList.add('has-items');
            if (starterPacks) starterPacks.hidden = true;
            container.style.display = '';
        }
        window.__fdCartRenderHold = { until: Date.now() + 12000 };
        beginCartWrite();
        trackDrawerAction(new Promise(function (resolve) { group.settles.push(resolve); }));

        // False when this add already reported back (or timed out).
        function close() {
            const index = group.open.indexOf(token);
            if (index < 0) return false;
            group.open.splice(index, 1);
            endCartWrite();
            return true;
        }

        const token = {
            confirm: async function (cart) {
                if (!close()) return repaintAfterLateAdd();
                if (cart) group.cart = cart;
                if (!group.open.length) await finishPageAddGroup(group);
            },
            fail: async function () {
                if (!close()) return repaintAfterLateAdd();
                token.removePlaceholders();
                group.needsRead = true;
                if (!group.open.length) await finishPageAddGroup(group);
            },
            removePlaceholders: function () {
                nodes.forEach(function (node) { node.remove(); });
            },
            showSlowNote: function () {
                let shown = false;
                nodes.forEach(function (node) {
                    const bar = node.isConnected ? node.querySelector('.fd-bb-cart-skeleton__bar--short') : null;
                    if (!bar) return;
                    const note = document.createElement('span');
                    note.className = 'fd-bb-cart-skeleton__meta fd-cart-pending-line__note';
                    note.textContent = PAGE_ADD_SLOW_NOTE;
                    bar.replaceWith(note);
                    node.setAttribute('aria-label', `${node.getAttribute('aria-label') || 'Adding to cart'}. ${PAGE_ADD_SLOW_NOTE}`);
                    shown = true;
                });
                return shown;
            }
        };
        group.tokens.push(token);
        group.open.push(token);
        // A flow that never reports back still ends with the real cart on screen.
        setTimeout(function () {
            if (!close()) return;
            group.needsRead = true;
            group.timedOut = true;
            if (!group.open.length) finishPageAddGroup(group);
        }, 15000);
        if (typeof toggleCartOpen === 'function') toggleCartOpen();
        return token;
    }

    // The newest add still waiting, so a flow that began at the click can join it.
    function currentPageAdd() {
        return pageAddGroup && pageAddGroup.open.length
            ? pageAddGroup.open[pageAddGroup.open.length - 1]
            : null;
    }

    window.FDCartPageAdd = {
        begin: beginPageAdd,
        current: currentPageAdd,
        lineFromElement: pendingLineFromElement
    };

    async function postCartJson(url, body) {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
        });
        let data = null;
        try {
            data = await response.json();
        } catch (error) {
            data = null;
        }
        if (!response.ok) {
            const err = new Error((data && (data.description || data.message)) || `Cart update failed with status ${response.status}`);
            err.status = response.status;
            err.data = data;
            throw err;
        }
        return data;
    }

    // Quantity-only changes go through /cart/update.js: the Regios cart embed
    // re-reads the whole page after every /cart/change.js.
    async function sendQuantities(updates) {
        const keys = Object.keys(updates);
        try {
            return await postCartJson('/cart/update.js', { updates: updates });
        } catch (error) {
            if (error.status === 422 || keys.length !== 1 || !error.status || error.status >= 500) throw error;
            const key = keys[0];
            try {
                return await postCartJson('/cart/change.js', { id: key, quantity: updates[key] });
            } catch (changeError) {
                if (changeError.status !== 400 || !key.includes(':')) throw changeError;
                return postCartJson('/cart/change.js', { id: key.split(':')[0], quantity: updates[key] });
            }
        }
    }

    // The line a quantity write gave a new key: the only line of the same variant, plan
    // and properties, absent before the write, holding the quantity that was sent.
    function rekeyedLine(key, sentQuantity, before, after) {
        if (sentQuantity == null || !before || !after || !Array.isArray(before.items) || !Array.isArray(after.items)) return null;
        const planOf = function (item) {
            const allocation = item.selling_plan_allocation;
            return allocation && allocation.selling_plan ? String(allocation.selling_plan.id) : '';
        };
        const propsOf = function (item) { return JSON.stringify(item.properties || {}); };
        const old = before.items.find(function (item) { return item.key === key; });
        if (!old) return null;
        const beforeKeys = new Set(before.items.map(function (item) { return item.key; }));
        const matches = after.items.filter(function (item) {
            return !beforeKeys.has(item.key) && item.variant_id === old.variant_id &&
                planOf(item) === planOf(old) && propsOf(item) === propsOf(old) &&
                Number(item.quantity) === Number(sentQuantity);
        });
        return matches.length === 1 ? matches[0].key : null;
    }

    function noteMovedLineKeys(updates, before, after) {
        if (!after || !Array.isArray(after.items)) return;
        Object.keys(updates).forEach(function (key) {
            if (after.items.some(function (item) { return item.key === key; })) return;
            const moved = rekeyedLine(key, updates[key], before, after);
            if (moved) movedLineKeys.set(key, moved);
        });
    }

    // The key a line has in this cart, following the keys earlier quantity writes gave it; null once it is gone.
    function currentLineKey(key, cart) {
        if (!key || !cart || !Array.isArray(cart.items)) return null;
        const seen = new Set();
        let at = key;
        while (at && !seen.has(at)) {
            if (cart.items.some(function (item) { return item.key === at; })) return at;
            seen.add(at);
            at = movedLineKeys.get(at);
        }
        return null;
    }

    // A tap on a line the drawer has not repainted yet carries its old key: send it to the key the line has now.
    function tappedLineKey(key) {
        if (!key || quantityTargets.has(key) || getCartItemByKey(key)) return key;
        return currentLineKey(key, latestCartState) || key;
    }

    function runQuantityWrites() {
        if (quantityWriteRunning) return quantityWriteRunning;
        beginCartWrite();
        const waitFor = Array.from(lineActions);
        quantityWriteRunning = trackDrawerAction((async function () {
            await Promise.resolve();
            if (waitFor.length) {
                await Promise.all(waitFor.map(function (p) { return p.catch(function () {}); }));
            }
            // The server can drop a write sent beside a gift write, so a tap waits for its answer.
            const gwp = window.FDCartGwp;
            if (gwp && typeof gwp.whenGiftWriteDone === 'function') await gwp.whenGiftWriteDone(3000);
            const sent = new Map();
            const touched = new Set();
            let confirmed = null;
            let beforeWrite = null;
            let failure = null;
            try {
                for (;;) {
                    const updates = {};
                    // A line action that ran first can have replaced the line.
                    const known = confirmed || (waitFor.length ? latestCartState : null);
                    const linkedTo = new Set(quantityLinks.values());
                    quantityTargets.forEach(function (quantity, key) {
                        if (sent.get(key) === quantity) return;
                        if (known && !known.items.some(function (item) { return item.key === key; })) {
                            const moved = quantityLinks.has(key) || linkedTo.has(key) ? null : currentLineKey(key, known);
                            sent.set(key, quantity);
                            if (moved && !quantityTargets.has(moved) && !(moved in updates)) {
                                updates[moved] = quantity;
                                if (quantityPrimaries.delete(key)) quantityPrimaries.add(moved);
                            }
                            return;
                        }
                        updates[key] = quantity;
                        const linked = quantityLinks.get(key);
                        if (linked) updates[linked] = quantity;
                    });
                    const keys = Object.keys(updates);
                    if (!keys.length) break;
                    keys.forEach(function (key) {
                        sent.set(key, updates[key]);
                        touched.add(key);
                    });
                    beforeWrite = known || latestCartState;
                    confirmed = await sendQuantities(updates);
                    lastConfirmedCart = confirmed;
                    noteMovedLineKeys(updates, beforeWrite, confirmed);
                }
            } catch (error) {
                failure = error;
            }
            const primaries = Array.from(quantityPrimaries);
            quantityTargets.clear();
            quantityLinks.clear();
            quantityPrimaries.clear();
            quantityWriteRunning = null;
            lastQuantityActivity = Date.now();
            quantityIdleWaiters.splice(0).forEach(function (resolve) { resolve(); });
            endCartWrite();
            const keys = Array.from(touched);
            if (failure) {
                console.error('Error updating quantity:', failure);
                await rollbackDrawer(confirmed, keys);
                if (typeof window.announceToScreenReader === 'function') {
                    window.announceToScreenReader('Error updating cart. Please try again.', 'assertive');
                }
                return;
            }
            if (!confirmed) {
                if (waitFor.length) await rollbackDrawer(null);
                return;
            }
            await updateCartDisplay(confirmed, { changedKeys: keys, backgroundGwpSync: true });
            if (typeof updateCartCount === 'function') {
                updateCartCount(confirmed.item_count);
            }
            if (typeof window.announceToScreenReader === 'function') {
                primaries.forEach(function (key) {
                    const line = (confirmed.items || []).find(function (item) { return item.key === key; });
                    window.announceToScreenReader(line
                        ? `Quantity updated to ${line.quantity} for ${line.product_title || 'Item'}.`
                        : 'Item removed from cart.');
                });
            }
        })());
        const flow = quantityWriteRunning;
        quantityFlows.add(flow);
        const flowDone = function () { quantityFlows.delete(flow); };
        flow.then(flowDone, flowDone);
        return flow;
    }

    function requestLineQuantity(key, quantity, linkedKey) {
        lastQuantityActivity = Date.now();
        quantityTargets.set(key, quantity);
        quantityPrimaries.add(key);
        if (linkedKey) {
            quantityLinks.set(key, linkedKey);
            quantityTargets.set(linkedKey, quantity);
        }
        const running = runQuantityWrites();
        // The write leaves first; the prediction still paints before the next frame.
        queueMicrotask(paintOptimisticQuantities);
        return running;
    }

    function displayedLineQuantity(key) {
        if (quantityTargets.has(key)) return quantityTargets.get(key);
        const source = lastConfirmedCart || latestCartState;
        const item = source && Array.isArray(source.items)
            ? source.items.find(function (line) { return line.key === key; })
            : null;
        return item ? Number(item.quantity) : NaN;
    }

    async function changeLineQty(key, delta, linkedKey = '') {
        let normalizedKey = safeString(key);
        if (otherTabCatchUp || (!quantityTargets.has(normalizedKey) && otherTabWrites() !== seenOtherTabWrites)) {
            await catchUpWithOtherTabs();
        }
        normalizedKey = tappedLineKey(normalizedKey);
        const item = getCartItemByKey(normalizedKey);
        if (!item) {
            return;
        }

        const current = displayedLineQuantity(normalizedKey);
        if (!Number.isFinite(current)) {
            return;
        }

        const step = getLineQtyStep(item);
        const direction = Number(delta) >= 0 ? 1 : -1;
        // At minimum (e.g. qty 3 for 90-day), minus is a no-op — remove via trash icon
        if (direction < 0 && current <= step) {
            return;
        }
        const target = nextSteppedQty(current, step, direction);
        await updateQuantity(normalizedKey, String(target), linkedKey);
    }
    window.changeLineQty = changeLineQty;

    // Quantity update functions
    async function updateQuantity(key, change, linkedKey = '') {
        const parsedQuantity = parseInt(change, 10);
        const normalizedQuantity = Number.isNaN(parsedQuantity) ? 0 : Math.max(parsedQuantity, 0);
        await applyCartUpdate(key, normalizedQuantity, linkedKey);
    }

    async function updateQuantityInput(key, newQuantity, linkedKey = '') {
        const qty = parseInt(newQuantity, 10);
        if (Number.isNaN(qty)) {
            return;
        }

        const item = getCartItemByKey(safeString(key));
        const qtyPerChange = item ? getLineQtyStep(item) : 1;
        // Stepped packs: ignore free-typed values — qty only changes via +/- buttons
        if (qtyPerChange && qtyPerChange > 1) {
            if (typeof event !== 'undefined' && event && event.target) {
                event.target.value = item.quantity;
            }
            return;
        }

        const normalizedQuantity = Math.max(qty, 0);

        if (normalizedQuantity === 0) {
            const dependentKeys = Array.isArray(crossSellLinkedKeys[key]) ? crossSellLinkedKeys[key] : [];
            if (dependentKeys.length > 0) {
                const productTitle = getCartItemTitleByKey(key) || '';
                openCrossSellRemovalModal(key, dependentKeys, productTitle);

                if (typeof event !== 'undefined' && event && event.target) {
                    const currentQuantity = getCartItemQuantityByKey(key) || 1;
                    event.target.value = currentQuantity;
                }

                return;
            }
        }

        await applyCartUpdate(key, normalizedQuantity, linkedKey);
    }

    // renderOptions: the options of the render pass this update replaces (a gift rule
    // inside updateCartDisplay). Only a pass that opts in with lightCorrections (the
    // bundle builder's first paint) keeps skipping upsells and recommendations; the
    // gift sync always runs. Everyone else gets the full render, as before.
    async function applyBulkCartUpdates(updateMap, renderOptions) {
        const normalizedUpdates = {};

        Object.entries(updateMap || {}).forEach(([rawKey, rawQuantity]) => {
            const normalizedKey = safeString(rawKey);
            if (!normalizedKey) {
                return;
            }

            const numericQuantity = Number(rawQuantity);
            const sanitizedQuantity = Number.isFinite(numericQuantity)
                ? Math.max(0, Math.trunc(numericQuantity))
                : 0;

            normalizedUpdates[normalizedKey] = sanitizedQuantity;
        });

        if (!Object.keys(normalizedUpdates).length) {
            return;
        }

        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates: normalizedUpdates })
        });

        const removalOnly = Object.keys(normalizedUpdates).every(function (key) { return normalizedUpdates[key] === 0; });
        let updatedCart = null;
        if (response.status === 422 && removalOnly && window.FDCartApi) {
            // Shopify answers 422 when every line to remove is already gone; a line still there means another failure.
            updatedCart = await window.FDCartApi.getCart(true);
            const stillThere = !updatedCart || !Array.isArray(updatedCart.items) || updatedCart.items.some(function (item) {
                return Object.prototype.hasOwnProperty.call(normalizedUpdates, item.key);
            });
            if (stillThere) throw new Error(`Bulk cart update failed with status ${response.status}`);
        } else if (!response.ok) {
            throw new Error(`Bulk cart update failed with status ${response.status}`);
        } else {
            updatedCart = await response.json();
        }
        const passOptions = {};
        if (renderOptions && renderOptions.lightCorrections) {
            ['skipUpsells', 'skipRecommendations'].forEach(function (flag) {
                if (renderOptions[flag]) passOptions[flag] = true;
            });
        }
        await updateCartDisplay(updatedCart, passOptions);
        if (typeof updateCartCount === 'function') {
            updateCartCount(updatedCart.item_count);
        }
    }

    async function applyCartUpdate(key, quantity, linkedKey = '') {
        const primaryKey = tappedLineKey(safeString(key));
        const normalizedLinkedKey = tappedLineKey(safeString(linkedKey).trim());
        const numericQuantity = Number(quantity);
        const payloadQuantity = Number.isFinite(numericQuantity)
            ? Math.max(0, Math.trunc(numericQuantity))
            : 0;
        const hasLinked = normalizedLinkedKey &&
            normalizedLinkedKey !== 'undefined' &&
            normalizedLinkedKey !== 'null' &&
            normalizedLinkedKey !== primaryKey;

        if (payloadQuantity === 0) {
            const dependentKeys = Array.isArray(crossSellLinkedKeys[primaryKey]) ? crossSellLinkedKeys[primaryKey] : [];
            if (dependentKeys.length > 0) {
                const productTitle = getCartItemTitleByKey(primaryKey) || '';
                openCrossSellRemovalModal(primaryKey, dependentKeys, productTitle);
                return;
            }
        }

        await requestLineQuantity(primaryKey, payloadQuantity, hasLinked ? normalizedLinkedKey : '');
    }

    // Remove item from cart
    async function removeItem(key) {
        const linkedKey = tryNowLinkedKeys[key] || '';
        await applyCartUpdate(key, 0, linkedKey);
    }

    // Warm the drawer's per-product lookups before the add (CART.md rule 9): on page
    // idle for the product page and its dialog upsells, and when the shopper points
    // at or presses a button of a product block. Capped, and cached for the session.
    const warmedCartProducts = new Set();
    const WARM_PRODUCT_LIMIT = 8;

    function warmCartProducts(ids) {
        const sf = window.Storefront;
        if (!sf || typeof sf.productCartMetaById !== 'function') return;
        (Array.isArray(ids) ? ids : [ids]).forEach(function (id) {
            const key = safeString(id).replace(/\D/g, '');
            if (!key || warmedCartProducts.has(key) || warmedCartProducts.size >= WARM_PRODUCT_LIMIT) return;
            warmedCartProducts.add(key);
            sf.productCartMetaById(key).catch(function () {});
        });
    }
    window.FDCartWarm = warmCartProducts;

    // Gift lines the cart's codes can add: their tags and cart metafields, fetched on
    // idle so the gift line paints without lookups once the threshold is crossed.
    const warmedGiftVariants = new Set();

    function warmGiftVariants(variantIds) {
        const sf = window.Storefront;
        if (!sf || typeof sf.productTagsByVariantIds !== 'function') return;
        const ids = (Array.isArray(variantIds) ? variantIds : [variantIds])
            .map(function (id) { return safeString(id).replace(/\D/g, ''); })
            .filter(function (id) { return id && !warmedGiftVariants.has(id); });
        if (!ids.length) return;
        ids.forEach(function (id) { warmedGiftVariants.add(id); });
        const run = function () {
            if (window.FDCartContext && typeof window.FDCartContext.warmPreorderText === 'function') {
                window.FDCartContext.warmPreorderText(ids);
            }
            sf.productTagsByVariantIds(ids).then(function (products) {
                products.forEach(function (product) {
                    rememberProductTags(product);
                    warmCartProducts([product.id]);
                });
            }).catch(function () {});
        };
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(run, { timeout: 2000 });
        else setTimeout(run, 300);
    }
    window.FDCartWarmGifts = warmGiftVariants;

    function warmPageProducts() {
        const ids = [];
        const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
        if (meta && meta.id) ids.push(meta.id);
        const upsellData = document.getElementById('PBFCM-upsell-products-data');
        if (upsellData) {
            try {
                (JSON.parse(upsellData.textContent) || []).slice(0, 4).forEach(function (product) {
                    if (product && product.id) ids.push(product.id);
                });
            } catch (error) {
                // no dialog upsells to warm
            }
        }
        warmCartProducts(ids);
    }

    function warmFromIntent(event) {
        const control = event.target && event.target.closest ? event.target.closest('button') : null;
        if (!control || control.closest('#main-nav')) return;
        const host = control.closest('[data-product-id]');
        if (host) warmCartProducts([host.getAttribute('data-product-id')]);
    }

    window.addEventListener('load', function () {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(warmPageProducts, { timeout: 4000 });
        } else {
            setTimeout(warmPageProducts, 1500);
        }
    });
    ['pointerover', 'pointerdown', 'focusin'].forEach(function (type) {
        document.addEventListener(type, warmFromIntent, { capture: true, passive: true });
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ensureCrossSellRemovalModal);
    } else {
        ensureCrossSellRemovalModal();
    }
